import type { BaseTranslation } from '../i18n-types';

const cs = {
	common: {
		actions: 'Akce',
		retry: 'Zkusit znovu',
		showMore: 'Zobrazit další',
		showLess: 'Skrýt další',
		loading: 'Načítání',
		search: 'Hledat',
		clean: 'Vymazat',
		today: 'Dnes',
		filter: 'Filtrovat',
		noData: 'Žádná data',
		noFilteredData: 'Žádná data neodpovídají zadaným filtrům',
		currency: 'Měna',
		dataLoadFailed: 'Data se nepodařilo načíst',
		date: 'Datum',
		dateFrom: 'Datum od',
		dateTo: 'Datum do',
		title: 'Název',
		status: 'Stav',
		error: 'Chyba',
		loadMore: 'Načíst další',
		amount: 'Částka',
		yes: 'Ano',
		no: 'Ne',
		unknown: 'Neznámý',
		continue: 'Pokračovat',
		cancel: 'Zrušit',
		confirm: 'Potvrdit',
		back: 'Zpět',
		download: 'Stáhnout',
		localeSwitcher: 'CZ',
		edit: 'Editovat',
		save: 'Uložit',
		saveChanges: 'Uložit změny',
		saveChangesAndClose: 'Uložit změny a zavřít',
		saveAndClose: 'Uložit a zavřít',
		select: 'Vybrat',
		close: 'Zavřít',
		delete: 'Smazat',
		remove: 'Odstranit',
		removeAndDelete: 'Odstranit a smazat',
		client: 'Klient',
		creationDate: 'Datum vytvoření',
		updatedDate: 'Datum poslední aktualizace',
		updatedAt: 'Poslední aktualizace',
		periodicity: 'Frekvence',
		periodicityMap: {
			daily: 'Denně',
			dailyShort: 'den',
			weekly: 'Týdně',
			weeklyShort: 'týd',
			monthly: 'Měsíčně',
			monthlyShort: 'měs',
			annually: 'Ročně',
			annuallyShort: 'rok',
			semiAnnually: 'Půlročně',
			semiAnnuallyShort: 'pol.',
			quarterly: 'Čtvrtletně',
			quarterlyShort: 'čtvrtletí',
			indefinite: 'Neurčitě',
		},
		cancelProcess: 'Zrušit proces',
		sortCode: 'Předčíslí',
		account: 'Účet',
		accountNumber: 'Číslo účtu',
		bankCode: 'Kód banky',
		invalidFormat: 'Neplatný formát',
		unexpectedApiError: 'Nastala neočekávaná chyba při komunikaci se servery',
		emptyCharacter: '-',
		forwardSlash: '/',
		clearAllFilters: 'Zrušit všechny filtry',
		from: 'Od',
		to: 'Do',
		tryAgain: 'Zkusit znovu',
		pid: 'PID',
		user: 'Uživatel',
		pageNotFound: {
			title: 'Stránka nenalezena',
			description:
				'Stránka, kterou hledáte, neexistuje. Zkontrolujte prosím Vaši URL adresu.',
		},
		genders: {
			male: 'Muž',
			female: 'Žena',
			unknown: 'Neznámé',
		},
		sendForApproval: 'Odeslat ke schválení',
		accountProductCodes: {
			accountProtected: 'Chráněný účet',
			currentAccountBasic: 'Běžný účet',
			currentAccountChild: 'Dětský běžný účet',
			currentAccountSecondary: 'Vedlejší běžný účet',
			currentAccountShared: 'Společný běžný účet',
			savingsAccountBasic: 'Spořicí účet',
			savingsAccountCashReserve: 'Spořicí rezerva',
			savingsAccountChild: 'Dětský spořicí účet',
			savingsAccountGoal: 'Spořicí cíl',
			savingsAccountGoalChild: 'Dětský spořicí cíl',
			savingsAccountShared: 'Společný spořicí účet',
			savingsGoalShared: 'Společný spořicí cíl',
			termDeposit: 'Termínovaný vklad',
		},
		placeholders: {
			select: 'Vyberte',
		},
		oneYear: 'rok',
		twoToFourYears: 'roky',
		years: 'let',
		dateCompose: {
			separator: ', ',
			year: '{0} {{let|rok|roky|roky|roky|let}}',
			month: '{0} {{měsíců|měsíc|měsíce|měsíce|měsíců|měsíců}}',
		},
		phone: {
			phonePrefix: 'Předvolba',
			phonePrefixSearch: 'Hledat předvolbu',
			phoneNumberWithoutPrefix: 'Telefonní číslo',
		},
		showClient: 'Zobrazit klienta',
		showAllClientRequests: 'Zobrazit všechny žádosti klienta',
		showAllClientActivations: 'Zobrazit všechny aktivace klienta',
		showAllClientVerifications: 'Zobrazit všechny ověření klienta',
		showAccountDetail: 'Zobrazit detail účtu',
		advancedSearch: {
			inputs: {
				lastName: 'Příjmení',
				firstName: 'Jméno',
				identityCardNumber: 'Číslo občanského průkazu',
				birthNumber: 'Rodné číslo',
				birthday: 'Datum narození',
				email: 'Email',
				pidUuid: 'PID',
			},
		},
		additionalData: 'Dodatečné údaje',
		descriptiveNumber: ' č.p. {houseNumber: string}',
		registrationNumber: ' č.ev. {evidenceNumber: string}',
		errors: {
			unknownTechnicalError: 'Neznámá technická chyba',
			foundErrors: 'Nalezené chyby',
		},
		actionButton: 'Akce',
		create: 'Vytvořit',
		type: 'Typ',
		content: 'Obsah',
		send: 'Odeslat',
		update: 'Aktualizovat',
		documentType: {
			idCard: 'Občanský průkaz',
			passport: 'Cestovní pas',
		},
		functionUnderDevelopment: 'Funkčnost je ve vývoji',
		noContent: 'Žádný obsah',
		pan: 'Číslo karty',
		email: 'E-mail',
		pidUuid: 'PID klienta',
		currencyPlural: {
			single: 'měnová složka',
			few: 'měnové složky',
			plural: 'měnových složek',
		},
		charactersPlural: {
			single: 'znak',
			few: 'znaky',
			plural: 'znaků',
		},
		companies: {
			partners: 'Partners',
		},
		advisorRoleRefresh: {
			dialogTitle: 'Aktualizovat práva na klienta',
			rightsCouldNotBeUpdated: 'Práva se nepodařilo aktualizovat',
			rightsUpdated: 'Práva aktualizována',
			unableToUpdateRightsUsingTheGivenDocument:
				'Pomocí daného dokladu se nepodařilo práva aktualizovat',
			dialogDescription:
				'Stáhne aktuální nastavení práv na klientem z PFS a aktualizuje přístupy v Dashboardu.',
			searchClientByPid: 'Vyhledat klienta podle PIDu',
			searchClientByDocument: 'Vyhledat klienta podle dokladu',
			documentNumber: 'Číslo dokladu',
			documentCountry: 'Země vydání dokladu',
			documentType: 'Typ dokladu',
		},
		notSpecified: 'Neuvedeno',
		noKeep: 'Ne, ponechat',
		yesProceed: 'Ano, {action: string}',
		noDocuments: 'Žádné dokumenty',
	},
	authGuard: {
		dataNotAccessible:
			'Požadavek nelze realizovat. Kontaktujte servisní podporu banky.',
	},
	loginPage: {
		companyName: 'Partners',
		productName: 'Back Office',
		login: 'Přihlášení',
		description:
			'Pro přihlášení použijte aplikaci Partners ve svém mobilním telefonu nebo svůj Microsoft účet.',
		timer: 'Platnost kódu vyprší za {seconds: string}',
		timerExpired:
			'Platnost QR kódu vypršela! Pro obnovení platnosti QR kódu načtěte prosím stránku znovu.',
		refreshQrCode: 'Obnovit platnost QR kódu',
		microsoftLogin: 'Přihlášení Microsoft účtem',
		fipLocalLogin: 'FIP přihlášení',
		e2eLogin: 'E2E přihlášení',
		failedToGenerateQrCode: 'QR kód se nepodařilo vygenerovat',
		insufficientRightsDialog: {
			title: 'Chybějící oprávnění',
			description:
				'Nemáte dostatečná oprávnění pro přístup do aplikace. Pokud přístup potřebujete, obraťte se na svého nadřízeného.',
			confirmationButton: 'OK',
		},
	},
	notFoundPage: {
		title: 'Tato stránka neexistuje',
	},
	appLayout: {
		searchClient: 'Hledat klienta',
		searchTerminHint: 'Jméno, email, datum narození',
		noClientFound: 'Žádný klient nenalezen',
		lastSeenClients: 'Posledně zobrazení klienti',
		logout: 'Odhlásit se',
		profileMenu: {
			profile: 'Profil',
			serviceSettings: 'Nastavení služeb',
			logout: 'Odhlásit',
		},
		fipFooter: {
			infoLineForAdvisors: 'Infolinka pro poradce:',
			infoLineHours: '(Po až Pá 8-20h)',
			emailSupport: 'Emailová podpora:',
		},
		advancedClientSearch: {
			label: 'Rozšířené vyhledávání',
			tabs: {
				client: 'Klient',
				account: 'Účet',
			},
			accountSearch: {
				inputLabel: 'Číslo',
				inputPlaceholder: 'Hledat podle čísla účtu, ID účtu nebo IBANu ...',
			},
		},
	},
	securedRouterLayout: {
		tokenExpiredDialog: {
			title: 'Jste odhlášeni',
			descriptionBank:
				'Došlo k neočekávanému odhlášení z aplikace nebo jste se snažili načíst stránku bez předešlého přihlášení.',
			descriptionFip:
				'Došlo k neočekávanému odhlášení z aplikace. Pro opětovné přihlášení znovu načtěte FIP a stránku s Dashboardem.',
			login: 'Přihlásit se',
		},
	},
	fipSideNavigationComponent: {
		home: 'Domů',
		clientSelect: 'Výběr klienta',
	},
	fipHomePage: {
		pageTitle: 'Co společně řešíme',
		nothingThatNeedsYourAttention: 'Nic, co by potřebovalo vaši pozornost',
		missingCertification: {
			bankAndLoan: {
				title: 'Nemáte platnou bankovní a úvěrovou certifikaci.',
				description:
					'U klientů banky tak nebudete mít dostupná bankovní data. Pro přístup na požadovaná data si doplňte chybějící certifikaci u Partners Financial Services.',
			},
			loan: {
				title: 'Nemáte platnou úvěrovou certifikaci.',
				description:
					'U klientů banky tak nebudete mít dostupná data o úvěrech. Pro přístup na požadovaná data si doplňte chybějící certifikaci u Partners Financial Services.',
			},
			bank: {
				title: 'Nemáte platnou bankovní certifikaci.',
				description:
					'U klientů banky tak nebudete mít dostupná bankovní data. Pro přístup na požadovaná data si doplňte chybějící certifikaci u Partners Financial Services.',
			},
		},
	},
	fipClientSelectPage: {
		pageTitle: 'Výběr klienta',
		noFoundOtherPossibleReasonsBtn: 'Další možné důvody',
		noFoundOtherPossibleReasons: {
			dialogTitle: 'Možné důvody nenalezení klienta',
			noAccessToClient: {
				title: 'Nemáte přístup na klienta',
				description:
					'Vyhledávat můžete pouze klienty, na které máte přístup v rámci FIPu. Pokud klienta ve FIPu nevyhledáte, nenaleznete ho ani v Dashboardu.',
			},
			missingRoleForClient: {
				title: 'Nemáte potřebnou roli ve vztahu ke klientovi',
				description:
					'Pokud klienta ve FIPu vyhledáte, pro zobrazení v Dashboardu navíc rozhoduje role, kterou máte ve vztahu ke klientovi přidělenou (např. Opatrovník). Poradci s rolí Správce, Opatrovník, Kompletní sdílení, Sdílení na zakázku nebo Bublina mají přístup na klienta povolen. Poradci s rolí Struktura ho pak mají zakázaný.',
			},
			dataNotUpdated: {
				title: 'Nejsou aktualizovaná data z FIPu',
				description:
					'Zpřístupnili jste si v průběhu dne klienta ve FIPu, ale nemůžete ho vyhledat v Dashboardu? Pravděpodobně nejsou ještě aktuální data z FIPu nahrána do Dashboardu (aktualizují se jednou denně). Pokud potřebujete klienta zpřístupnit hned, aktualizujte si manuálně práva na klienta na stránce „Výběr klienta“ pomocí funkce “Akce” – “Aktualizovat práva na klienta”.',
			},
			stillNotFound: {
				description:
					'Jste poradce s rolí Správce nebo Opatrovník na konkrétního klienta a nemůžete ho přesto vyhledat, obraťte se na podporu.',
			},
		},
	},
	clientLayout: {
		riskProfile: {
			medium: 'Rizikový profil: střední',
			high: 'Rizikový profil: vysoký',
			unacceptable: 'Rizikový profil: neakceptovatelný',
		},
		pep: 'PEP',
		withoutGroupConsent: 'Nemá skupinový souhlas',
		invalidPersonalData: 'Chybné osobní údaje',
		employee: 'Zaměstnanec',
		deathClient: 'Klient zemřel',
		advisor: 'Opatrovník:',
		notAssigned: 'Nepřidělen',
		advisorId: 'ID',
		contacts: 'Kontakty',
		advisorResidence: 'Sídlo poradce',
		viewReasonDialog: {
			title: 'Klient je zaměstnanec',
			explanation:
				'Upřesněte důvod náhledu na klienta, který je zaměstnancem skupiny Partners.',
			reasonLabel: 'Důvod',
			noteLabel: 'Poznámka',
			reasons: {
				clientService: 'Obsluha klienta ',
				cooperationWithAuthorities: 'Součinnost s úřady',
				amlOrFraud: 'AML / Podvod',
				internalControlOrAudit: 'Vnitřní kontrola / Audit',
				issueOrIncident: 'Řešení problému / incidentu',
				other: 'Jiný',
			},
		},
		doNotHavePermissionsToSeeClientDialog: {
			title: 'Chybějící práva',
			explanation:
				'Nemáte dostatečná práva na zobrazení klienta. Pokud přístup potřebujete, kontaktujte helpdesk.',
		},
		nationalNumber: {
			shortcuts: {
				birthNumber: 'r.č.:',
				insuranceNumber: 'č.p.:',
			},
			tooltips: {
				birthNumber: 'Rodné číslo',
				insuranceNumber: 'Číslo pojištění',
				unknown: 'Neznámý typ národního identifikátoru',
				unspecified: 'Neurčitý typ národního identifikátoru',
				nationalIdentifier: 'Národní identifikátor',
			},
		},
		tooltips: {
			email: 'E-mail',
			permanentAddress: 'Trvalá adresa',
			phoneNumber: 'Mobilní telefon',
		},
		bankIdEventType: {
			login: 'Přihlášení',
			userInfo: 'Informace o uživateli',
			profile: 'Identifikace osoby',
			sign: 'Podpis dokumentu',
			notification: 'Notifikace',
			consentedScopes: 'Udělené souhlasy',
			noEventTypeChosen: 'Žádný typ události',
			all: 'Všechny',
		},
	},
	clientOverviewPage: {
		title: 'Přehled',
		notifications: 'Upozornění',
		lastEventsTile: {
			title: 'Poslední události',
			noEvents: 'Žádné události',
			moreEvents: 'Další události',
			failedToLoadEvents: 'Události se nepodařilo načíst',
		},
		mobileAppTile: {
			title: 'Aplikace',
			noApplications: 'Žádné platné aktivace',
			lastUsage: 'Poslední použití: {lastUsageDate: string}',
			moreActivations: 'Další aktivace',
			failedToLoadActivations: 'Aktivace se nepodařilo načíst',
		},
		packageTile: {
			title: 'Balíček',
			packagePricePerMonth: '{price: string}/měs',
			noPackage: 'Žádný balíček',
			morePackages: 'Další balíčky',
			failedToLoadPackages: 'Balíčky se nepodařilo načíst',
			clientRole: 'Role klienta: {role: string}',
		},
		accountsTile: {
			title: 'Účty',
			noAccounts: 'Žádné aktivní účty',
			moreAccounts: 'Další účty',
			failedToLoadAccounts: 'Účty se nepodařilo načíst',
			multiCurrencyIndicator: '{baseTitle: string} (MM)',
		},
		cardsTile: {
			title: 'Karty',
			noCards: 'Žádné aktivní karty',
			moreCards: 'Další karty',
			failedToLoadCards: 'Karty se nepodařilo načíst',
		},
		loansTile: {
			title: 'Úvěry',
			noLoans: 'Žádné aktivní úvěry',
			moreLoans: 'Další úvěry',
			failedToLoadLoans: 'Úvěry se nepodařilo načíst',
		},
		notificationTile: {
			noData: 'Žádná upozornění',
			failedToLoadNotifications: 'Upozornění se nepodařilo načíst',
			header: {
				failedToLoadSomeNotifications: 'Část upozornění se nepodařilo načíst',
			},
			dialog: {
				dialogTitle: 'Upozornění',
			},
			nextNotifications: 'Další upozornění',
			notifications: {
				clientDataEmailMissing: {
					title: 'Chybějící email',
					text: 'Klient nemá evidovaný email',
				},
				clientDataPhoneMissing: {
					title: 'Chybějící telefon',
					text: 'Klient nemá evidovaný telefon',
				},
				clientDataPermanentAddressMissing: {
					title: 'Chybějící trvalá adresa',
					text: 'Klient nemá evidovanou trvalou adresu',
				},
				clientApplicationsBlocked: {
					title: 'Zablokovaná aplikace',
					text: 'Klient má zablokované všechny platné aktivace aplikace',
				},
				clientBankIdentityBlocked: {
					title: 'Zablokovaná bankovní identita',
					text: 'Klient má zablokované používání bankovní identity',
				},
				clientPidBlocked: {
					title: 'Klient je zablokovaný jako "podezřelý"',
					text: 'Klient má blokovanou identitu, všechny aktivace aplikace, budoucí aktivace aplikace a bankovní identitu.',
				},
				clientNewActivationsBlocked: {
					title: 'Zablokované budoucí aktivace aplikace',
					text: 'Klient neprovede další aktivaci aplikace na žádném zařízení',
				},
				clientAccountsInDebet: {
					single: {
						title: 'Účet v debetu',
						text: 'Účet {accountNumber: string} je v debetu {amount: string}',
						textMultipleCurrencies:
							'Účet {accountNumber: string} a {currencyCount: number} {currencyCountPlural: string} v debetu',
					},
					few: {
						title: 'Účty v debetu',
						text: '{count: number} účty v debetu v celkové výši {amount: string}',
						textMultipleCurrencies:
							'{count: number} účty a {currencyCount: number} {currencyCountPlural: string} v debetu',
					},
					multiple: {
						title: 'Účty v debetu',
						text: '{count: number} účtů v debetu v celkové výši {amount: string}',
						textMultipleCurrencies:
							'{count: number} účtů a {currencyCount: number} {currencyCountPlural: string} v debetu',
					},
				},
				clientAccountsWithExecution: {
					single: {
						title: 'Exekuce',
						text: 'Na účtu {iban: string} je vedena exekuce ve výši {amount: string}',
					},
					multiple: {
						title: 'Exekuce',
						text: 'Na {count: number} účtech jsou vedeny exekuce v celkové výši {amount: string}',
					},
				},
				clientAccountsInTermination: {
					single: {
						title: 'Zrušení účtu',
						text: 'Účet {iban: string} je v procesu rušení',
					},
					few: {
						title: 'Zrušení účtů',
						text: '{count: number} účty jsou v procesu rušení',
					},
					multiple: {
						title: 'Zrušení účtů',
						text: '{count: number} účtů je v procesu rušení',
					},
				},
				clientAccountsBlocked: {
					single: {
						title: 'Zablokovaný účet',
						text: 'Účet {iban: string} je zablokovaný',
					},
					few: {
						title: 'Zablokované účty',
						text: '{count: number} účty jsou zablokované',
					},
					multiple: {
						title: 'Zablokované účty',
						text: '{count: number} účtů je zablokovaných',
					},
				},
				clientAccountsTermDepositWaitingForPayment: {
					title: 'Termínovaný vklad není aktivní',
					text: 'Na účet {iban: string} zatím nedorazila počáteční platba',
				},
				clientCardsBlocked: {
					single: {
						title: 'Zablokovaná nebo neaktivní karta',
						text: 'Kartu {pan: string} není možné použít k placení',
					},
					few: {
						title: 'Zablokované nebo neaktivní karty',
						text: '{count: number} karty není možné použít k placení',
					},
					multiple: {
						title: 'Zablokované nebo neaktivní karty',
						text: '{count: number} karet není možné použít k placení',
					},
				},
				clientMobilityProcessingFailed: {
					single: {
						title: 'Zaseknutá mobilita',
						text: 'Mobilita na účtu {selectedAccountIban: string} (k {mobilityDate: string}) se nezpracovává',
					},
					few: {
						title: 'Zaseknuté mobility',
						text: '{count: number} mobility {formattedAccountsText: string} se nezpracovávají',
					},
					multiple: {
						title: 'Zaseknuté mobility',
						text: '{count: number} mobilit {formattedAccountsText: string} se nezpracovává',
					},
				},
				clientMobilityWaitingForSignature: {
					single: {
						title: 'Mobilita čeká na schválení klientem',
						text: 'Mobilita na účtu {selectedAccountIban: string} (k {mobilityDate: string}) čeká v mobilní aplikaci na podpis',
					},
					few: {
						title: 'Mobility čekají na schválení klientem',
						text: '{count: number} mobility {formattedAccountsText: string} čekají v mobilní aplikaci na podpis',
					},
					multiple: {
						title: 'Mobility čekají na schválení klientem',
						text: '{count: number} mobilit {formattedAccountsText: string} čeká v mobilní aplikaci na podpis',
					},
				},
				clientMobilityProcessingFailedOrWaitingForSignature: {
					accounts: {
						single: 'na účtu {accountsText: string}',
						multiple: 'na účtech {accountsText: string}',
					},
				},
			},
		},
		pfsOnboardingApplicationsTile: {
			title: 'Onboarding z PFS',
			onboardingApplicationName: 'Žádost o "{productName: string}"',
			noOnboardingApplications: 'Žádné rozpracované žádosti',
			moreOnboardingApplications: 'Další žádosti',
			failedToLoadOnboardingApplications: 'Žádosti se nepodařilo načíst',
		},
		actions: {
			verifyClientForRemoteService: 'Ověřit vzdáleně totožnost klienta',
		},
	},
	clientEventsPage: {
		title: 'Události',
		solver: 'Řešitel',
		noEventDetail: 'Žádný detail události',
		eventTypes: {
			login: 'Přihlášení do aplikace',
			logout: 'Odhlášení z aplikace',
			appActivation: 'Aktivace aplikace',
			notificationSettings: 'Změna nastavení notifikací',
			unknown: 'Neznámá událost',
		},
		eventStates: {
			initiated: 'Spuštěna',
			completed: 'Dokončena',
			cancelled: 'Zrušena',
			failed: 'Selhala',
			stepCompleted: 'Krok dokončen',
			taskFailed: 'Úkol selhal',
			taskSuccess: 'Úkol úspěšný',
			allTasksFinished: 'Všechny úkoly dokončeny',
		},
		eventProperties: {
			deviceModel: 'Model zařízení',
			deviceId: 'ID zařízení',
			deviceType: 'Typ zařízení',
			deviceOs: 'Operační systém zařízení',
			appVersion: 'Verze Partners aplikace',
		},
		taskTypes: {
			cancelProcess: 'Storno procesu',
			commitActivation: 'Potvrzení aktivace',
			commitUser: 'Potvrzení klientem',
			completeProcess: 'Dokončení procesu',
			createActivation: 'Vytvoření aktivace',
			createProcess: 'Vytvoření procesu',
			expireProcess: 'Expirace procesu',
			importUser: 'Nahrání klienta',
			initializeActivation: 'Iniciace aktivace',
			initiateIdentityVerification: 'Iniciace verifikace totožnosti',
			initiateUserUpsert: 'Iniciace nahrání klienta',
			prepareDocumentsToSign: 'Příprava dokumentů k podpisu',
			processIdentityVerification: 'Ověření identity',
			processSignedDocuments: 'Podpis dokumentů',
			processUserUpsert: 'Nahrání klienta',
			resetDocumentsToSign: 'Restart přípravy dokumentů k podpisu',
			resetIdentityVerification: 'Restart ověření identity',
			resetUserUpsert: 'Restart nahrání klienta',
			verifyIdentity: 'Ověření identity',
		},
		labels: {
			step: 'Krok:',
			separator: ' · ',
			deviceName: 'Název zařízení',
			phoneNumber: 'Telefon',
			activationId: 'ID aktivace',
			notificationsEnabled: 'Notifikace povoleny',
			notificationsForPayments: 'Notifikace pro platby',
			marketingCommunication: 'Marketingová komunikace',
			eventId: 'Identifikátor události',
			error: 'Chyba',
		},
	},
	clientEventsNewPage: {
		title: 'Události - new',
		noEvents: 'Žádné události',
		failedToLoadEvents: 'Události se nepodařilo načíst',
		failedToLoadScope: 'Data se nepodařilo načíst',
		infoText: 'Počet nalezených událostí: {eventsAmount:number}',
		table: {
			header: {
				status: 'Stav',
			},
		},
		status: {
			success: 'Dokončena',
			failed: 'Selhala',
		},
		communicationDetail: {
			sentCommunication: 'Odeslaný text',
		},
	},
	clientDetailPage: {
		title: 'Klientské údaje',
		buttons: {
			change: 'Změnit',
			historyOfChanges: 'Historie změn',
			addToBlacklist: 'Přidat na blacklist',
			removeFromBlacklist: 'Odebrat z blacklistu',
		},
		createdAt: 'Datum změny',
		carriedOutBy: 'Provedl',
		advancedDataPreview: 'Rozšířený náhled',
		personalData: 'Osobní údaje',
		basicData: 'Základní údaje',
		nationalIdentifiers: 'Národní identifikátory',
		nationalIdentifierNumber: 'Číslo',
		countryOfIssue: 'Země vydání',
		phone: 'Telefon',
		aml: 'AML',
		additionalData: 'Dodatečné údaje',
		contactData: 'Kontaktní údaje',
		permanentAddress: 'Trvalá adresa',
		contactAddress: 'Korespondenční adresa',
		unknownAddress: 'Adresa (neznámý typ)',
		firstName: 'Jméno',
		lastName: 'Příjmení',
		middleName: 'Prostřední jméno',
		birthDate: 'Datum narození',
		birthLocation: 'Místo narození',
		gender: 'Pohlaví',
		nationality: 'Občanství',
		titlePrefix: 'Titul před jménem',
		titleSuffix: 'Titul za jménem',
		legalCapacity: 'Způsobilost k právním úkonům',
		legalAge: 'Plnoletost',
		dateOfDeath: 'Datum úmrtí',
		additionalNationalities: 'Dodatečná občanství',
		phoneNumber: 'Mobilní telefon',
		phoneNumberPrimary: 'Mobilní telefon (primární)',
		email: 'E-mail',
		emailPrimary: 'E-mail (primární)',
		changeEmailDialog: {
			snackbar: {
				emailChangedSuccessfully: 'Email byl změněn',
				emailsChangedSuccessfully: 'Emaily byly změněny',
				emailsChangeFailedPartially: 'Jeden z emailů se nepodařilo změnit',
				emailsChangeFailed: 'Emaily se nepodařilo změnit',
				emailChangeFailed: 'Email se nepodařilo změnit',
			},
			title: 'Změnit e-mail',
		},
		changeNameDialog: {
			snackbar: {
				success: 'Jméno bylo změněno',
				failed: 'Jméno se nepodařilo změnit',
			},
			title: 'Změnit jméno a příjmení',
		},
		changePhoneDialog: {
			snackbar: {
				phoneChangedSuccessfully: 'Telefon byl změněn',
				phonesChangedSuccessfully: 'Telefony byly změněny',
				phonesChangeFailedPartially: 'Jeden z telefonů se nepodařilo změnit',
				phonesChangeFailed: 'Telefony se nepodařilo změnit',
				phoneChangeFailed: 'Telefon se nepodařilo změnit',
			},
			title: 'Změnit telefon',
		},
		changeNationalIdentifierDialog: {
			snackbar: {
				success: 'Národní identifikátor byl změněn',
				failed: 'Národní identifikátor se nepodařilo změnit',
			},
			title: 'Změnit národní identifikátor',
			labels: {
				type: 'Typ',
			},
		},
		changeAddressDialog: {
			searchAddress: 'Hledat adresu',
			noAddressFound: 'Žádná adresa nenalezena',
			snackbar: {
				success: 'Adresa byla změněna',
				failed: 'Adresu se nepodařilo změnit',
			},
			titles: {
				permanentResidence: 'Změnit trvalou adresu',
				contactResidence: 'Změnit korespondenční adresu',
				unknown: 'Změnit adresu',
			},
			tabs: {
				addressInCzechRepublic: 'Adresa v České republice',
				addressOutsideCzechRepublic: 'Adresa mimo Českou republiku',
			},
		},
		deleteAddressDialog: {
			title: 'Smazat adresu?',
			descriptions: {
				permanentResidence:
					'Trvalá adresa klienta bude smazána. Tuto akci nelze vrátit.',
				contactResidence:
					'Korespondenční adresa klienta bude smazána. Tuto akci nelze vrátit.',
				unknown: 'Adresa klienta bude smazána. Tuto akci nelze vrátit.',
			},
			snackbar: {
				success: 'Adresa byla smazána',
				failed: 'Adresu se nepodařilo smazat',
			},
		},
		changeIdCardDialog: {
			title: 'Změnit doklad',
			number: 'Číslo',
			type: 'Typ',
			issuerCountry: 'Země vydání',
			snackbar: {
				success: 'Doklad změněn',
				failed: 'Doklad se nepodařilo změnit',
			},
		},
		deleteIdCardDialog: {
			title: 'Smazat doklad?',
			description:
				'Opravdu chcete smazat doklad "{documentType: string} {number: string}", země vydání "{country: string}"?',
			snackbar: {
				success: 'Doklad smazán',
				failed: 'Doklad se nepodařilo smazat',
			},
		},
		addresses: 'Adresy',
		address: {
			city: 'Město',
			cityPart: 'Městská část',
			country: 'Země',
			evidenceNumber: 'Číslo evidenční',
			houseNumber: 'Číslo popisné',
			street: 'Ulice',
			streetNumber: 'Číslo orientační',
			zipCode: 'PSČ',
		},
		documents: 'Doklady',
		identityDocumentTypes: {
			bc: 'Rodný list',
			ca: 'Cestovní průkaz (dočasný)',
			dl: 'Řidičský průkaz',
			id: 'Občanský průkaz',
			ie: 'Potvrzení o přechodném pobytu',
			ir: 'Povolení k pobytu (plastová karta)',
			ix: 'Povolení k pobytu (knížka)',
			op: 'Občanský průkaz (bez čipu)',
			p: 'Pas',
			ps: 'Rezidenční štítek',
			unknown: 'Neznámý typ dokladu',
			vs: 'Vízum',
		},
		documentNumber: 'Číslo dokladu',
		issuer: 'Vydal',
		issuerCountry: 'Země vydání',
		issueDate: 'Datum vydání',
		validTo: 'Platnost do',
		clientData: 'Klientské údaje',
		taxDomicile: 'Daňová rezidence',
		FATCA: 'FATCA',
		politicallyExposedPerson: 'Politicky exponovaná osoba',
		clientCreationDay: 'Datum založení klienta',
		consents: 'Souhlasy',
		consentTypes: {
			gdprConsent: 'Skupinový marketingový souhlas',
			mobileAppTermsAndConditionsConsent: 'Podmínky používání mobilní aplikace',
			thirdParties: 'Souhlas - třetí strany',
			childOnboardingMandate: 'Mandát pro onboarding dítěte',
			unknown: 'Neznámý',
		},
		notGranted: 'Neudělen',
		granted: 'Udělen',
		revoked: 'Odvolán',
		relatedPeople: 'Spjaté osoby',
		relationshipTypes: {
			employeeGuardianOf: 'Opatrovaný zaměstnanec',
			guardedBy: 'Opatrovník',
			guardedByEmployee: 'Zaměstnanec opatrovníka',
			guardianOf: 'Opatrovaný',
			childToParent: 'Rodič',
			legalRepresentativeOf: 'Zastupovaný',
			legalRepresentedBy: 'Zákonný zástupce',
			loaEmpoweredBy: 'Zmocnitel',
			loaEmpoweringWho: 'Zmocněnec',
			parentToChild: 'Dítě',
			unknown: 'Neznámý',
		},
		documentProvingRelationship: 'Dokument prokazující vazbu k {name: string}',
		child: 'Dítě',
		parent: 'Rodič',
		anotherPerson: 'Další osoba',
		doNotHavePermissionsToToViewPerson:
			'Na zobrazení osoby nemáte dostatečné oprávnění',
		identityConsent: 'Souhlas s identitou',
		marketingConsent: 'Skupinový marketingový souhlas',
		mobileAppTermsAndConditionsConsent:
			'Souhlas s podmínkami použití mobilní aplikace',
		maritalStatus: 'Rodinný stav',
		maritalStatuses: {
			cohabitation: 'Soužití',
			married: 'Ženatý/vdaná',
			divorced: 'Rozvedený/á',
			registeredPartnership: 'Registrované partnerství',
			registeredPartnershipCancelled: 'Registrované partnerství zrušeno',
			registeredPartnershipWidowed: 'Zaniklé partnerství smrtí',
			widowed: 'Ovdovělý/á',
			single: 'Svobodný/á',
			unknown: 'Neznámý',
			partnership: 'Partnerství',
			partnershipCanceled: 'Zrušené partnerství',
			lapsedMarriage: 'Zaniklé manželství',
			separated: 'Odloučení',
		},
		riskProfile: 'Rizikový profil',
		riskProfiles: {
			high: 'Vysoký',
			low: 'Nízký',
			medium: 'Střední',
			unacceptable: 'Neakceptovatelný',
			unknown: 'Neznámý',
		},
		regularSourceOfIncome: 'Pravidelný zdroj příjmu',
		regularSourceOfIncomes: {
			alimony: 'Výživné',
			agreement: 'Pracovní smlouva',
			businessActivities: 'Podnikatelské činnosti',
			capitalProperty: 'Příjem z kapitálových aktiv',
			dividends: 'Příjem z dividend',
			occupation: 'Hlavní zaměstnání',
			occupationBrutto: 'Hlavní zaměstnání - brutto',
			parentalLeave: 'Mateřská, rodičovská',
			partnerProfit: 'Příjem z partnerství',
			partTime: 'Vedlejší zaměstnání',
			partTimeBrutto: 'Vedlejší zaměstnání - brutto',
			pension: 'Důchod',
			prize: 'Výhra',
			recurringBonuses: 'Pravidelné bonusy',
			rent: 'Příjem z pronájmu',
			selfEmployment: 'Samostatně výdělečně činný',
			selfEmploymentBrutto: 'Samostatně výdělečně činný - brutto',
			socialBenefits: 'Sociální příspěvek',
			unknown: 'Neznámý',
		},
		irregularSourceOfIncome: 'Nepravidelný zdroj příjmu',
		irregularSourceOfIncomes: {
			unknown: 'Neznámý',
			unknownSimpleaIrregular: 'Neznámý příjem Simplea',
			companyShareSale: 'Příjem z prodeje společnosti/akcií',
			realEstateSale: 'Příjem z prodeje nemovitosti',
			movableItemSale: 'Příjem z prodeje movitého majetku',
			gift: 'Dar',
			heritage: 'Dědictví',
			prize: 'Cena (např. loterie)',
			loanFromFinancialInstitution: 'Úvěr od finanční instituce',
			loanOther: 'Úvěr od nefinanční instituce',
			personalSavings: 'Osobní úspory',
			investmentProductsIncome: 'Příjem z investičních produktů',
			otherIncome: 'Jiný příjem',
		},
		incomeInformationDialog: {
			buttonText: 'Zobrazit informace o příjmech',
			title: 'Příjmy klienta',
			totalIncome: 'Celkové příjmy',
			regularIncomeSectionTitle: 'Pravidelné příjmy',
			irregularIncomeSectionTitle: 'Nepravidelné příjmy',
			sum: 'Celkem',
		},
		companyIds: {
			bank: 'Partners Banka, a.s.',
			bankEmployee: 'Zaměstnanec Partners Banky (skupina)',
			mobApp: 'Partners Banka, a.s. (mobilní aplikace)',
			mobAppPar: 'Partners Banka, a.s. (mobilní aplikace)',
			mobAppSfs: 'Simplea Financial Services, a.s. SK (mobilní aplikace)',
			mobAppSk: 'Simplea Financial Services, a.s. (mobilní aplikace SK)',
			mobAppWlb: 'Whitelabel (mobilní aplikace)',
			pfs: 'Partners Financial Services, a.s.',
			pfsConsultant: 'Poradce Partners (skupina)',
			rentea: 'Rentea penzijní společnost, a.s.',
			sfs: 'Simplea Financial Services, a.s. (SK)',
			simplea: 'Simplea pojišťovna, a.s',
			simpleaSk: 'Simplea pojišťovna, a.s. (SK)',
			unknown: 'Neznámý',
			group: 'Skupina Partners, a.s.',
			loan: 'Úvěry Partners Banky (skupina)',
			nonbank: 'Nebanka',
			ocp: 'Partners OCP',
			gepard: 'Gepard',
			vub: 'VUB',
		},
		clientFrom: 'Klientem od',
		clientTo: 'Klientem do',
		companies: 'Společnosti',
		clientNotManagedByAnyCompany:
			'Klient není aktuálně klientem žádné společnosti',
		trustLevel: {
			unverified: 'Neověřený údaj',
			blocked: 'Neplatný údaj',
		},
		failedToLoadHistoryOfChangesData: 'Nepodařilo se načíst data',
		noData: {
			noBasicInfo: 'Žádné základní údaje',
			noAdditionalData: 'Žádné dodatečné údaje',
			noAddresses: 'Žádné adresy',
			noDocuments: 'Žádné doklady',
			noClientAmlData: 'Žádné AML údaje',
			noConsentAgreements: 'Žádné souhlasy',
			noRelationshipPeople: 'Žádné spjaté osoby',
			noNationalIdentifier: 'Žádný národní identifikátor',
			noHistoryOfChanges: 'Žádná historie změn',
		},
		verificationType: 'Způsob ověření',
		verificationTypes: {
			unknown: 'Neznámý',
			machine: 'Systém',
			amlOfficer: 'AML',
			bankId: 'Bank iD',
			client: 'Klient',
			consultantFaceToFace: 'Poradce (osobně)',
			consultantRemote: 'Poradce (vzdáleně)',
			consultantEdoklad: 'Poradce (eDokladem)',
			backofficeUser: 'Uživatel backoffice',
			szr: 'Základní registry',
		},
		sourceClient: {
			unknown: 'Neznámý',
			nonBank: 'Nebanka',
			bank: 'Partners Banka',
			bankEmployee: 'Partners Banka - zaměstnanec',
			bankLoanProspect: 'Partners Banka - žadatel o úvěr',
			bankTest: 'Partners Banka TEST',
			pfs: 'Partners Financial Services',
			pfsConsultant: 'Poradce PFS',
			pid: 'PID',
			pidTest: 'PID TEST',
			rentea: 'Rentea',
			sfs: 'Simplea Financial Services (SK)',
			simplea: 'Simplea',
			simpleaSk: 'Simple (SK)',
			mobApp: 'Partners Banka - mobilní aplikace',
			mobAppSk: 'Partners Banka - mobilní aplikace (SK)',
			ocp: 'OCP',
			gepard: 'Gepard',
			orfeus: 'Orfeus',
			orfeusSk: 'Orfeus (SVK)',
			vub: 'VUB',
		},
		nationalIdentifierTypes: {
			options: {
				unknown: 'Neznámý',
				birthNumber: 'Rodné číslo',
				insuranceNumber: 'Číslo pojištění',
				unspecified: 'Neurčitý',
			},
			labels: {
				unknown: 'Neznámý',
				birthNumber: 'Rodné číslo',
				insuranceNumber: 'Číslo pojištění',
				unspecified: 'Číslo',
			},
		},
		verificationInvestigations: {
			historyOfDocumentCopiesMade: 'Historie pořízených kopií dokladů',
			noData: 'Žádná historie pořízených kopií dokladů',
			investigationId: 'Scan (Zen iD)',
		},
		statusOfDataVerificationDialog: {
			title: 'Ověření údajů v základních registrech',
			noVerifications: 'Žádné ověření',
			columns: {
				company: 'Společnost',
				status: 'Stav',
				statusChangedAt: 'Poslední změna stavu',
				companyClientFrom: 'Klientem od {date:string}',
				companyClientTo: 'do {date:string}',
			},
			labels: {
				aifo: 'AIFO',
			},
			aisStatus: {
				unrated: 'Neověřeny',
				notForAisIdentification: 'Nebudou ověřovány',
				aisProcessing: 'Probíhá ověřování',
				aisIdentified: 'Ověřování dokončeno',
				aisUpdated: 'Ověřování aktualizováno',
				aisUnsubscribed: 'Ověřování ukončeno',
				aisNotIdentified: 'Ověřování selhalo',
				aisPartiallyIdentified: 'Ověřování částečně dokončeno',
				aisPartiallyUpdated: 'Ověřování částečně aktualizováno',
				unknown: 'Neznámý',
			},
			actions: {
				identifyAis: {
					button: 'Spustit ověření',
					snackbar: {
						success:
							'Požadavek na ověření údajů zadán. Provedení může trvat několik desítek sekund.',
						failed: 'Spuštění ověření údajů se nepodařilo zadat.',
					},
				},
				updateAis: {
					button: 'Aktualizovat ověření',
					snackbar: {
						success:
							'Požadavek na aktualizaci ověřených údajů zadán. Provedení může trvat několik desítek sekund.',
						failed: 'Aktualizaci ověření údajů se nepodařilo zadat.',
					},
				},
			},
		},
		clientNationalIdentifierAddToBlacklistDialog: {
			title: 'Přidat na blacklist?',
			description:
				'Klient nebude moci aktivovat aplikaci pomocí identifikátoru {id: string}.',
			confirmButton: 'Přidat',
			snackbar: {
				success: 'Identifikátor přidán na blacklist',
				failed: 'Identifikátor se nepodařilo přidat na blacklist',
				invalidIdentifier:
					'Identifikátor se nepodařilo přidat na blacklist, neplatný identifikátor',
				clientDoesNotExist:
					'Identifikátor se nepodařilo přidat na blacklist, klient neexistuje',
			},
		},
		clientNationalIdentifierRemoveFromBlacklistDialog: {
			title: 'Odebrat z blacklistu?',
			description:
				'Klient bude moci opět aktivovat aplikaci pomocí identifikátoru {id: string}.',
			confirmButton: 'Odebrat',
			snackbar: {
				success: 'Identifikátor odebrán z blacklistu',
				failed: 'Identifikátor se nepodařilo odebrat z blacklistu',
				invalidIdentifier:
					'Identifikátor se nepodařilo odebrat z blacklistu, neplatný identifikátor',
				clientDoesNotExist:
					'Identifikátor se nepodařilo odebrat z blacklistu, klient neexistuje',
			},
		},
		onBlacklistTag: 'Na blacklistu',
		onBlacklistTooltip:
			'Identifikátor na blacklistu blokuje klienta v aktivaci aplikace',
	},
	accountTermination: {
		layout: {
			terminatedProducts: 'Rušené produkty',
			balanceSettlement: 'Vypořádání zůstatku',
			summary: 'Rekapitulace',
			cancelProcess: 'Zrušit proces',
			accountTermination: 'Zrušení účtu',
			cancelDialog: {
				title: 'Zrušit proces?',
				description: 'Ztratíte všechny vyplněné informace.',
			},
		},
		useAccountTerminationReasonCategoriesHook: {
			categories: {
				onClientRequest: 'Z podnětu klienta',
				onBankRequest: 'Z podnětu banky',
				specificReasons: 'Specifické důvody',
			},
		},
		useAccountTerminationReasonsConfigurationHook: {
			feeTooHigh: 'Vysoké poplatky za služby',
			notEnoughProducts: 'Nedostatečná šíře produktů',
			interestRate: 'Výše úrokových sazeb',
			confusing: 'Nevyhovující správa produktu přes aplikaci',
			other: 'Jiné',
			clientRequest: 'Zrušení na žádost klienta',
			aml: 'AML důvody (okamžitě)',
			fraud: 'Podvod (okamžitě)',
			tocViolation: 'Hrubé porušení obchodních podmínek (okamžitě)',
			insolvency: 'Insolvence',
			inheritance: 'Dědictví',
			limitationOfAutonomy: 'Omezení svéprávnosti',
			bankWithNoticePeriod:
				'Ukončení vztahu s klientem (2-měsíční výpovědní lhůta)',
		},
		terminationProductsListComponent: {
			overdraft: {
				title: 'Kontokorent',
				label: 'Výše kontokorentu',
				tooltip: 'Nastavený kontokorent bude zrušeny k datu zrušení účtu',
			},
			productListSection: {
				title: 'Trvalé příkazy, inkasa a SIPO',
				tooltip: 'Nastavené příkazy budou zrušeny k datu zrušení účtu',
				directDebits: { label: 'Inkaso {labelIndex: number}' },
				standingOrders: { label: 'Trvalý příkaz {labelIndex: number}' },
				sipo: { label: 'SIPO {labelIndex: number}' },
			},
			cards: {
				title: 'Platební karty',
				text: 'K účtu je vydána debetní karta. Ke zrušení účtu dojde po uplynutí 30 denní lhůty pro zrušení karty. Karta bude automaticky zrušena, když bude proces zrušení účtu dokončen.',
			},
			sharedAccountTerminationHint:
				'Účet bude zrušen i pro spoluvlastníka, kterým je ',
		},
		reasonDialog: {
			title: 'Důvod zrušení',
			note: 'Poznámka',
			terminateAllAccountsDialog: {
				title: 'Chcete pokračovat s jedním účtem?',
				description:
					'Zrušení účtu {separator:string} je většinou potřeba provést na více účtech klienta. Skutečně chcete pokračovat pouze s jedním vybraným účtem?',
				startAllAccountsTermination: 'Spustit zrušení všech účtů',
			},
		},
		productsPage: {
			balance: 'Zůstatek',
			account: {
				label: 'Název účtu',
			},
			accountCannotBeTerminated: {
				title: 'Účet nelze zrušit',
				subtitlePart1: 'Zrušení účtu',
				subtitlePart2: 'brání:',
				accountTerminationReasonTitle: 'Na účtu',
				terminationReasons: {
					blockingExists: 'Blokace na účtu',
					existingTermination: 'Jiný probíhající požadavek na zrušení účtu',
				},
			},
		},
		settlementPage: {
			accountSectionTitle: 'Účty pro vypořádání zůstatku',
			accountSectionTooltip:
				'Účet, na který budou zaslány zbývající finanční prostředky z rušeného účtu',
			accountSectionHint:
				'Zůstatek rušeného účtu bude rozdělen mezi uvedené účty stejným dílem',
			internalBankAccount: 'Interní účet banky',
			dateSectionTitle: 'Datum zrušení účtu',
			dateSectionTooltip:
				'Datum, ke kterému proběhne zrušení účtu. Do data zrušení může klient účet normálně používat.',
			documentsSectionTitle: 'Dokumenty',
			documentsSectionTooltip:
				'K procesu rušení je možné přidat dokumenty, které souvisí s požadavkem na zrušení (např. žádost klienta). Dokumenty přiložené v procesu budou automaticky uloženy mezi ostatní dokumenty klienta.',
			other: 'Jiný účet',
			terminationDate: 'Datum zrušení účtu',
			selectDocument: 'Vybrat dokument',
			uploadDocument: 'Nahrát dokument',
			sameSettlementAndTerminatedAccountError:
				'Účet pro vypořádání zůstatku nemůže být stejný jako rušený účet',
			settlementAccountCannotBeSubAccountOfTerminatedAccount:
				'Účet pro vypořádání zůstatku nemůže být podúčtem rušeného účtu',
			settlementAccountIsInTerminationProcess:
				'Účet pro vypořádání zůstatku je v procesu rušení, zadejte jiný účet',
			dateMustBeAfterToday: 'Datum musí být nejdříve dnes',
			documentCardComponent: {
				deleteDocumentDialog: {
					title: 'Odstranit dokument?',
					description:
						'Dokument bude odstraněn z procesu, ale zůstane nahrán v dokumentech klienta.',
				},
				deleteAndRemoveDocumentDialog: {
					title: 'Odstranit a smazat dokument?',
					description:
						'Dokument bude odstraněn z procesu a zároveň bude smazán z dokumentů klienta. Akce je nevratná.',
				},
			},
		},
		summaryPage: {
			recapitulationSection: {
				title: 'Rekapitulace',
				settlementAccounts: 'Účty pro vypořádání zůstatku',
				reason: 'Důvod zrušení',
				reasonNote: 'Poznámka',
				settlementAccount: 'Účet pro vypořádání zůstatku',
				terminationDate: 'Datum zrušení účtu',
				documentsRecapitulationSubsection: {
					title: 'Dokumenty',
				},
			},
			terminatedProductsSection: {
				title: 'Rušené produkty',
			},
			authorizationTypeSection: {
				title: 'Způsob schválení žádosti',
				internalControl: 'Interní kontrola',
				internalControlTooltip:
					'Žádost o zrušení účtu bude poslána do interní fronty na kontrolu a dokončení dalším pracovníkem banky',
				byClientInApp: 'Klientem v mobilní aplikaci',
				byClientInAppTooltip:
					'Žádost o zrušení účtu bude poslána klientovi do mobilní aplikace k potvrzení',
			},
			resultDialog: {
				success: {
					title: 'Žádost odeslána',
					description: 'Žádost o zrušení účtu byla odeslána ke schválení',
					showRequest: 'Zobrazit žádost',
				},
				error: {
					title: 'Žádost nelze zpracovat',
					description: 'Zrušení účtu se nepodařilo provést',
				},
			},
		},
	},
	incomingMobility: {
		common: {
			dateOfMobility: 'Datum mobility',
			mobilityRange: 'Rozsah',
			transferBalance: 'Převést aktuální zůstatek',
			transferAllStandingOrdersAndDirectDebits:
				'Převést trvalé příkazy a inkasa',
			closeAccount: 'Zrušit účet',
		},
		incomingMobilityLayout: {
			basicInformation: 'Základní údaje',
			documents: 'Dokumenty',
			standingOrdersDirectDebitSipo: 'Trvalé příkazy, Inkasa a SIPO',
			recapitulation: 'Rekapitulace',
			cancelProcess: 'Zrušit proces',
			incomingMobility: 'Příchozí mobilita',
		},
		createIncomingMobility: {
			createIncomingMobilityBasicInfoPage: {
				accountInfoTitle: 'Současný účet klienta v jiné bance',
				accountInfoTooltip:
					'Zadejte účet klienta v jiné bance, ze kterého se bude převádět zůstatek a příp. trvalé příkazy (viz. rozsah níže) do Partners. Účet musí být veden v CZK měně.',
				accountPrefix: 'Předčíslí',
				currencyCode: 'Měna účtu',
				mobilityDateTitle: 'Datum mobility',
				mobilityDateTooltip:
					'Datum, ke kterému se má mobilita v požadovaném rozsahu provést. Nejdřívější možný termín je 13. pracovní den ode dneška.',
				mobilityDateDescription1:
					'Vyberte pracovní den mezi {datePlaceholder:string} a {datePlaceholder:string}.',
				mobilityDateDescription2:
					'Pokud klient bude převádět i platby, ověřte, že zadané datum neovlivní splatnost příkazů v druhé bance.',
				mobilityDateCaption:
					'Vyberte datum mezi {minDate: string} a {maxDate: string}',
				mobilityDateError:
					'Zadané datum musí být pracovní den mezi {minDate: string} a {maxDate: string}',
				mobilityDateNotLoadedError: 'Informace o datu se nepodařilo načíst.',
				mobilityRangeTooltip:
					'K dispozici jsou nejčastější možnosti. Pokud klient požaduje jiný rozsah, využijte extra formulář dostupný na WIKI.',
				incomingMobilityValidationFailed: 'Validace  neproběhla v pořádku ',
				otherOptions: 'Další možnosti',
				mobilityScopeMinLength:
					'Je nutné vybrat alespoň jednu možnost rozsahu mobility',
			},
			createIncomingMobilityRecapitulationPage: {
				otherBankCurrentAccountTitle: 'Současný účet klienta v jiné bance',
				partnersAccountTitle: 'Účet v Partners',
				parametersTitle: 'Parametry',
				mobilityScope: 'Rozsah',
				resultDialog: {
					success: {
						title: 'Žádost vytvořena',
						description:
							'Žádost o převod účtu byla odeslána klientovi do mobilní aplikace ke schválení',
						showRequestButton: 'Zobrazit žádost',
					},
					error: {
						title: 'Žádost nelze zpracovat',
						description: 'Byly nalezeny chyby, které brání vytvoření',
					},
				},
			},
			bankBackOfficeGatewayErrors: {
				fixableErrors: {
					title: 'Opravitelné chyby',
					texts: {
						validationAccountErrorMissingBirthday: 'Chybějící datum narození',
						validationAccountErrorMissingName: 'Chybějící jméno nebo příjmení',
						validationAccountErrorMissingPrimaryIdCard:
							'Chybějící primární doklad',
						validationAccountErrorMissingNationalNumber:
							'Chybějící rodné číslo',
						validationAccountErrorMissingAddress:
							'Chybějící trvalé nebo přechodné bydliště',
						validationAccountErrorMissingEmail: 'Chybějící email',
						validationAccountErrorMissingPhone: 'Chybějící telefon',
						verificationErrorNameAndBirthday:
							'Jméno, příjmení a datum narození není ověřeno',
						verificationErrorNationalNumber: 'Rodné číslo není ověřeno',
						verificationErrorIdCard: 'Číslo dokladu není ověřeno',
						verificationErrorAddres: 'Adresa není ověřena',
						verificationErrorEmail: 'Email není ověřen',
						verificationErrorPhone: 'Telefon není ověřen',
						validationDataErrorSimilarMobilityExists:
							'Mobilita se stejnými parametry již existuje v procesu schvalování/zpracování',
					},
				},
				unfixableErrors: {
					title: 'Neopravitelné chyby',
					texts: {
						validationAccountErrorClientIsNotAdult: 'Klient není zletilý',
						validationAccountErrorClientIsNotOwnerOfIban:
							'Klient není vlastníkem účtu',
						validationAccountErrorAccountIsClosing: 'Účet se bude rušit',
						validationAccountErrorAccountIsBlocked: 'Účet je blokovaný',
						validationDataErrorAccountNotKnown: 'Neznámý účet',
						validationAccountErrorProductNotEligible:
							'Na účtu nelze vytvořit mobilitu',
						validationAccountErrorStatusNotEligible: 'Účet v nepovoleném stavu',
						validationAccountErrorClientNotOwner: 'Klient není vlastníkem účtu',
					},
				},
				unexpectedErrors: {
					title: 'Neočekávané chyby',
					text: 'Nedostupné interní služby',
				},
			},
		},
		processIncomingMobility: {
			processIncomingMobilityBasicInfoPage: {
				currentClientBank: 'Současná banka klienta',
				dateOfMobilityTooltip: 'not defined yet',
				currentClientBankHeaderTooltip: 'not defined yet',
			},
			processIncomingMobilityRecurringPaymentsPage: {
				createDialog: {
					title: 'Nový příkaz',
					typeLabel: 'Typ',
				},
				invalidateDialog: {
					description:
						'Přejete si pokračovat v zneplatnění mobility? Akce je nevratná.',
					label: 'Důvod zneplatnění',
				},
				paymentOrder: {
					name: 'Název',
					status: 'Stav',
					amount: 'Částka v Kč',
					periodicity: 'Frekvence',
					sortCode: 'Předčíslí',
					accountNumber: 'Číslo účtu',
					bankCode: 'Kód banky příjemce',
					variableSymbol: 'Variabilní symbol',
					constantSymbol: 'Konstantní symbol',
					specificSymbol: 'Specifický symbol',
					messageToRecipient: 'Zpráva pro příjemce',
					periodicityOptions: {
						annually: 'Ročně',
						indefinite: 'Neurčitě',
						monthly: 'Měsíčně',
						quarterly: 'Čtvrtletně',
						semiAnnually: 'Pololetně',
						weekly: 'Týdně',
					},
					mobilityProcessStatusOptions: {
						active: 'aktivní',
						inactive: 'neaktivní',
						cancel: 'zrušený',
						firstSign: 'podepsáno poprvé',
						waitingForSign: 'čeká na podpis',
					},
					validFromDate: 'Platnost od',
					validToDate: 'Platnost do',
				},
				standingOrder: {
					title: 'Trvalý příkaz',
					editTitle: 'Editace trvalého příkazu',
					invalidateTitle: 'Zneplatnění trvalého příkazu',
					executionDate: 'Datum provedení',
				},
				directDebit: {
					title: 'Inkaso',
					editTitle: 'Editace inkasa',
					invalidateTitle: 'Zneplatnění inkasa',
				},
				sipo: {
					title: 'SIPO',
					editTitle: 'Editace SIPO',
					invalidateTitle: 'Zneplatnění SIPO',
					connectionNumber: 'Číslo spojení',
					messageForMe: 'Zpráva pro mě',
				},
				buttons: {
					generateConfirmation: 'Vygenerovat potvrzení',
					setUp: 'Nastavit',
					invalidate: 'Zneplatnit',
					edit: 'Editovat',
					addPayment: 'Přidat příkaz',
				},
				settingUpPaymentsOrders:
					'Nastavení trvalých příkazů, svolení k inkasu a SIPO',
				sectionTitles: {
					directDebit: 'Inkaso',
					sipo: 'SIPO',
					standingOrders: 'Trvalé příkazy',
				},
			},
			incomingMobilityDocumentPage: {
				uploadDocument: 'Nahrát dokument',
			},
			incomingMobilityRecapitulationPage: {
				newAccount: 'Nový účet v Partners Bank',
				currentClientBank: 'Současná banka klienta',
				finishButton: 'Dokončit',
				dialogTitle: 'Chcete ukončit zpracování mobility?',
				dialogDescription:
					'Ukončením zpracování mobility se mobilita uzavře vůči změnám a zpracování. Ukončená mobilita je přesunuta do historie mobilit klienta.',
			},
		},
	},
	unexpectedErrorDialogComponent: {
		title: 'Neočekávaná chyba',
		description: 'Nastala neočekávaná chyba',
	},
	clientDocuments: {
		title: 'Dokumenty',
		uploadDocument: 'Nahrát dokumenty',
		filtersPopoverContent: {
			filterGroupTitles: {
				search: 'Vyhledat',
				category: 'Kategorie',
				documentsAvailableInMobileApp:
					'Dokumenty dostupné klientovi v mobilní aplikaci',
				archivedDocuments: 'Archivované dokumenty',
			},
			labels: {
				allCategories: 'Všechny',
				withoutRestriction: 'Bez omezení',
			},
			searchDocument: 'Vyhledat v názvu dokumentu',
			tooltips: {
				documentsAvailableInMobileAppTooltip:
					'Vyfiltruje dokumenty, které jsou aktuálně dostupné klientovi v rámci mobilní aplikace {companyName:string}, v nabídce "Menu", sekce Banka, položka "Dokumenty".',
			},
		},
		horizontalMenuItems: {
			bankDocuments: 'Bankovní dokumenty',
			uploadedByClientDocuments: 'Nahrané ke klientovi',
		},
		columns: {
			category: 'Kategorie',
			fileName: 'Název',
			visibleToClient: 'Dostupný v aplikaci',
			createdAtDate: 'Datum vytvoření',
			labels: {
				archived: 'Archivovaný',
			},
		},
		noDocuments: 'Žádné dokumenty',
		failedToLoadDocuments: 'Dokumenty se nepodařilo načíst',
		documentDetail: {
			failedToLoadBankDocument: 'Bankovní dokument se nepodařilo načíst.',
			sections: {
				signatures: 'Podepsání dokumentu',
				originalDocumentReplacement: 'Nahrazuje původní dokument',
				additionalInfo: 'Dodatečné údaje',
			},
			labels: {
				description: 'Popis',
				bankDocumentCode: 'Číslo smlouvy / dokumentu',
				tags: 'Tagy',
				signedByBank: 'Banka podepsala',
				signedByClient: 'Klient podepsal',
				originalDocumentUuid: 'ID původního dokumentu',
				originalDocumentName: 'Název původního dokumentu',
				originalDocumentCreatedAt: 'Datum vytvoření původního dokumentu',
				documentUuid: 'ID dokumentu',
				documentOwner: 'Vlastník dokumentu',
				connectedWithAccount: 'Dokument spjatý s účtem',
				expirationDate: 'Datum expirace',
			},
			buttons: {
				editDocumentInformation: 'Změnit informace o dokumentu',
			},
		},
		bankTypes: {
			addendumToFrameworkAgreement: 'Dodatek k rámcové smlouvě',
			availableAccountConfirmation: 'Potvrzení o vedení účtu',
			availableBalanceConfirmation: 'Potvrzení o zůstatku',
			commitmentsConfirmation: 'Potvrzení o závazcích',
			complaintsProcedure: 'Reklamační řád',
			directDebitConfirmation: 'Potvrzení inkasa',
			foreignPoliceConfirmation: 'Potvrzení pro cizineckou policii',
			frameworkAgreement: 'Rámcová smlouva',
			priceList: 'Ceník',
			sipoConfirmation: 'SIPO potvrzení',
			standingOrderConfirmation: 'Potvrzení trvalého příkazu',
			statementOfFees: 'Poplatkový výpis',
			statementOfPayments: 'Transakční výpis',
			termsAndConditions: 'Pravidla a podmínky',
			termsAndConditionsCards: 'Pravidla a podmínky pro karty',
			termsAndConditionsCardsGoogleAndApplePay:
				'Pravidla a podmínky pro Google/Apple pay',
			termsAndConditionsPayments: 'Pravidla a podmínky pro platby',

			mobilityRequest: 'Žádost o mobilitu',
			interestRates: 'Úroková sazba',
			personalDataProcessingInformation:
				'Informace o zpracování osobních údajů',
			permanentlyAccessibleInformation: 'Trvale přístupné informace',
			termsOfUseMobileApplication: 'Podmínky používání mobilní aplikace',
			groupMarketingConsent: 'Skupinový marketingový souhlas',
			informationOnTheDepositInsuranceSystem:
				'Informace o systému pojištění vkladů',
			mobilityChangeAccount: 'Mobilita - změna účtu',
			mobilityPayers: 'Mobilita - plátce',
			accountTerminationBankImmediateCab: 'Zrušení účtu - okamžité - CAB',
			accountTerminationBankImmediateOther: 'Zrušení účtu - okamžité - jiný',
			accountTerminationBankWithNoticePeriod: 'Zrušení účtu - výpovědní lhůta',
			accountTerminationLimitationOfAutonomy:
				'Zrušení účtu - omezení svéprávnosti',
			loanAccessorAgreement: 'Smlouva o přístupu k úvěru',
			loanAgreement: 'Smlouva o úvěru',
			loanApplicationSecured: 'Žádost o úvěr - zajištěný',
			loanApplicationUnsecured: 'Žádost o úvěr - nezajištěný',
			loanInterestRateGuaranteeSecured: 'Zajištění úrokové sazby - zajištěný',
			loanInterestRateGuaranteeUnsecured:
				'Zajištění úrokové sazby - nezajištěný',
			loanPreContractualExplanation: 'Předkontraktační vysvětlení',
			loanRefinancingTermination: 'Ukončení refinancování úvěru',
			loanScheduleSecured: 'Úvěrový plán - zajištěný',
			loanScheduleUnsecured: 'Úvěrový plán - nezajištěný',
			exampleTemplate: 'Ukázková šablona',
			cardPaymentConfirmation: 'Potvrzení o platbě kartou',
			domesticPaymentConfirmation: 'Potvrzení o domácí platbě',
			sepaPaymentConfirmation: 'Potvrzení o SEPA platbě',
			loanIzuUnsecured: 'Úvěr IŽU - nezajištěný',
			frameworkAgreementAmendment: 'Dodatek k rámcové smlouvě',
			priceListAmendment: 'Dodatek k ceníku',
			termsAndConditionsAmendment: 'Dodatek k podmínkám',
			termsAndConditionsAdjustment: 'Úprava podmínek',
			termsAndConditionsPaymentsAmendment: 'Dodatek k podmínkám pro platby',
			termsAndConditionsPaymentsAdjustment: 'Úprava podmínek pro platby',
			termsAndConditionsCardsAmendment: 'Dodatek k podmínkám pro karty',
			termsAndConditionsCardsAdjustment: 'Úprava podmínek pro karty',
			foreignPaymentConfirmation: 'Potvrzení zahraniční platby',
			loanEuropeanStandardisedInformationSheetSecured:
				'Evropský standardizovaný informační přehled - zajištěný',
			loanAccessionToDebtAgreementSecured:
				'Smlouva o přistoupení k závazku - zajištěný',
			loanAccessionToDebtAgreementUnsecured:
				'Smlouva o přistoupení k závazku - nezajištěný',
			loanCalculationWhenWithdrawingFromALoan: 'Výpočet při výběru z úvěru',
			loanConfirmationOfCancellationOfApplication: 'Potvrzení zrušení žádosti',
			loanConfirmationOfConsumerLoanRepayment:
				'Potvrzení splacení spotřebitelského úvěru',
			loanConfirmationOfConsumerLoanRepaymentAndTerminationOfTheAccessionObligation:
				'Potvrzení splacení a ukončení závazku',
			loanContractSecured: 'Úvěrová smlouva - zajištěný',
			loanContractUnsecured: 'Úvěrová smlouva - nezajištěný',
			loanEuropeanStandardisedInformationSheetUnsecured:
				'Evropský standardizovaný informační přehled - nezajištěný',
			loanExtraordinaryFullInstalmentCalculation: 'Výpočet mimořádné splátky',
			loanNoticeOfEarlyRepaymentOfConsumerLoanUnsecured:
				'Oznámení o předčasném splacení - nezajištěný',
			loanStandardEuropeanConsumerCreditInformationUnsecured:
				'Standardní evropské spotřebitelské informace - nezajištěný',
			loanConfirmationOfPaidInterestSecured:
				'Potvrzení zaplacených úroků - zajištěný',
			loanEarlyRepaymentNotice: 'Oznámení o předčasném splacení',
			other: 'Ostatní',
		},
	},
	appEditableTagInputsComponent: {
		addTag: 'Přidat tag',
	},
	client: {
		additionalCurrencies: {
			title: 'Další měnové složky',
			mismatchAccountantBalanceSingle:
				'Měnová složka {currencyCode: string} má rozdílný účetní zůstatek',
			mismatchAccountantBalanceMultiple:
				'Měnové složky {currencyCodes: string} mají rozdílný účetní zůstatek',
			accountant: 'účetní {amount: string}',
		},
	},
	clientProducts: {
		title: 'Produkty',
		horizontalMenuItems: {
			package: 'Balíček',
			accounts: 'Účty {count: string}',
			cards: 'Karty {count: string}',
			loans: 'Úvěry {count: string}',
			bankInsurances: 'Pojištění k účtu {count: string}',
		},
		actionSections: {
			client: 'Klient',
			consulting: 'Poradenství',
		},
		actions: {
			createReportsForStateInstitutions:
				'Vytvořit podklady pro státní instituce',
			createPFSAnalysis: 'Vytvořit analýzu v PFS',
			sendClientDocumentationToPFS: 'Odeslat dokumentaci do PFS',
			verifyClientForRemoteService: 'Ověřit vzdáleně totožnost klienta',
			blockPid: 'Zablokovat klienta',
			unblockPid: 'Odblokovat klienta',
			blockageHistory: 'Historie blokací klienta',
		},
		blockPidDialog: {
			title: 'Zablokovat klienta?',
			description: 'Po zablokování identity klienta budou také automaticky:',
			bulletPoints: {
				blockAllMobileActivations:
					'zablokovány všechny stávající aktivace mobilní aplikace',
				blockFutureMobileActivations:
					'zablokována možnost aktivovat si mobilní aplikaci v budoucnu',
				blockBankIdentity: 'zablokována bankovní identita',
			},
			confirm: 'Zablokovat',
			snackbar: {
				success: 'Klient byl úspěšně zablokován',
				alreadyBlocked: 'Klient je již zablokován',
				failed: 'Blokaci klienta se nepodařilo provést',
			},
		},
		unblockPidDialog: {
			title: 'Odblokovat klienta?',
			descriptionPrefix: 'Po odblokování ',
			descriptionBold: 'nebudou',
			descriptionSuffix:
				' automaticky obnoveny předchozí blokace mobilní aplikace a bankovní identity. Odblokování je třeba provést manuálně nebo klient bude muset projít novou aktivací mobilní aplikace.',
			confirm: 'Odblokovat',
			snackbar: {
				success: 'Klient byl úspěšně odblokován',
				alreadyUnblocked: 'Klient je již odblokován',
				failed: 'Odblokaci klienta se nepodařilo provést',
			},
		},
		blockageHistoryDialog: {
			title: 'Historie blokací',
			noBlockages: 'Žádné blokace',
			failedToLoad: 'Historii blokací se nepodařilo načíst',
			table: {
				date: 'Datum',
				action: 'Akce',
				performedBy: 'Provedl',
				reason: 'Důvod',
				blocked: 'Zablokováno',
				unblocked: 'Odblokováno',
			},
			columns: {
				blockageType: 'Typ blokace',
				validFrom: 'Platnost od',
				validTo: 'Platnost do',
			},
			blockageTypes: {
				identityFraud: 'Podezření na podvod',
				unknown: 'Neznámý',
			},
			activeBlockage: 'Aktivní',
		},
		generateReportForStateInstitutionsDialog: {
			title: 'Vytvořit podklady pro státní instituce',
			pageTitle: '{clientName:string} - Vytvořit podklady pro státní instituce',
			informationToCopy: 'Informace ke zkopírování',
			sections: {
				loans: {
					productCode: 'Kód produktu: {productCode: string}',
					amount: 'Částka: {amount: string}',
					secured: 'Zajištěný: {secured: string}',
					state: 'Stav: {state: string}',
					code: 'Kód úvěru: {code: string}',
					loanAgreementSignedAt:
						'Datum podepsání: {loanAgreementSignedAt: string}',
					pastDueAmount: 'Částka po splatnosti: {pastDueAmount: string}',
					yesValue: 'Ano',
					noValue: 'Ne',
				},
				client: {
					client: 'KLIENT',
					nameAndSurname: 'Jméno a příjmení: {name: string}',
					dateOfBirth: 'Datum narození: {dateOfBirth: string}',
					permanentResidence: 'Trvalé bydliště: {address: string}',
					idCardNumber: 'Číslo občanského průkazu: {idCardNumber: string}',
					phoneNumber: 'Telefonní číslo: {phoneNumber: string}',
					email: 'E-mail: {email: string}',
					documentCopy: {
						header: 'Pořízené kopie dokladů',
						updatedAt: 'Datum změny: {updatedAt: string}',
						idCardNumber: 'Číslo dokladu: {idCardNumber: string}',
						link: 'Zobrazit detaily k pořízeným kopiím dokladů',
					},
				},
				bankAccounts: {
					accountNumber: 'Číslo účtu: {accountNumber: string}',
					status: 'Stav: {status: string}',
					balance: 'Zůstatek: {balance: string}',
					dateOfCreation: 'Datum založení: {dateOfCreation: string}',
					methodOfCreation: 'Způsob založení: {methodOfCreation: string}',
					distraints: 'Exekuce: {hasDistraints: string}',
					heldTransactions: 'Blokační transakce: {hasHeldTransactions: string}',
					terminationSource: 'Zrušen na žádost: {terminationSource: string}',
					terminationSourceValues: {
						bank: 'Banky',
						bankCore: 'Banky (Core)',
						client: 'Klienta',
					},
					disponents: {
						header: 'Disponenti:',
						nameAndSurname: 'Jméno a příjmení: {name: string}',
						dateOfBirth: 'Datum narození: {dateOfBirth: string}',
						permanentResidence: 'Trvalé bydliště: {address: string}',
						idCardNumber: 'Číslo občanského průkazu: {idCardNumber: string}',
						phoneNumber: 'Telefonní číslo: {phoneNumber: string}',
						email: 'E-mail: {email: string}',
					},
					distraintFields: {
						referenceNumber:
							'Spisová značka a pořadové číslo: {referenceNumber: string}',
						issuer: 'Vydal: {issuer: string}',
						actualAmount: 'Aktuální částka: {actualAmount: string}',
						originalAmount: 'Původní částka: {originalAmount: string}',
						issueDate: 'Datum vystavení: {issueDate: string}',
						lastChangeDate:
							'Datum poslední změny blokace: {lastChangeDate: string}',
					},
					heldTransactionFields: {
						type: 'Typ: {type: string}',
						amount: 'Částka: {amount: string}',
						creationDate: 'Datum vytvoření: {creationDate: string}',
					},
				},
				bankCards: {
					creditCardNumber: 'Číslo platební karty: {creditCardNumber: string}',
					holdersName: 'Jméno držitele: {holdersName: string}',
					cardType: 'Typ karty: {cardType: string}',
					cardStatus: 'Stav karty: {cardStatus: string}',
					cardActivationMethod:
						'Způsob aktivace karty: {cardActivationMethod: string}',
					deliveryAddress: 'Doručovací adresa: {deliveryAddress: string}',
					addressNotRegistered: 'Není evidována',
					cardTokens: {
						noTokens: 'Žádné karetní tokeny',
						tokenReferenceId:
							'Číslo karetního tokenu: {tokenReferenceId: string}',
						panSource: 'Způsob tokenizace: {panSource: string}',
						createdAt: 'Datum tokenizace: {createdAt: string}',
						tokenStatus: 'Stav karetního tokenu: {tokenStatus: string}',
					},
				},
				applicationActivations: {
					createdAt: 'Datum vytvoření: {createdAt: string}',
					name: 'Název: {name: string}',
					processType: 'Typ aktivace: {processType: string}',
					processState: 'Stav: {processState: string}',
					phoneNumber: 'Telefonní číslo: {phoneNumber: string}',
					bankTitle: 'Banka použita pro přihlášení: {bankTitle: string}',
					activationId: 'ID aktivace: {activationId: string}',
				},
				bankIdentity: {
					createdAt: 'Datum vytvoření: {createdAt: string}',
					company: 'Společnost: {company: string}',
					application: 'Aplikace: {application: string}',
					id: 'ID: {id: string}',
					type: 'Typ události: {type: string}',
					activityUuid: 'ID aktivity: {activityUuid: string}',
				},
			},
			steps: {
				range: 'Rozsah',
				outputs: 'Výstupy',
			},
			subtitles: {
				client: 'Klient',
				products: 'Produkty',
				applications: 'Aplikace',
				documents: 'Dokumenty',
				bankIdentity: 'Bankovní identita',
				loans: 'Úvěry',
			},
			tooltips: {
				other:
					'Vyhledá v dokumentech klienta následující typy dokumentů: rámcová smlouva, dodatek k rámcové smlouvě, změna rámcové smlouvy nebo dokumenty související s ukončením vztahu s klientem.',
			},
			checkboxes: {
				client: 'Stáhnout informace o klientovi',
				accounts: 'Stáhnout informace k vybraným účtům klienta',
				accountDisponents: 'Stáhnout informace k disponentům',
				accountStatements:
					'Vygenerovat výpis(y) k vybraným účtům klienta za období',
				cards: 'Stáhnout informace ke kartám',
				cardTokens: 'Stáhnout informace ke karetním tokenům',
				applicationActivations: 'Stáhnout historii aktivací mobilní aplikace',
				contractualDocuments: 'Připravit seznam smluvní dokumentace',
				bankIdentity: 'Stáhnout historii použití bankovní identity',
				loans: 'Stáhnout informace k úvěrům',
			},
			datePickers: {
				dateFrom: 'Od',
				dateTo: 'Do',
			},
			contentTitles: {
				client: 'Informace o klientovi',
				accounts: 'Informace k vybraným účtům klienta',
				cardsAndCardTokens: 'Informace ke kartám a karetním tokenům',
				applications: 'Historie aktivací mobilní aplikace',
				bankIdentity: 'Historie použití bankovní identity',
				loans: 'Informace k úvěrům',
			},
			buttons: {
				generateReports: 'Vytvořit',
				updateFirstStep: 'Změnit zadání',
			},
			noData: {
				noClientData: 'Žádné data ke klientovi',
				noAccountsData: 'Žádné data k účtům',
				noCardsData: 'Žádné data ke kartám',
				noApplicationsData: 'Žádné data k aplikacím',
				noDocumentsData: 'Žádné dokumenty',
				noBankIdentityData: 'Žádné data k bankovní identitě',
				noLoansData: 'Žádná data k úvěrům',
			},
			failedToLoadLoansData: 'Data o úvěrech se nepodařilo načíst',
			failedToLoadData: 'Data se nepodařilo stáhnout',
			failedToLoadDataDateRangeNotValid:
				'Data se nepodařilo stáhnout (pro vybrané účty je zadané datum od-do neplatné)',
			insufficientRights: {
				title: 'Report nelze vytvořit',
				description:
					'Nemáte dostatečná práva pro vygenerování reportu. Obraťte se prosím na helpdesk.',
			},
		},
		createPFSAnalysisDialog: {
			title: 'Vytvořit analýzu v PFS',
			errorTitle: 'Analýzu nelze vytvořit',
			successTitle: 'Analýza vytvořena',
			changeEntry: 'Změnit zadání',
			description:
				'Založí klienta v Partners Financial Services a vytvoří novou analýzu pod konkrétním poradcem.',
			advisorId: 'ID poradce',
			advisorIdHelperText:
				'ID poradce může být jak pro fyzické tak právnické osoby',
			advisorFullName: 'Jméno poradce',
			errors: {
				advisorWithCurrentIdDoesNotExist: 'Poradce s daným ID neexistuje',
				errorClientshipDoesNotMeetCriteria:
					'Klient nesplňuje podmínky. Musí být klientem Partners Banky a nesmí být klientem Partners Financial Services.',
				errorNationalContextDoesNotMeetCriteria:
					'Klient a poradce mají nastavený rozdílný národní kontext',
				advisorOrClientDoesNotExist:
					'Nečekaná chyba - poradce nebo klient neexistuje',
				existingAnalysisInPFS:
					'Klient má v Partners Financial Services již vytvořenou analýzu',
			},
			flagDescription: 'Příznak “Založena na základě požadavku Partners Banky”',
			flagToggle:
				'Označit příznakem “Založena na základě požadavku Partners Banky”',
			theAnalysisWillBeCreatedWithoutTheClientsConsent:
				'Analýza bude vytvořena bez souhlasu klienta.',
			analysisCreated:
				'Klient byl založen v Partners Financial Services a byla vytvořena analýza {analysisId: number}. Poradce bude informován o analýze emailem.',
		},
		sendDocumentationToPFSDialog: {
			title: 'Odeslat bankovní smlouvy do PFS',
			errorTitle: 'Smlouvy nelze odeslat',
			successTitle: 'Smlouvy odeslány',
			description:
				'Odešle smluvní dokumentaci klienta z Partners Banky do Partners Financial Services pro další zpracování.',
			sendDocumentationUnderTheCurrentClientGuardian:
				'Odeslat dokumentaci pod aktuálním opatrovníkem klienta {advisorName: string} (ID{advisorID: string})',
			unfortunatelyTheClientDoesNotHaveAnAssignedGuardian:
				'Bohužel klient nemá přiděleného opatrovníka',
			submitDocumentationUnderAnotherAdvisor:
				'Odeslat dokumentaci pod jiným poradcem',
			advisorId: 'ID poradce',
			advisorIdHelperText:
				'ID poradce může být jak pro fyzické tak právnické osoby',
			advisorFullName: 'Jméno poradce',
			errors: {
				errorClientshipDoesNotMeetCriteria:
					'Klient nesplňuje podmínku. Klient musí být klientem Partners Banky a Partners Financial Services.',
				advisorWithCurrentIdDoesNotExist: 'Poradce s daným ID neexistuje',
			},
			successDescription:
				'Smluvní dokumentace klienta byla odeslána do Partners Financial Services.',
			failureDescription: 'Odeslání dokumentů se nezdařilo',
			advisorIdHasChanged:
				'Při zpracování nebylo možné odeslat smlouvy pod zadaným poradcem. Smlouvy tak byly odeslány pod poradcem {advisorName: string} (ID{advisorID: string}).',
		},
		packagesPage: {
			anotherClient: 'Další klient',
			noPackage: 'Žádný balíček',
			failedToLoadPackage: 'Balíček se nepodařilo načíst',
			monthlyPrice: 'Cena měsíčně',
			packageName: 'Balíček "{packageName:string}"',
			marketingActionsErrors: {
				fetchFailed:
					'Zobrazena původní cena. Data o marketingových akcích se nepodařilo načíst.',
				multipleActions:
					'Zobrazena původní cena. Snížení nejasné kvůli souběhu více marketingových akcí.',
				discountApplied:
					'Cena snížena marketingovou akcí na vlastníkovi balíčku.',
			},
			additionalData: {
				title: 'Dodatečné údaje',
				advisorId: 'ID {advisorId:number}',
				labels: {
					bundleId: 'ID balíčku',
					productCode: 'Produktový kód',
					productVersion: 'Verze produktu',
					advisor: 'Poradce',
				},
			},
			clientRoles: {
				driver: 'Vlastník',
				passenger: 'Spoluvlastník',
				passengerChild: 'Dítě',
			},
			connectedClients: {
				title: 'Klienti připojení k balíčku',
				labels: {
					name: 'Jméno',
					lastname: 'Příjmení',
				},
			},
		},
		loansPage: {
			filter: {
				state: {
					title: 'Stav úvěru',
					active: 'Aktivní',
					completed: 'Ukončené',
				},
			},
			state: {
				active: 'Aktivní',
				cancelledByBank: 'Zrušen bankou',
				cancelledByBankBeforeDrawing: 'Zrušen bankou (před načerpáním)',
				cancelledByClient: 'Zrušen klientem',
				cancellingByBank: 'V procesu rušení (ze strany banky)',
				cancellingByClient: 'V procesu rušení (ze strany klienta)',
				clientWithdrawalFromTheContract: 'Zrušen klientem',
				collection: 'Ve vymáhání',
				contractNotSigned: 'Zrušen (nepodepsán)',
				contractSigned: 'Podepsaný (čeká na čerpání)',
				draft: 'Návrh',
				drawingExpired: 'Nenačerpaný (klient nesplnil podmínky)',
				drawing: 'V procesu čerpání',
				drawingPreparation: 'Příprava čerpání',
				earlyRepaid: 'Předčasně splacen',
				earlyRepaying: 'Vyžádáno předčasné splacení klientem',
				forcedRepaid: 'Splacen (zesplatnění bankou)',
				forcedRepayingByBank: 'Vyžádáno zesplatnění bankou',
				refinanced: 'Splacen (refinancován)',
				refinancing: 'Vyžádáno refinancování klientem',
				repaid: 'Splacen',
				waitingForAccessorSign: 'Čeká na podpis přistupitelů',
				waitingForDrawing: 'Čeká na načerpání',
				waitingForSign: 'Čeká na podpis',
			},
			productName: 'Název',
			creditLimitAmount: 'Výše úvěru',
			noActiveLoans: 'Žádné aktivní úvěry',
			noClosedLoans: 'Žádné ukončené úvěry',
			noLoanDetail: 'Žádný detail',
			stateTitle: 'Stav',
			loanDetail: {
				parameters: {
					nextPaymentDate: 'Datum příští splátky',
					nextPaymentAmount: 'Výše splátky',
					remainingCount: 'Počet zbývajících řádných splátek',
					repaidCount: 'Počet provedených řádných splátek',
					remainingPrincipalAmount: 'Jistina zbývající ke splacení',
					principalPaid: 'Splacená jistina',
					state: 'Stav',
					totalPastDueAmount: 'Částka po splatnosti',
					pastDueDate: 'Po splatnosti od {date: string}',
				},
				loan: {
					sectionTitle: 'Úvěr',
					creditLimitAmount: 'Původní výše úvěru',
					totalClientPays: 'Celkem klient zaplatí',
					purposeAmount: 'Výše účelové části úvěru',
					nonPurposeAmount: 'Výše neúčelové části úvěru',
					termInMonths: 'Doba splácení úvěru',
					repaymentDay: 'Den splátky v měsíci',
					repaymentFrequency: 'Frekvence splácení',
					repaymentDayInMonths: '{0}{{. den}}',
					repaymentDateFrequencyMap: {
						day: '{0}x denně',
						week: '{0}x týdně',
						month: '{0}x měsíčně',
						quarter: '{0}x čtvrtletně',
						year: '{0}x ročně',
					},
				},
				interestRate: {
					sectionTitle: 'Úroková sazba',
					interestRate: 'Úroková sazba',
					periodFixation: 'Fixace na období',
					rpsn: 'RPSN',
				},
				disposition: {
					sectionTitle: 'Dispozice',
					mainDebtor: 'Hlavní dlužník',
					coDebtors: 'Přistupitel',
				},
				additionalData: {
					sectionTitle: 'Dodatečné údaje',
					id: 'ID úvěru',
					paymentBankAccountIban: 'Číslo splátkového účtu měsíční splátky',
					createdAt: 'Datum vytvoření',
					productCode: 'Produktový kód',
					productVersion: 'Verze produktu',
				},
				contract: {
					contractNumber: 'Číslo smlouvy',
					loanAgreementSigned: 'Datum podpisu',
					sectionTitle: 'Smlouva',
				},
				documents: {
					sectionTitle: 'Dokumenty',
					noDocuments: 'Žádné dokumenty',
				},
			},
		},
		accountsPage: {
			filter: {
				state: {
					active: 'Aktivní',
					cancelled: 'Zrušené',
				},
			},
			columns: {
				type: 'Typ',
				iban: 'Číslo účtu',
				balance: 'Zůstatek',
				status: 'Stav',
			},
			availableBalance: {
				adjustedBalance: '~ {adjustedBalance:string}',
				adjustedBalanceTooltip: 'Zobrazena částka zůstatku je orientační',
				hiddenBalance: '****,- {currency: string}',
				hiddenBalanceTooltip: 'Zobrazení zůstatku není pro vaši roli povolené',
				accountant: 'účetní {amount: string}',
			},
			multiCurrency: {
				tag: 'Multiměnový',
				overviewIndicator: 'MM',
			},
			smartReserve: {
				tag: 'Chytrá rezerva',
			},
			buttons: {
				generateConfirmation: 'Vygenerovat potvrzení',
				changePaymentLimits: 'Změnit',
				transactionHistory: 'Transakční historie',
				mobilityRequests: 'Žádosti o mobilitu',
				cancelAccount: 'Zrušit',
				markAccountAsBasic: 'Označit jako základní',
				blockAccount: 'Zablokovat',
			},
			accountDetail: {
				sectionTitles: {
					paymentLimits: 'Limity plateb',
					interestRate: 'Úroková sazba',
					interestRateNextMonth: 'Úroková sazba - příští měsíc',
					dispositions: 'Dispozice',
					additionalData: 'Dodatečné údaje',
					smartReserve: 'Chytrá rezerva',
					childToBasicTransition: 'Převod dětského účtu na dospělý',
					termDepositParameters: 'Parametry',
					savingGoal: 'Spořicí cíl',
				},
				buttons: {
					details: 'Podrobnosti',
				},
				labels: {
					accountName: 'Název účtu',
					accountBalanceToDate: 'Zůstatek ke dni',
					accountNumber: 'Číslo účtu',
					coreId: 'DCS ID účtu',
					iban: 'IBAN',
					ccIban: 'Currency Cloud IBAN (SEPA platby)',
					ccIbanSwift: 'SWIFT IBAN',
					ccSwiftCode: 'BIC (SWIFT)',
					accountCurrency: 'Měna účtu',
					creationDate: 'Datum vytvoření',
					closeDate: 'Datum zrušení',
					terminationReason: 'Důvod zrušení',
					accountCreated: 'Účet vytvořen',
					basicAccountIndex: 'Příznak "Základní účet"',
					dailyLimitAmount: 'Výše denního limitu',
					unlimitedLimit: 'Neomezený',
					leftToExhaust: 'Zbývá vyčerpat',
					rate: 'Sazba',
					interestRateWithBonus: 'Úroková sazba včetně zvýhodnění',
					bonusAppliedToBalance: 'Zvýhodnění aplikováno na zůstatek',
					bonusAppliedToBalanceWithMaxThresholdAmount:
						'do {maxThresholdAmount: string} včetně',
					bonusApplied: 'Zvýhodnění aplikováno',
					bonusAppliedToEntireBalance: 'Na celý zůstatek',
					bonusAssignedBasedOnCampaign: 'Zvýhodnění přiděleno na základě akce',
					interestRateBasic: 'Úroková sazba',
					appliedToBalance: 'Aplikováno na zůstatek',
					appliedToBalanceWithMaxThresholdAmount:
						'nad {maxThresholdAmount: string}',
					applied: 'Aplikována',
					interestRateNextMonth: 'Úroková sazba příští měsíc',
					multipleCampaignRatesOverlap:
						'Existuje souběh více kampaňových sazeb',
					unableToDetermine: 'Nelze určit, existuje více kampaňových sazeb',
					plannedBonusNextMonth: 'Plánované zvýhodnění na příští měsíc',
					accountId: 'ID účtu',
					productCode: 'Produktový kód',
					productVersion: 'Verze produktu',
					rateType: {
						base: 'Základní',
						reduced: 'Snížená',
					},
					depositAmount: 'Částka vkladu',
					durationInMonths: 'Délka vázání (měsíce)',
					maturityDate: 'Datum splatnosti',
					savingGoalTargetAmount: 'Cílová částka',
					savingGoalFulfillment: 'Plnění cíle',
				},
				tooltips: {
					ccIbanSwift:
						'SWIFT IBAN (International Bank Account Number) je číslo účtu v mezinárodním formátu. Klient ho potřebuje znát u plateb, kdy mu posílá někdo platbu ze zahraničí.',
					ccSwiftCode:
						'BIC (Bank Identifier Code) je mezinárodní kód, který označuje banku při zahraničních platbách. Používá se společně s SWIFT IBANem.',
				},
				hints: {
					failedToLoadPaymentLimits: 'Limity se nepodařilo načíst',
					failedToLoadInterestRate: 'Úrokovou sazbu se nepodařilo načíst',
					failedToLoadFutureInterestRate:
						'Data pro zobrazení plnění podmínek pro získání základní sazby na příští měsíc se nepodařilo načíst',
				},
				sweep: {
					sectionTitle: 'Hlídání minimálního zůstatku',
					labels: {
						enabled: 'Zapnuto',
						targetAmount: 'Minimální zůstatek',
						sourceAccount: 'Spořící účet, ze kterého se peníze převádějí',
					},
					hints: {
						failedToLoad:
							'Data o nastavení hlídání minimálního zůstatku se nepodařilo načíst',
						previouslySet:
							'Dříve již nastaveno hlídání minimálního zůstatku na {targetAmount: string} na účet {sourceAccount: string}',
					},
				},
				accountDispositionTypes: {
					owner: 'Vlastník',
					ownerChild: 'Vlastník - dítě',
					disponent: 'Disponent',
					disponentPoa: 'Zmocněnec',
				},
				futureInterestRateReasoning: {
					fulfilledByBundle: 'Splňuje podmínky: placený balíček',
					fulfilledByFreshFirstSavingsAccount:
						'Splňuje podmínky: spořicí účet do {firstSavingsAccountDate: string}',
					fulfilledByNumberOfCardPaymentsAndSweep:
						'Splňuje podmínky: platby kartou {numberOfCardPayments: number}/{requiredNumberOfCardPayments: number}, zapnuté hlídání minimálního zůstatku',
					fulfilledByOther: 'Splňuje podmínky: jiná podmínka',
					notFulfilled:
						'Nesplňuje podmínky: platby kartou {numberOfCardPayments: number}/{requiredNumberOfCardPayments: number}',
					notFulfilledWithSweep:
						'Nesplňuje podmínky: platby kartou {numberOfCardPayments: number}/{requiredNumberOfCardPayments: number}, {sweepStatus: string} hlídání minimálního zůstatku',
					sweepEnabled: 'zapnuté',
					sweepDisabled: 'vypnuté',
				},
				smartReserve: {
					couldNotLoadData: 'Informace o chytré rezervě se nepodařilo načíst',
					enabled: 'Zapnuta',
					settingRoundingUpToNearestWholeNumber:
						'Nastavení zaokrouhlení na / Pevná částka navíc',
					linkedAccount: 'Propojený účet',
					previouslySet:
						'Dříve nastavena chytrá rezerva na {targetAmount: string} na účet {sourceAccount: string}',
					previouslySetFromSingleAccount:
						'Dříve nastavena chytrá rezerva na {targetAmount: string} z účtu {currentAccounts: string}',
					previouslySetFromMultipleAccounts:
						'Dříve nastavena chytrá rezerva na {targetAmount: string} z účtů {currentAccounts: string}',
				},
				accountTransitionProcess: {
					labelFromChild: 'Převod z dětského účtu',
					labelToMain: 'Převod na hlavní běžný účet',
					fetchFailed: 'Data se nepodařilo načíst',
					inProgress: 'Probíhá',
					done: 'Dokončen',
					aborted: 'Proces zrušen',
					tooltipStatus: 'Stav převodu',
					tooltipCreatedAt: 'Datum vytvoření',
					tooltipUpdatedAt: 'Datum poslední změny',
					statuses: {
						draft: 'Návrh',
						readyToTransition: 'Připraven na převod',
						signed: 'Převod potvrzen',
						waitingForAml: 'Čeká se na AML',
						documentsSigned: 'Dokumenty podepsány',
						challengesClosed: 'Úkoly zrušeny',
						disponentClosed: 'Disponenství zrušeno',
						cardClosed: 'Karty zrušeny',
						accountTransitioned: 'Účet převeden',
						bundleCreated: 'Balíček vytvořen',
						cardCreated: 'Karta vytvořena',
						transitioned: 'Převod dokončen',
						aborted: 'Převod zrušen',
						unknown: 'Neznámý stav',
					},
				},
				childToBasicTransition: {
					restartButton: 'Restartovat zpracování',
					prepareButton: 'Vytvořit nový požadavek',
					restartSuccess: 'Převod se podařilo restartovat',
					restartError: 'Převod se nepodařilo restartovat',
					prepareSuccess: 'Požadavek na převod vytvořen',
					prepareError: 'Požadavek na převod se nepodařilo vytvořit',
				},
			},
			smartReserveDialog: {
				title: 'Chytrá rezerva',
				settingRoundingUpToNearestWholeNumber:
					'Nastavení zaokrouhlení nahoru na nejbližších',
				fixedAmountInAdditionToSavings: 'Pevná částka navíc ke spoření',
				state: 'Stav',
				smartReserveSavingsState: {
					pendingActivation: 'Probíhá aktivace',
					active: 'Aktivní',
					pendingChange: 'Probíhá změna',
					pendingTermination: 'Probíhá zrušení',
					terminated: 'Zrušená',
				},
				savingsAreMadeFromCurrentAccounts: 'Spoření probíhá z {type: string}',
				smartReserveSavingsType: {
					basic: 'běžných účtů',
					child: 'dětského účtu',
					shared: 'společného účtu',
				},
				savingsAreMadeOnAnAccount: 'Spoření probíhá na účet',
				additionalData: {
					sectionTitle: 'Dodatečné údaje',
					savingsId: 'ID spoření',
					lastSignatureOperationId: 'Poslední ID podpisové operace',
					creationDate: 'Datum vytvoření',
					terminationDate: 'Datum zrušení',
				},
			},
			changePaymentLimitsDialog: {
				title: 'Změnit limity plateb',
				inputLabel: 'Nový denní limit',
				inputPlaceholder: 'Nová výše denního limitu (Kč)',
				toggleLabel: 'Zapnout neomezený limit',
				toggleCaption: 'Na neomezenou dobu do maximální povolené výše',
				hint: 'Tato operace bude poslána klientovi na schválení do mobilní aplikace',
				snackbar: {
					success: 'Změna limitu byla poslána klientovi ke schválení',
					error: 'Limity plateb se nepodařilo změnit',
				},
				paymentLimitValidation: {
					max: 'Maximální povolená výše limitu je {maxPaymentLimit: string} Kč',
					min: 'Minimální povolená výše limitu je {minPaymentLimit: string} Kč',
				},
			},
			generateConfirmationDialog: {
				title: 'Vygenerovat potvrzení',
				selectDocumentTypePlaceholder: 'Vyberte typ dokumentu',
				selectDocumentTypeLabel: 'Typ dokumentu',
				selectDocumentMediaTypePlaceholder: 'Vyberte formát potvrzení',
				selectDocumentMediaTypeLabel: 'Formát potvrzení',
				selectDocumentYearLabel: 'Rok',
				selectDocumentCurrencyLabel: 'Měnová složka',
				currencyCreatedAtCaption:
					'Datum vytvoření měnové složky {createdAt: string}',
				bankDocumentType: {
					AVAILABLE_ACCOUNT_CONFIRMATION: 'Potvrzení o vedení účtu',
					AVAILABLE_BALANCE_CONFIRMATION: 'Potvrzení o zůstatku',
					COMMITMENTS_CONFIRMATION: 'Potvrzení o závazcích',
					DIRECT_DEBIT_CONFIRMATION: 'Potvrzení o souhlasu s inkasem',
					EXAMPLE: 'Příklad',
					FOREIGN_POLICE_CONFIRMATION: 'Potvrzení pro cizineckou policii',
					SIPO_CONFIRMATION: 'Potvrzení o SIPO',
					STANDING_ORDER_CONFIRMATION: 'Potvrzení o trvalém příkazu',
					STATEMENT_OF_FEES: 'Poplatkový výpis',
					STATEMENT_OF_PAYMENTS: 'Transakční výpis',
					TRANSACTION_CONFIRMATION: 'Potvrzení o platbě',
					UNSUPPORTED: 'Nepodporováno',
				},
				errorMessages: {
					dateMustBeTodayOrEarlier:
						'Zvolené datum musí být dnešním nebo dřívějším datem',
					dateMustBeLaterThanFrom:
						"Zvolené datum musí být pozdější než 'od' datum",
					dateMustBeLaterThanAccountCreation:
						'Zvolené datum musí být pozdější než datum vytvoření měnové složky',
					dateFromIsRequired: "Datum 'od' je povinné pole",
					dateToIsRequired: "Datum 'do' je povinné pole",
				},
				snackbar: {
					generationError: 'Dokument se nepodařilo vygenerovat',
					generationSuccess: 'Vygenerování dokumentu bylo dokončeno',
					downloadError: 'Dokument se nepodařilo stáhnout',
				},
				buttons: {
					generate: 'Vygenerovat',
				},
			},

			markAccountAsBasicDialog: {
				title: 'Označit účet jako základní?',
				description: 'Účet {accountNumber: string} bude označen jako základní.',
				snackBar: {
					success: 'Účet označen jako základní',
					error: 'Označení účtu se nepodařilo',
				},
				buttons: {
					mark: 'Označit',
				},
			},
			blockAccountDialog: {
				title: 'Zablokovat účet?',
				descriptionPart1:
					'Účet {accountNumber: string} bude dočasně zablokován pro ',
				descriptionPart2: 'odchozí platby. ',
				descriptionPart3:
					'Blokovány budou všechny platby, včetně trvalých příkazů, inkas, sipo a plateb kartou z daného účtu.',
				noteLabel: 'Poznámka',
				hintPart1: 'Nastavením změníte aktuálně nastavenou blokaci ',
				hintPart2Blocked: 'příchozích a odchozích plateb ',
				hintPart2Inblocked: 'příchozích plateb ',
				hintPart3: 'na účtu.',
				snackBar: {
					success:
						'Požadavek na zablokování účtu zadán. Provedení může trvat několik sekund.',
					error: 'Blokaci účtu se nepodařilo zadat.',
				},
				buttons: {
					set: 'Zablokovat',
				},
			},
			noOpenAccounts: 'Žádné aktivní účty',
			noClosedAccounts: 'Žádné zrušené účty',
			failedToLoadAccounts: 'Účty se nepodařilo načíst',
			distraints: {
				infoPanel: {
					headline: 'Exekuce na účtu ({count: number})',
					oneDistraint: 'Aktuální výše blokace {countText:  string}',
					moreDistraints: 'Celková výše všech blokací {countText: string}',
					detailButton: 'Podrobnosti',
				},
				issuedToAnotherClientInfoPanel: {
					headline: 'Exekuce vydána na klienta {clientName: string}',
					showClientButton: 'Zobrazit klienta',
				},
				dialogTitle: 'Exekuce na účtu {accountNumber: string}',
				table: {
					tableHeader: {
						distraintOrderReferenceNumber: 'Spisová značka a pořadové číslo',
						distraintOrderDate: 'Datum vystavení',
						originalCurrentBlockingAmount: 'Původní / Aktuální výše blokace',
						issuedToAnotherClient: 'Vydána na jiného klienta',
					},
					tableContent: {
						distraintOrderIssuerName: 'Vydal',
						actualHoldDate: 'Datum poslední změny blokace',
						additionalData: 'Dodatečné údaje',
						externalId: 'ID exekuce v Zauzoo',
						coreDistraintHoldId: 'ID blokační transakce v DCS',
						accountDistraintUuid: 'ID blokace na BARu',
					},
				},
			},
			terminationProcess: {
				infoPanel: {
					prepareToClose:
						'Rozpracovaný požadavek na zrušení účtu {terminationSource: string} {terminationReasonCode: string}',
					lastAborted:
						'Poslední přerušený požadavek na zrušení účtu {terminationSource: string} {terminationReasonCode: string}',
					accountCancelled:
						'Účet zrušen {terminationSource: string} {terminationReasonCode: string}',
					detailButton: 'Podrobnosti',
					failedToLoad:
						'Případné požadavky na zrušení účtu se nepodařilo načíst',
				},
				terminationSource: {
					client: 'z podnětu klienta',
					bank: 'z podnětu banky',
					bankCore: 'z podnětu banky (core)',
				},
				terminationReasonCode: {
					feeTooHigh: 'Vysoké poplatky za služby',
					notEnoughProducts: 'Nedostatečná šíře produktů',
					interestRate: 'Výše úrokových sazeb',
					confusing: 'Nevyhovující správa produktu přes aplikaci',
					other: 'Jiné',
					clientRequest: 'Zrušení na žádost klienta',
					aml: 'AML důvody (okamžitě)',
					fraud: 'Podvod (okamžitě)',
					tocViolation: 'Hrubé porušení obchodních podmínek (okamžitě)',
					insolvency: 'Insolvence',
					inheritance: 'Dědictví',
					limitationOfAutonomy: 'Omezení svéprávnosti',
					bankWithNoticePeriod:
						'Ukončení vztahu s klientem (2-měsíční výpovědní lhůta)',
					endOfDistraint: 'Ukončení exekuce',
				},
				cancellationDate:
					'Plánované zrušení ke konci dne {expectedEndDate: string}',
				terminationDialog: {
					termination: 'Zrušení',
					accountCancellationRequirements:
						'Požadavky na zrušení účtu {accountNumber: string}',
					tableHeader: {
						labels: {
							requirement: 'Požadavek',
						},
						requirement:
							'{termination: string} {terminationSource: string} - {terminationReasonCode: string}',
						status: {
							aborted: 'Zrušený',
							closed: 'Dokončený',
							prepareToClose: 'Příprava zrušení',
							readyToClose: 'Čeká na zrušení',
						},
					},
					detail: {
						note: 'Poznámka',
						settlementAccounts: 'Účty pro vypořádání',
						documents: {
							sectionTitle: 'Dokumenty',
							noDocuments: 'Žádné dokumenty',
						},
						additionalInfo: {
							sectionTitle: 'Dodatečné údaje',
							id: 'ID požadavku',
							terminationOriginTitle: 'Zdroj',
							terminationOrigin: {
								be: 'BE',
								boa: 'BOA',
								faa: 'FAA',
								ma: 'Mobilní aplikace',
							},
							createdAt: 'Datum vytvoření',
							signatureOperationId: 'ID podpisové operace',
						},
					},
				},
			},
		},

		cardsPage: {
			filter: {
				state: {
					active: 'Aktivní',
					cancelled: 'Zrušené',
				},
			},
			columns: {
				type: 'Typ',
				cardNumber: 'Číslo karty',
				status: 'Stav',
				validTo: 'Platnost do',
			},
			validToText: 'Platnost do ',
			blockedPin: 'Zablokovaný PIN',
			noOpenCards: 'Žádné aktivní karty',
			noClosedCards: 'Žádné zrušené karty',
			failedToLoadCards: 'Karty se nepodařilo načíst',
			noCardDetail: 'Není detail karty',
			cardDetail: {
				parameters: {
					name: 'Název',
					category: 'Kategorie',
					cardDesign: 'Design karty',
					creationDate: 'Datum vytvoření',
					activationDate: 'Datum aktivace',
					cardBlocked: 'Blokace karty FAU/Policie',
					tokens: 'Počet tokenů (aktivních / celkem)',
					noTokens: 'Žádné tokeny',
				},
				dailyLimit: {
					sectionTitle: 'Limity plateb',
					amountOfTheLimit: 'Výše denního limitu',
					remainsToExhaust: 'Zbývá vyčerpat',
				},
				serviceSettings: {
					sectionTitle: 'Nastavení karty',
					atmTransaction: 'ATM transakce',
					contactlessPayments: 'Bezkontaktní platby',
					onlinePayments: 'Platby přes internet',
					magneticStripePayments: 'Platby přes magnetický proužek',
					currencyConversionPaymentsDCC: 'Platby s převodem měny (DCC)',
					allow: 'Povoleny',
					disallow: 'Zakázány',
					clickToPay: {
						title: 'Click To Pay',
						unknownState: 'Neznámý stav',
						visaStatus: {
							activating: 'Probíhá aktivace',
							active: 'Aktivní',
							disabling: 'Probíhá vypínání',
							disabled: 'Vypnutá',
						},
						tooltip: {
							registeredData: 'Registrované údaje klienta v Click To Pay:',
							name: 'Jméno: {name: string}',
							email: 'E-mail: {email: string}',
							phone: 'Telefonní číslo: {phone: string}',
							address: 'Adresa: {address: string}',
							lastUpdated: 'Poslední aktualizace: {lastUpdated: string}',
						},
					},
				},
				manageTokens: {
					sectionTitle: 'Tokeny',
					titleTooltip:
						'Karetní token je speciální kód vytvořený při nahrání karty do telefonu nebo aplikace. Nahrazuje skutečné údaje karty a používá se při placení. Obchodník dostane pouze tento kód, ne citlivé údaje karty, což zvyšuje bezpečnost.',
					manageTokensButton: 'Přehled tokenů',
				},
				cardDelivery: {
					sectionTitle: 'Doručení karty',
					address: 'Adresa',
					expressDelivery: 'Expresní doručení',
					cardUndeliveredReturnDate: 'Datum vrácení',
					cardUndeliveredReturnCode: 'Důvod vrácení',
					cardUndeliveredReturnCodes: {
						customerHasDied: 'Klient zemřel',
						customerHasMoved: 'Klient se odstěhoval',
						insufficientAddress: 'Nedostatečná adresa',
						otherReason: 'Neznámý',
						unclaimed: 'Klient nevyzvedl',
						undelivered: 'Klient nepřijal',
						unknownCustomer: 'Na adrese není klient známý',
					},
				},
				additionalData: {
					sectionTitle: 'Dodatečné údaje',
					cardToAccount: 'Karta k účtu',
					cardId: 'ID karty',
					freezeDate: 'Datum zablokování',
					terminationDate: 'Datum zrušení',
					terminationType: 'Důvod zrušení',
					replacementBankCardUuid: 'Číslo nahrazené karty',
					terminationTypes: {
						accountTransition: 'Převod účtu',
						client: 'Žádost klienta',
						bank: 'Rozhodnutí banky',
						closingAccount: 'Zrušený účet',
						chargebackFraud: 'Podvod s vratkou platby',
						disposed: 'Provedena autorizace',
						expired: 'Expirace',
						replacedDamaged: 'Náhrada - poškození',
						replacedLost: 'Náhrada - ztráta',
						replacedStolen: 'Náhrada - krádež',
						fraud: 'Podvod',
						undelivered: 'Nedoručena držiteli',
						unknown: 'Neznámý důvod',
					},
				},
				actionButtons: {
					freezeCard: 'Zablokovat',
					unfreezeCard: 'Odblokovat',
					activateCard: 'Aktivovat',
					unblockPinCard: 'Odblokovat PIN',
					servicesSettingsCard: 'Změnit',
					changeLimitCard: 'Změnit',
					terminationCard: 'Zrušit',
					historyOfChangesClickToPay: 'Historie změn Click to Pay',
				},
				dialogs: {
					freezeDialog: {
						title: 'Zablokovat kartu?',
						description:
							'Karta {pan: string} bude dočasně zablokována. Klient ji nebude moci používat.',
						freezeButton: 'Zablokovat',
						cardFreezed: 'Karta byla zablokována',
						cardCouldntBeFreezed: 'Kartu se nepodařilo zablokovat',
					},
					unfreezeDialog: {
						title: 'Odblokovat kartu?',
						description:
							'Po odblokaci karty {pan: string} bude klient moci kartu opět používat.',
						unfreezeButton: 'Odblokovat',
						cardUnfreezed: 'Karta byla odblokována',
						cardCouldntBeUnfreezed: 'Kartu se nepodařilo odblokovat',
					},
					activateCardDialog: {
						title: 'Aktivovat kartu?',
						description:
							'Po aktivaci karty {pan: string} bude moci klient kartu okamžitě používat.',
						activateButton: 'Aktivovat',
						cardActivated: 'Karta byla aktivována',
						cardCouldntBeActivated: 'Kartu se nepodařilo aktivovat',
					},
					unblockPinCardDialog: {
						title: 'Odblokovat PIN?',
						description:
							'Klient bude moci opět používat PIN u karty {pan: string}.',
						unblockPinButton: 'Odblokovat PIN',
						cardUnblockedPin: 'PIN byl odblokován',
						couldntUnblockCardPin: 'PIN se nepodařilo odblokovat',
					},
					servicesSettingsCardDialog: {
						title: 'Změnit nastavení karty',
						description:
							'Změna nastavení proběhne okamžitě bez potvrzení klientem',
						servicesSettingsConfirmButton: 'Nastavit',
						cardServicesSettingsChanged:
							'Nastavení služeb na kartě bylo změněno',
						unableToSetServices:
							'Nastavení služeb se nepodařilo změnit. Zkontrolujte aktuální nastavení karty a případně ho upravte',
						atmTransactions: {
							title: 'ATM transakce',
							description: 'Výběry z bankomatů a platebních terminálů.',
						},
						contactlessTransactions: {
							title: 'Bezkontaktní transakce',
							description: 'Transakce přiložením karty k terminálu.',
						},
						internetPayments: {
							title: 'Platby přes internet',
							description: 'Elektronické platby na e-shopech.',
						},
						magneticStripePayments: {
							title: 'Magnetický proužek',
							description: 'Platby protažením karty přes terminál.',
						},
						dccTransactions: {
							title: 'Platby s převodem měny (DCC)',
							description:
								'Platby v zahraničí s vysokými poplatky za převod měny. Vypnutím budou tyto platby zamítány a klient ušetří.',
						},
					},
					changeLimitDialog: {
						title: 'Změnit limity plateb',
						newDailyLimit: 'Nový denní limit',
						newValueDailyLimit: 'Nová výše denního limitu (Kč)',
						paymentLimitValidation: {
							max: 'Maximální povolená výše limitu je {maxPaymentLimit: string} Kč',
							min: 'Minimální povolená výše limitu je {minPaymentLimit: string} Kč',
						},
						changeWarning:
							'Změna limitu proběhne okamžitě bez potvrzení klientem',
						cardLimitSet: 'Limit na kartě byl změněn',
						unableToSetCardLimit: 'Limit na kartě se nepodařilo změnit',
						confirmButton: 'Nastavit',
					},
					terminationDialog: {
						title: 'Zrušit kartu?',
						description:
							'Karta {pan: string} bude trvale zrušena. Tuto akci nelze vrátit. Klient si v případě zájmu bude muset požádat o novou kartu.',
						terminationButton: 'Zrušit',
						cardTerminated: 'Karta byla zrušena',
						cardCouldntBeTerminated: 'Kartu se nepodařilo zrušit',
					},
					manageTokensCardDialog: {
						title: 'Přehled tokenů ke kartě {pan: string}',
						noTokens: 'Žádné tokeny',
						labels: {
							deviceType: {
								unknown: 'Neznámý typ',
								mobilePhone: 'Mobilní telefon',
								tablet: 'Tablet',
								watch: 'Chytré hodinky',
								mobilePhoneOrTablet: 'Mobilní telefon nebo tablet',
								pc: 'Počítač',
								householdDevice: 'Domácí zařízení',
								wearableDevice: 'Nositelné zařízení',
								automobileDevice: 'Auto',
							},
							panSource: {
								keyEntered: 'Ruční zadání',
								onFile: 'Soubor',
								mobileBankingApp: 'Mobilní bankovnictví',
								chipDip: 'Chip & Dip',
								contactlessTap: 'Bezkontaktní ověření',
								token: 'Token',
							},
							cardTokenStatus: {
								active: 'Aktivní',
								suspended: 'Zablokovaný',
								inactive: 'Neaktivní',
								deactivated: 'Zrušený',
							},
							operationSystem: {
								ios: 'iOS',
								android: 'Android',
								other: 'Neznámý',
							},
						},
						table: {
							columnLabels: {
								cardToken: 'Token',
								cardTokenStatus: 'Stav',
								device: 'Zařízení',
							},
							detailLabels: {
								activationDate: 'Datum aktivace',
								deviceType: 'Typ zařízení',
								source: 'Zdroj',
								operationSystemType: 'Operační systém',
								stepUpMethods: 'Způsob aktivace tokenu',
								declineReason: 'Důvod zamítnutí tokenu',
								tokenReferenceId: 'ID tokenu',
								createdAt: 'Datum vytvoření',
								suspendedDate: 'Datum zablokování',
								terminatedDate: 'Datum zrušení',
							},
							buttons: {
								freeze: 'Zablokovat',
								unfreeze: 'Odblokovat',
								cancel: 'Zrušit',
								activate: 'Aktivovat',
							},
							stepUpMethods: {
								appToApp: 'Aplikace',
								customerService: 'Call centrum',
								otpEmail: 'Email',
								otpSms: 'SMS',
								outboundCall: 'Odchozí hovor',
								unknown: 'Neznámý',
							},
							declineReason: {
								fraudSuspicionCase1: 'Podezřelý případ 1',
								fraudSuspicionCase2: 'Podezřelý případ 2',
								fraudSuspicionCase3: 'Podezřelý případ 3',
								fraudSuspicionCase4: 'Podezřelý případ 4',
								fraudSuspicionCaseUnknown: 'Neznámý typ podvodu',
								maxActiveAndroidTokensReached:
									'Dosažen max počet tokenů pro Android',
								maxActiveIosTokensReached: 'Dosažen max počet tokenů pro iOS',
								maxIncorrectAttemptsCountExceeded: 'Dosažen max počet pokusů',
								suspendedOrTerminatedCard: 'Blokovaná nebo zrušená karta',
								invalidExpirationDate: 'Nesprávné datum expirace karty',
								cvv2Failure: 'Nesprávný CVV kód',
								unknown: 'Neznámý',
								invalidCardType: 'Nesprávný typ karty',
								requestorNotSupported: 'Nepodporovaný žadatel',
								minimalAge: 'Nedostatečný věk klienta',
								checkEligibilityInvalidExpirationDate:
									'Neplatné datum expirace při kontrole způsobilosti',
							},
						},
						confirmationDialog: {
							freeze: {
								title: 'Zablokovat token?',
								description:
									'Klient nebude moci dočasně pomocí tokenu {tokenReferenceId:string} na kartě {cardPan:string} platit.',
								infoBox:
									'Po zablokování dostane klient notifikaci na své zařízení.',
								snackBar: {
									success:
										'Požadavek na zablokování tokenu zadán. Provedení může trvat několik sekund.',
									error: 'Blokaci tokenu se nepodařilo zadat.',
								},
							},
							unfreeze: {
								title: 'Odblokovat token?',
								description:
									'Klient bude moci pomocí tokenu {tokenReferenceId:string} na kartě {cardPan:string} opět platit.',
								infoBox:
									'Po odblokování dostane klient notifikaci na své zařízení.',
								snackBar: {
									success:
										'Požadavek na odblokování tokenu zadán. Provedení může trvat několik sekund.',
									error: 'Odblokaci tokenu se nepodařilo zadat.',
								},
							},
							cancel: {
								title: 'Zrušit token?',
								description:
									'Token {tokenReferenceId:string} na kartě {cardPan:string} bude trvale zrušen. Tato akce je nevratná.',
								infoBox:
									'Po zrušení dostane klient notifikaci na své zařízení.',
								snackBar: {
									success:
										'Požadavek na zrušení tokenu zadán. Provedení může trvat několik sekund.',
									error: 'Zrušení tokenu se nepodařilo zadat.',
								},
							},
							activate: {
								title: 'Aktivovat token?',
								description:
									'Token {tokenReferenceId:string} na kartě {cardPan:string} bude aktivován a klient jej bude moci používat k platbám.',
								infoBox:
									'Po aktivaci dostane klient notifikaci na své zařízení.',
								snackBar: {
									success:
										'Požadavek na aktivování tokenu zadán. Provedení může trvat několik sekund.',
									error: 'Aktivaci tokenu se nepodařilo zadat.',
								},
							},
						},
					},
				},
			},
			cardCategory: {
				plastic: 'Plastová',
				virtual: 'Virtuální',
				virtualOnetime: 'Jednorázová virtuální',
			},
			cardDesign: {
				virtual: 'Virtuální',
				founder: 'Zakladatelská',
				disposable: 'Jednorázová',
				standardDarkBlue: 'Tmavě modrá',
				standardTurquoise: 'Tyrkysová',
				standardWhite: 'Bílá',
				standardCoral: 'Korálová',
				kidsThumbUp: 'Dětská',
				kidsGirl: 'Dětská',
				kidsFlight: 'Dětská',
				kidsSkate: 'Dětská',
				commonLo: 'Běžná',
				commonVe: 'Běžná',
				virtualCoral: 'Virtuální korálová',
				virtualWhite: 'Virtuální bílá',
				virtualDarkBlue: 'Virtuální tmavě modrá',
				virtualGrey: 'Virtuální šedá',
				virtualKidsCoral: 'Virtuální korálová (dětská)',
				virtualKidsDarkBlue: 'Virtuální tmavě modrá (dětská)',
				virtualKidsTurquoise: 'Virtuální tyrkysová (dětská)',
				virtualKidsWhite: 'Virtuální bílá (dětská)',
				disposableGrey: 'Jednorázová šedá',
				disposableKids: 'Jednorázová (dětská)',
				virtualXmas2024: 'Virtuální vánoční 2024',
				virtualCoralXmas2024: 'Virtuální korálová vánoční 2024',
				virtualWhiteXmas2024: 'Virtuální bílá vánoční 2024',
				virtualDarkBlueXmas2024: 'Virtuální tmavě modrá vánoční 2024',
				virtualGreyXmas2024: 'Virtuální šedá vánoční 2024',
				virtualKidsCoralXmas2024: 'Virtuální korálová vánoční 2024 (dětská)',
				virtualKidsDarkBlueXmas2024:
					'Virtuální tmavě modrá vánoční 2024 (dětská)',
				virtualKidsTurquoiseXmas2024:
					'Virtuální tyrkysová vánoční 2024 (dětská)',
				virtualKidsWhiteXmas2024: 'Virtuální bílá vánoční 2024 (dětská)',
				unknownDesign: 'Neznámý design',
			},
		},
		clickToPayPage: {
			pageTitle:
				'{name: string} - Historie změn: Click To Pay na kartě {cardPan: string}',
			noClickToPayHistory: 'Žádné změny Click To Pay',
			failedToLoadClickToPayHistory: 'Data se nepodařilo načíst',
			table: {
				header: {
					type: 'Akce',
					status: 'Stav',
					updatedAt: 'Poslední aktualizace',
				},
				detail: {
					errorMessage: 'Chybová zpráva',
					createdAt: 'Datum vytvoření',
					actionInitializedAt: 'Datum začátku zpracování ',
					processedAt: 'Datum zpracování',
					requestTraceUuid: 'ID akce',
				},
			},
			filter: {
				type: 'Typ',
				status: 'Stav',
				errorMessage: 'Chybová zpráva',
				requestTraceUuid: 'ID akce',
				actionInitializedAt: 'Datum počátku zpracování od',
				processedAt: 'Datum zpracování od',
			},
			types: {
				create: 'Automatické aktivování',
				block: 'Zablokování',
				unblock: 'Odblokování',
				terminate: 'Zrušení',
				customerUpdate: 'Aktualizace klientem',
				customerTerminate: 'Zrušení klienta',
				addressUpdate: 'Aktualizace adresy',
				customerOptIn: 'Aktivování klientem',
				customerOptOut: 'Zrušení klientem',
			},
			statuses: {
				pending: 'Čeká na zpracování',
				processing: 'Probíhá zpracování',
				processingInVisa: 'Probíhá zpracování (Visa)',
				success: 'Dokončena',
				failed: 'Zpracování selhalo',
				obsolete: 'Nerelevantní akce',
			},
		},
		accountStatuses: {
			active: 'Aktivní',
			inblocked: 'Zablokovaný (příchozí platby)',
			outblocked: 'Zablokovaný (odchozí platby)',
			blocked: 'Zablokovaný',
			closed: 'Zrušený',
			readyToClose: 'Čeká na zrušení',
			foreclosure: 'Exekuce',
			inProcessInterference: 'V procesu rušení',
			waitingForPayment: 'Čeká na platbu',
		},
		accountCreationChannels: {
			online: 'Online',
			fip: 'Přes poradce ve FIP',
		},
		paymentCardTypes: {
			common: 'Společná karta',
			disposable: 'Jednorázová virtuální karta',
			kids: 'Dětská karta',
			premium: 'Investorská karta',
			standard: 'Platební karta',
			virtual: 'Virtuální karta',
		},
		paymentCardsStatuses: {
			unactivated: 'Čeká na aktivaci',
			active: 'Aktivní',
			suspended: 'Zablokovaná',
			terminated: 'Zrušená',
		},
		bankInsurancesPage: {
			filter: {
				labels: {
					status: 'Stav smlouvy',
					type: 'Typ smlouvy',
				},
				status: {
					active: 'Aktivní',
					terminated: 'Ukončeno',
					withdrawn: 'Odvoláno',
				},
				type: { travel: 'Cestovní pojištění' },
			},
			productName: 'Název',
			longTermTravelInsurance: 'Celoroční cestovní pojištění',
			noActiveInsurances: 'Žádné aktivní pojištění',
			noClosedInsurances: 'Žádné ukončené pojištění',
			noInsuranceDetail: 'Žádný detail',
			stateTitle: 'Stav',
			inProcessOfTermination: 'V procesu rušení',
			detail: {
				parameters: {
					sectionTitle: 'Parametry pojištění',
					insuranceType: 'Typ pojištění',
					insuranceAmount: 'Výše pojistného',
					paidFromAccount: 'Hrazeno z účtu',
					paymentDate: 'Datum platby',
					paymentDateValue: 'Poslední den v měsíci',
				},
				contract: {
					sectionTitle: 'Smlouva',
					contractNumber: 'Číslo smlouvy',
					contractDate: 'Datum sjednání',
					terminationDate: 'Datum ukončení',
					minimalValidTill: 'Minimální platnost do',
				},
				pricePeriod: {
					monthly: 'měs.',
					quarterly: 'čtvrtletí',
					semiAnnual: 'půlrok',
					annual: 'rok',
				},
				activeTermination: {
					title:
						'Rozpracovaný požadavek na zrušení celoročního cestovního pojištění',
					dateOfTermination:
						'Datum zrušení: {terminationDate: string} (do 24 hodin před zrušením lze požadavek odvolat z mobilní aplikace).',
				},
				actions: {
					transactionHistory: 'Transakční historie',
					terminateInsurance: 'Zrušit pojištění',
					terminateDialog: {
						title: 'Zrušení pojištění',
						reasonLabel: 'Důvod zrušení pojištění',
						reasonTextLabel: 'Poznámka',
						reasonTextRequired: 'Poznámka je povinná při výběru jiného důvodu',
						confirmButton: 'Potvrdit',
						snackBar: {
							success:
								'Celoroční cestovní pojištění bude ukončeno ke dni {terminationDate}',
							error: 'Požadavek na zrušení pojištění se nepodařilo odeslat',
						},
						reasonCodes: {
							bankRequest: 'Zrušení ze strany banky',
							clientRequest: 'Stížnost klienta',
							statutoryPeriod: 'Zrušení produktu ve lhůtě 2 měsíců od sjednání',
							other: 'Jiný důvod',
						},
					},
				},
			},
		},
	},
	clientCryptoAccountPage: {
		title: 'Krypto',
		tabAccount: 'Účet',
		status: 'Stav',
		createdAt: 'Datum vytvoření',
		closedAt: 'Datum zrušení',
		closeReason: 'Důvod zrušení',
		noAccount: 'Žádný účet',
		notEligibleForCreation: 'Klient nesplňuje podmínky pro vytvoření účtu',
		notEligibleForTransactions:
			'Klient nesplňuje podmínky pro budoucí transakce',
		reason: 'Důvod: {reason: string}',
		detailsSection: 'Detail krypto účtu',
		cryptoAccountUuid: 'ID krypto účtu',
		coreAccountId: 'ID účtu v DCS',
		linkedBankAccount: 'Provázaný běžný účet',
		balancesSection: 'Zůstatky kryptoměn',
		statuses: {
			active: 'Aktivní',
			closing: 'Čeká na zrušení',
			closed: 'Zrušený',
		},
		closeReasons: {
			cancellation14: 'Odstoupení od smlouvy ve 14 denní lhůtě',
			unknown: 'Neznámý',
		},
		syncBalancesButton: 'Synchronizovat zůstatky',
		syncBalancesSnackbar: {
			success: 'Zůstatky synchronizovány',
			error: 'Zůstatky se nepodařilo synchronizovat',
		},
		rejectReasons: {
			ageLimit: 'Nezletilý',
			deceased: 'Klient zemřel',
			legalCapacity: 'Nezpůsobilý k právním úkonům',
			riskProfile: 'Rizikový profil',
			basicAccountUnavailable: 'Nedostupný běžný účet',
			basicAccountStatus: 'Nepovolený stav běžného účtu',
			basicAccountOverdraft: 'Běžný účet v debetu',
			distraintProcedure: 'Exekuce',
			pep: 'Politicky exponovaná osoba',
			unknown: 'Neznámý',
		},
	},
	clientMarketingActionsPage: {
		title: 'Marketingové akce',
		failedToLoadMarketingActions: 'Marketingové akce se nepodařilo načíst',
		noMarketingActions: 'Žádné marketingové akce',
		unknownAction: 'Neznámá akce',
		columns: {
			marketingAction: 'Akce',
			status: 'Stav',
			validity: 'Platnost',
			benefit: 'Benefit',
		},
		affectedCampaignType: {
			bundleDiscount: 'sleva na balíček',
			interestRate: 'úroková sazba',
			other: 'Jiná',
		},
		setupMarketingActionButton: 'Nastavit akci',
		editMarketingActionButton: 'Změnit',
		labels: {
			validFrom: 'Platnost od',
			validTo: 'Platnost do',
		},
		filters: {
			titles: {
				actionType: 'Typ akce',
				actionStatus: 'Stav akce',
			},
			labels: {
				actionStatus: {
					active: 'Aktivní',
					scheduled: 'Plánovaná',
					expired: 'Ukončená',
					failed: 'Chyba',
					canceled: 'Zrušená',
				},
			},
		},
		actionType: {
			bundleDiscount: 'Sleva na balíček',
			interestRate: 'Lepší úroková sazba',
			other: 'Jiný typ slevy',
		},
		marketingActionDetail: {
			unknownDetail: 'Neznámý detail',
			failedToLoadMarketingActionDetail: 'Detail akce se nepodařilo načíst',
			additionalData: {
				sectionTitle: 'Dodatečné údaje',
				labels: {
					actionId: 'ID akce',
					specificationId: 'ID specifikace',
					creationDate: 'Datum vytvoření',
					appliedToClients: {
						label: 'Dopad na další klienty',
						values: {
							individual: 'Ne (individuální akce)',
							bundle: 'Ano (všichni klienti v balíčku)',
							other: 'Jiný',
						},
					},
				},
			},
			brokerageDetail: {
				sectionTitle: 'Dopad do provize poradce',
				labels: {
					brokerageDiscountPercent: 'Snížení provize o',
					brokerageDiscountType: {
						label: 'Typ provize',
						values: {
							acquisition: 'Získatelská',
							subsequent: 'Pečovatelská',
							other: 'Jiná',
						},
					},
				},
			},
			bundleDiscountDetail: {
				sectionTitle: 'Detail balíčku',
				labels: {
					currentPrice: 'Cena balíčku po započtení slevy',
					originalPrice: 'Původní cena balíčku',
				},
			},
			interestRateDetail: {
				sectionTitle: 'Úroková sazba',
				labels: {
					currentRate: 'Aktuální úroková sazba',
					appliesUpTo: 'Aplikovaná do výše zůstatku',
					historyButton: 'Historický vývoj',
					historyDialogTitle: 'Historický vývoj úrokových sazeb',
					rate: 'Úroková sazba',
				},
			},
			affectedProductsDetail: {
				affectedProducts: 'Akce aplikována na produkty',
				affectedProductTypes: 'Akce aplikována na typy produktů',
				additionalDataLoadFailed: 'Dodatečná data se nepodařilo načíst',
				affectedProductGroupType: {
					label: 'Akce aplikována na skupinu produktů',
					values: {
						bundle: 'Balíček',
						savings: 'Spořicí účty',
						current: 'Běžné účty',
						other: 'Jiný',
					},
				},
				labels: {
					productType: 'Typ produktu',
					accountNumber: 'Číslo účtu',
					accountName: 'Název účtu',
				},
			},
		},
		tooltips: {
			notDriverClient:
				'Nastavení akce se slevou na balíček je dostupné pouze pod klientem, který je vlastníkem balíčku.',
			hasActiveBundleDiscount: 'Nelze nastavit další akci se slevou na balíček',
		},
		setMarketingActionDialog: {
			title: 'Nastavit marketingovou akci',
			setButton: 'Nastavit',
			free: 'Zdarma',
			params: 'Parametry',
			hint: 'Aktuálně lze nastavovat pouze akce se slevou na balíček',
			labels: {
				action: 'Akce',
				actionPackagePrice: 'Cena balíčku s akcí:',
				advisorCommissionImpact: 'Dopad do provize poradce:',
				validityDate: 'Datum platnosti',
				date: 'Datum',
			},
			snackbar: {
				success: 'Marketingová akce byla nastavena',
				error: 'Marketingovou akci se nepodařilo nastavit',
			},
			validToOptions: {
				unlimited: 'Neomezeně',
				oneYear: '12 měsíců (do {validToDate: string})',
				ownDate: 'Vlastní datum',
			},
		},
		editMarketingActionDialog: {
			title: 'Změnit nastavení marketingové akce',
			editButton: 'Uložit',
			newActionValidity: 'Nová platnost akce',
			labels: {
				action: 'Akce',
				validityDate: 'Datum platnosti',
				date: 'Datum',
			},
			snackbar: {
				success: 'Marketingová akce byla změněna',
				error: 'Marketingovou akci se nepodařilo změnit',
			},
			validToOptions: {
				unlimited: 'Neomezeně',
				oneYear: '12 měsíců',
				ownDate: 'Vlastní datum',
			},
		},
		campaignUsageStatusDialog: {
			title: 'Stav využití akcí Member Get Member',
			noAvailableActions: 'Žádné dostupné akce pro klienta',
			failedToLoad: 'Data se nepodařilo načíst',
			noCampaignUsageDetail: 'Žádné podrobnosti o využití kampaně',
			columns: {
				campaignName: 'Název akce',
				duration: 'Trvání',
				successfulRecommendations: 'Úspěšná doporučení',
			},
			additionalData: {
				sectionTitle: 'Dodatečné údaje',
				labels: {
					campaignCode: 'ID kampaně',
				},
			},
			recommendationCode: 'Doporučovací kód',
			clientsWhoUsedAction: 'Klienti, kteří kód využili',
			clientDataWarning: 'Jména klientů nesmí být klientovi komunikována',
			clientPid: 'PID klienta',
			usageDate: 'Datum využití',
		},
		actionsButton: {
			title: 'Akce',
			usageStatusAction: 'Stav využití akcí Member Get Member',
		},
	},
	clientApplications: {
		title: 'Aplikace',
		failedToLoadActivations: 'Aktivace se nepodařilo načíst',
		horizontalMenuItems: {
			validActivations: 'Platné aktivace {validActivationsCount:number}',
			activationsHistory: 'Historie aktivací {activationHistoryCount:number}',
			psd2ConnectedBanks: 'Připojené banky {psd2ConnectedBanksCount:number}',
			identityVerification:
				'Ověření identity {identityVerificationCount:number}',
		},
		clientActivationsHistory: {
			noHistoricActivations: 'Žádné historické aktivace',
		},
		clientValidActivationsPage: {
			noValidActivations: 'Žádné platné aktivace',
			applicationsTable: {
				additionalData: 'Dodatečné údaje',
				columns: {
					deviceName: 'Název zařízení',
					appVersion: 'Verze aplikace',
					lastUsed: 'Poslední použití',
				},
				statuses: {
					active: 'Aktivní',
					blocked: 'Zablokovaná',
					created: 'Vytvořená',
					pendingCommit: 'Čeká na vytvoření',
					removed: 'Zrušená',
				},
				detail: {
					activationDate: 'Datum aktivace',
					enabledNotifications: 'Povolené notifikace',
					deviceId: 'ID zařízení',
					deviceFingerprint: 'Fingerprint',
				},
				buttons: {
					block: 'Zablokovat',
					unblock: 'Odblokovat',
					remove: 'Odstranit',
				},
				confirmationDialog: {
					block: {
						title: 'Zablokovat aktivaci?',
						description:
							'Aktivace na zařízení {deviceName:string} bude dočasně zablokována. Klient se nebude moci do aplikace přihlásit.',
						snackBar: {
							success: 'Aktivace byla zablokována',
							error: 'Při blokování aktivace nastala chyba',
						},
					},
					unblock: {
						title: 'Odblokovat aktivaci?',
						description:
							'Aktivace na zařízení {deviceName:string} bude odblokována. Klient se bude moci do aplikace opět přihlásit.',
						snackBar: {
							success: 'Aktivace byla odblokována',
							error: 'Při odblokování aktivace nastala chyba',
						},
					},
					remove: {
						title: 'Odstranit aktivaci?',
						description:
							'Aktivace na zařízení {deviceName:string} bude trvale odstraněna. Tuto akci nelze vrátit. Pokud klient nemá jiné platné aktivace, bude muset pro opětovné používání projít novou aktivací aplikace.',
						snackBar: {
							success: 'Aktivace byla odstraněna',
							error: 'Při odstraňování aktivace nastala chyba',
						},
					},
				},
			},
		},
		clientApplicationsNewActivations: {
			status: {
				newAppActivationsAreBlocked: 'Nové aktivace aplikace jsou blokovány',
				newAppActivationsAreBlockedTooltip:
					'Klient nemůže provádět nové aktivace mobilní aplikace ani na stávajícím ani na novém zařízení. Klient může využívat pouze platné aktivace (pokud nejsou již zablokované).',
			},
			blockDialog: {
				title: 'Zablokovat nové aktivace?',
				description:
					'Klient nebude moci dočasně provést novou aktivaci aplikace na stávajícím nebo novém zařízení.',
				blockButton: 'Zablokovat',
				snackbar: {
					success: 'Nové aktivace aplikace jsou zablokovány',
					error: {
						default: 'Nové aktivace aplikace se nepodařilo zablokovat',
						notAcceptable: 'Nové aktivace nelze zablokovat, PID nenalezen.',
						badGateway: 'Nové aktivace nelze zablokovat, neplatný požadavek.',
						conflict: 'Nové aktivace nelze zablokovat, již jsou zablokovány',
					},
				},
			},
			unblockDialog: {
				title: 'Odblokovat nové aktivace?',
				description:
					'Klient bude moci provádět nové aktivace aplikace na stávajícím nebo novém zařízení.',
				unblockButton: 'Odblokovat',
				snackbar: {
					success: 'Nové aktivace aplikace byly odblokovány',
					error: {
						default: 'Nové aktivace aplikace se nepodařilo odblokovat',
						notAcceptable: 'Nové aktivace nelze odblokovat, PID nenalezen.',
						badGateway: 'Nové aktivace nelze odblokovat, neplatný požadavek.',
						conflict: 'Nové aktivace nelze odblokovat, již jsou odblokovány',
					},
				},
			},
			actions: {
				sectionTitle: 'Aktivace',
				blockFutureActivations: 'Zablokovat budoucí aktivace aplikace',
				unblockFutureActivations: 'Odblokovat budoucí aktivace aplikace',
			},
		},
		clientPsd2ConnectedBanksPage: {
			noPsd2ConnectedBanks: 'Žádné připojené banky',
			failedToLoadPsd2ConnectedBanks: 'Připojené banky se nepodařilo načíst',
			connectedBanksTable: {
				bank: 'Banka',
				bankListNames: {
					airbank: 'Air Bank a.s.',
					creditas: 'Banka CREDITAS a.s.',
					csas: 'Česká spořitelna, a.s.',
					csob: 'Československá obchodní banka, a. s.',
					fio: 'Fio banka, a.s.',
					jtb: 'J&T BANKA, a.s., pobočka zahraničnej banky',
					kb: 'Komerční banka, a.s.',
					mbank: 'mBank S.A., organizační složka',
					mockCobs: 'Mock Cobs banka',
					moneta: 'MONETA Money Bank, a.s.',
					raiffeisen: 'Raiffeisenbank a.s.',
					unicredit: 'UniCredit Bank Czech Republic and Slovakia, a.s.',
					unknownBank: 'Neznámá banka',
				},
				detail: {
					revokeButton: 'Odstranit',
					revokeDialog: {
						revokeConnectionTitle: 'Odstranit propojení?',
						revokeConnectionDescription:
							'Propojení s {bankName: string} bude odstraněno. Tuto akci nelze vrátit. Pokud bude chtít klient propojení používat, bude muset projít novým nastavením propojení.',
						snackbarSuccess: 'Propojení odstraněno',
						snackbarError: 'Propojení se nepodařilo odstranit',
					},
				},
				reloadBankListNames: {
					reloadButton: 'Aktualizovat seznam',
					snackbarSuccess: 'Seznam aktualizován',
					snackbarError: 'Seznam se nepodařilo aktualizovat',
				},
			},
		},
	},
	clientBankIdentity: {
		title: 'Bankovní identita',
		clientCanFullUseBankIdentity: 'Klient může plně používat bankovní identitu',
		clientCanPartialUseBankIdentity:
			'Klient může částečně používat bankovní identitu',
		clientCantUseBankIdentity: 'Klient nemůže používat bankovní identitu',
		conditions: {
			clientMeetsConditions:
				'Klient splňuje podmínky pro používání bankovní identity',
			clientMeetsConditionsTooltip:
				'Kontrolované podmínky: 1) Klient je aktuálně klientem banky, 2) Klient je stařší 15 let, 3) Klient je ověřen v základních registrech.',
			clientCanUseBankIdentityInMobileApp:
				'Klient má povoleno používání bankovní identity v mobilní aplikaci',
			clientDataMeetConditionsForAllBankIdentityServices:
				'Klientské údaje splňují podmínky pro všechny služby bankovní identity',
			clientDataMeetConditionsForAllBankIdentityServicesTooltip:
				'Pokud některé klientské údaje chybí nebo nejsou dostatečně ověřeny, může být omezeno používaní některých / všech služeb bankovní identity.',
			clientHasCreatedBankIdentityAndItIsActive:
				'Klient má vytvořenou a aktivní bankovní identitu',
		},
		notEligibleReasons: {
			clientAgeUnderLimit: 'věk pod 15 let',
			clientIsNotBankClient: 'není aktuálně klientem banky',
			clientHasNoBankAifo: 'není ověřen v základních registrech',
		},
		setDisabled: {
			set: 'Nastaveno',
			disabled: 'Zakázáno',
		},
		bankIdInNiaErrors: {
			isBlocked: 'Identita je blokována',
			isNotActive: 'Identita není vytvořena',
		},
		showErrorDataButton: 'Zobrazit chybná data',
		impactOnBankIdServicesTitle: 'Dopad na jednotlivé Bank iD služby',
		impactOnBankIdServices: {
			bankIdConnect: 'Bank iD CONNECT',
			bankIdIdentify: 'Bank iD IDENTIFY',
			bankIdIdentifyAml: 'Bank iD IDENTIFY AML',
			bankIdIdentifyPlus: 'Bank iD IDENTIFY PLUS',
			bankIdSign: 'Bank iD SIGN',
		},
		bankIdServicesOverviewTitle: 'Přehled služeb Bank iD',
		bankIdServicesDescription: {
			bankIdConnect:
				'Služba pro přihlašování k online službám pomocí bankovní identity bez nutnosti zadávat nové přihlašovací údaje, např. přihlašování do zákaznických účtů na soukromých portálech, státní správy nebo firem.',
			bankIdIdentify:
				'Základní ověření totožnosti, které umožňuje přístup k online službám a portálům, např. přihlášení na Portál občana, potvrzení identity na e-shopech nebo přístup k online službám státní správy.',
			bankIdIdentifyPlus:
				'Rozšířené ověření totožnosti s možností právně závazného digitálního podepisování dokumentů, např. uzavírání smluv online, podepisování hypoték, pojištění nebo právní dokumenty s plnou právní váhou.',
			bankIdIdentifyAml:
				'Služba pro ověření totožnosti splňující požadavky zákona proti praní špinavých peněz a financování terorismu, např. registrace na burzách kryptoměn, u investičních firem nebo jiných finančních institucí.',
			bankIdSign:
				'Služba pro digitální podepisování dokumentů s právní váhou, která umožňuje uzavírat smlouvy a podepisovat důležité dokumenty online bez potřeby fyzického podpisu.',
		},
		errorDataTitle: 'Chybná data pro použití v bankovní identitě',
		errorData: {
			name: {
				title: 'Jméno',
				text: 'Chybějící nebo v základních registrech neověřené údaje o jménu',
			},
			email: {
				title: 'E-mail',
				text: 'Chybějící emailová adresa',
			},
			phoneNumber: {
				title: 'Telefon',
				text: 'Chybějící mobilní telefon',
			},
			birthdate: {
				title: 'Datum narození',
				text: 'Chybějící nebo v základních registrech neověřené údaje o datu narození',
			},
			addresses: {
				title: 'Adresy',
				text: 'Chybějící nebo v základních registrech neověřené údaje o trvalé adrese',
			},
			titles: {
				title: 'Tituly',
				text: 'Chybějící tituly před / za jménem',
			},
			gender: {
				title: 'Pohlaví',
				text: 'Chybějící údaje o pohlaví',
			},
			birthNumber: {
				title: 'Rodné číslo',
				text: 'Chybějicí nebo v základních registrech neověřené údaje o rodném čísle',
			},
			paymentAccounts: {
				title: 'Platební účty',
				text: 'Chybějící číslo účtu v Partners Bance',
			},
			birthPlaceNationality: {
				title: 'Místo narození',
				text: 'Chybějící nebo v základních registrech neověřené údaje o místě narození',
			},
			maritalStatus: {
				title: 'Rodinný stav',
				text: 'Chybějící údaje o rodinném stavu',
			},
			idCards: {
				title: 'Doklady',
				text: 'Chybějící nebo v základních registrech nebo Bank iD neověřené údaje o dokladech',
			},
			legalStatus: {
				title: 'Způsobilost k právním úkonům / plnoletost',
				text: 'Chybějící údaje o způsobilosti k právním úkonům nebo plnoletosti',
			},
			verification: {
				title: 'Ověření údajů',
				text: 'Chybějící údaje o ověření údajů klienta',
			},
		},
		errorDataLoading: 'Data o bankovní identitě se nepodařilo načíst',
		blockBankIdentityDialog: {
			title: 'Zablokovat bankovní identitu?',
			description:
				'Klient se nebude moci přes bankovní identitu Partners přihlásit do služeb třetích stran.',
			blockButton: 'Zablokovat',
			snackbar: {
				success:
					'Požadavek na zablokování bankovní identity zadán. Provedení může trvat několik sekund.',
				error: 'Blokaci bankovní identity se nepodařilo zadat.',
			},
		},
		reconcileClientDataInNiaDialog: {
			title: 'Ověřit totožnost?',
			description: 'Bude spuštěno nové ověření totožnosti klienta v NIA.',
			reconcileButton: 'Ověřit totožnost',
			snackbar: {
				success: 'Ověření totožnosti v NIA nastartováno',
				error: 'Ověření totožnosti v NIA se nezdařilo',
			},
		},
		unblockBankIdentityDialog: {
			title: 'Odblokovat bankovní identitu?',
			description:
				'Klient se bude moci přes bankovní identitu Partners opět přihlásit do služeb třetích stran.',
			unblockButton: 'Odblokovat',
			snackbar: {
				success:
					'Požadavek na odblokování bankovní identity zadán. Provedení může trvat několik sekund.',
				error: 'Odblokaci bankovní identity se nepodařilo zadat.',
			},
		},
		historyOfUse: {
			title: 'Historie použití',
			failedToLoadHistory: 'Historii použití se nepodařilo načíst',
			noHistory: 'Žádná historie použití',
			tabs: {
				authoritiesAndTheState: 'Úřady a stát',
				privateCompanies: 'Soukromé firmy',
			},
			authoritiesAndTheStateTab: {
				tableHeader: {
					type: 'Typ',
					date: 'Datum',
				},
				tableContent: {
					identityOfTheCitizen: 'Identita občana',
				},
				filter: {
					eventTimeFrom: 'Datum od',
					eventTimeTo: 'Datum do',
					dateOfUse: 'Datum použití',
				},
			},
			privateCompaniesTab: {
				table: {
					header: {
						clientProviderName: 'Společnost',
						type: 'Typ události',
						createdAt: 'Datum',
					},
					companies: {
						single: '{count: number} společnost',
						few: '{count: number} společnosti',
						plural: '{count: number} společností',
					},
				},
				eventType: {
					login: 'Přihlášení',
					userInfo: 'Informace o uživateli',
					profile: 'Identifikace osoby',
					sign: 'Podpis dokumentu',
					notification: 'Notifikace',
					consentedScopes: 'Udělené souhlasy',
					all: 'Všechny',
				},
				filter: {
					dateOfUse: 'Datum použití',
					type: 'Typ události',
				},
				signDetail: {
					signObjectSection: {
						sectionTitle: 'Podepisované prohlášení',
						hashLabel: 'Hash',
						valueLabel: 'Hodnota',
					},
					documentSection: {
						sectionTitle: 'Podepisovaný dokument',
						titleLabel: 'Název dokumentu',
						createdLabel: 'Datum vytvoření',
					},
					documentsSection: {
						sectionTitle: 'Podepisované dokumenty',
						envelopeNameLabel: 'Název obálky',
						envelopeHashLabel: 'Hash obálky',
						titleLabel: 'Název dokumentu',
						createdLabel: 'Datum vytvoření',
						documentDetailsLabel: 'Informace o dokumentu',
					},
					documentDialog: {
						dialogTitle: 'Informace o dokumentu',
						titleLabel: 'Název dokumentu',
						authorLabel: 'Autor',
						createdLabel: 'Datum vytvoření',
						subjectLabel: 'Obsah dokumentu',
						idLabel: 'ID dokumentu (externí)',
						pagesLabel: 'Počet stran',
						hashLabel: 'Hash',
						closeLabel: 'Zavřít',
					},
				},
				notificationDetail: {
					affectedDataSection: {
						sectionTitle: 'Dotčená data',
						affectedDataLabel: 'Dotčená data',
					},
					informedCompaniesSection: {
						sectionTitle: 'Informované společnosti',
						clientNameLabel: 'Společnost',
						clientTypeLabel: 'Typ společnosti',
						clientIdLabel: 'ID společnosti',
					},
				},
				consentedScopesDetail: {
					affectedScopeSection: {
						sectionTitle: 'Dotčený rozsah',
						affectedScopesLabel: 'Dotčené rozsahy',
					},
				},
				affectedClaims: {
					titlePrefix: 'Titul před jménem',
					titleSufix: 'Titul za jménem',
					givenName: 'Jméno',
					familyName: 'Příjmení',
					middleName: 'Prostřední jméno',
					gender: 'Pohlaví',
					birthdate: 'Datum narození',
					birthnumber: 'Rodné číslo',
					age: 'Věk',
					majority: 'Plnoletost',
					dateOfDeath: 'Datum úmrtí',
					birthplace: 'Místo narození',
					birthcountry: 'Země narození',
					primaryNationality: 'Národnost',
					maritalstatus: 'Rodinný stav',
					addresses: 'Adresy',
					idcards: 'Doklady',
					email: 'Email',
					emailVerified: 'Email ověřen',
					phoneNumber: 'Mobilní telefon',
					phoneNumberVerified: 'Mobilní telefon ověřen',
					pep: 'Politicky exponovaná osoba',
					limitedLegalCapacity: 'Omezení svéprávnosti',
				},
				scopes: {
					openId: 'OpenID Connect',
					offlineAccess: 'Offline přístup',
					profileAddresses: 'Adresy',
					profileBirthdate: 'Datum narození',
					profileBirthNumber: 'Rodné číslo',
					profileBirthplaceNationality: 'Místo narození a národnost',
					profileEmail: 'E-mailová adresa',
					profileGender: 'Pohlaví',
					profileIdCards: 'Doklady totožnosti',
					profileLegalStatus: 'Právní status',
					profileLocale: 'Jazyk',
					profileMaritalStatus: 'Rodinný stav',
					profileName: 'Jméno',
					profilePaymentAccounts: 'Platební účty',
					profilePhoneNumber: 'Telefonní číslo',
					profileTitles: 'Tituly',
					profileUpdatedAt: 'Naposledy aktualizováno',
					profileZoneInfo: 'Časové pásmo',
					profileVerification: 'Status ověření',
					notificationClaimsUpdated: 'Notifikace o aktualizaci údajů',
				},
			},
			progressSection: {
				sectionTitle: 'Průběh',
				eventType: {
					attempt: 'Ověření spuštěno',
					attemptCancelled: 'Ověření zrušeno (v aplikaci)',
					attemptConfirmed: 'Ověření potvrzeno (v aplikaci)',
					succeeded: 'Ověření dokončeno',
					failed: 'Chyba při ověření',
					canceled: 'Ověření zrušeno (neznámý PID)',
					unknown: 'Neznámý krok',
				},
				accordionContent: {
					deviceName: 'Název zařízení',
					verificationInstrument: 'ID ověřovacího prostředku',
					createdAt: 'Datum vytvoření',
					pidUuid: 'PID klienta',
					bsi: 'BSI',
					flowType: 'Typ procesu',
				},
				failedReason: {
					clientNotFound: 'Klient nenalezen',
					optOut: 'Klient má vypnutou bankovní identitu',
					missingVerificationInstrument:
						'Klient nemá evidován verifikační prostředek (aplikaci a doklad)',
					missingBsi: 'Klient nebyl ztotožněn v NIA',
					unknown: 'Neznámá chyba',
				},
			},
			additionalDataSection: {
				sectionTitle: 'Dodatečné údaje',
				activityUuid: 'ID aktivity',
				sessionCode: 'Session kód',
			},
			devicesUsedSection: {
				sectionTitle: 'Použitá zařízení',
				deviceName: 'Název zařízení',
				pidUuid: 'PID klienta',
			},
			infoAboutUserSection: {
				sectionTitle: 'Informace o klientovi',
				name: 'Jméno',
				familyName: 'Příjmení',
				email: 'E-mail',
				phoneNumber: 'Telefon',
				birthdate: 'Datum narození',
				nationalities: 'Státní příslušnost',
			},
			companySection: {
				sectionTitle: 'Společnost',
				clientName: 'Název aplikace',
				clientType: 'Typ společnosti',
				clientId: 'ID společnosti',
				clientTypes: {
					unknown: 'Neznámá',
					bank: 'Banka',
					financialCompany: 'Finanční společnost licencovaná ČNB',
					amlCompany: 'Nefinanční společnost se zákonnou AML povinností',
					publicEntity: 'Veřejnoprávní subjekt',
					nonprofitOrganization: 'Nezisková organizace',
					otherCompany: 'Ostatní',
				},
			},
		},
	},
	clientTransactions: {
		title: 'Transakce',
		horizontalMenuItems: {
			transactionsHistory: 'Historie',
			transactionsFuture: 'Budoucí {count: string}',
			transactionsStanding: 'Trvalé příkazy {count: string}',
			transactionsSIPO: 'SIPO {count: string}',
			transactionsDirectDebits: 'Inkaso {count: string}',
		},
		accountSelectFilter: {
			text: 'Účet:',
			subtitles: {
				activeAccounts: 'Aktivní účty',
				closedAccounts: 'Zrušené účty',
			},
		},
		generateTransactionConfirmation: {
			button: 'Vygenerovat potvrzení',
			disabledTooltip:
				'Generování potvrzení pro daný typ transakce je ve vývoji',
			snackbar: {
				success: 'Potvrzení bylo vygenerováno',
				error: 'Potvrzení se nepodařilo vygenerovat',
				downloadError: 'Potvrzení se nepodařilo stáhnout',
			},
		},
		counterPartyPaymentType: {
			cardTransaction: 'Transakce kartou',
			block: 'Blokace',
			other: 'Transakce',
			zpsTransfer: 'Zahraniční platba',
			zpsFee: 'Poplatek za zahraniční platbu',
			exchange: 'Převod měn',
			transferConversion: 'Platba',
		},
		paymentType: {
			block: 'Blokace',
			cardCashAdvance: 'Výběr hotovosti kartou',
			cardCashback: 'Cashback kartou',
			cardMoneyTransfer: 'Příchozí platba na kartu',
			cardPayment: 'Platba kartou',
			cardRefund: 'Vrácení peněz na kartu',
			cardReturn: 'Vrácení peněz na kartu',
			cardWithdrawal: 'Výběr z bankomatu kartou',
			cardSuperSavingAccount: 'Spoření z platby kartou',
			collection: 'Výběr',
			directDebit: 'Inkaso',
			holdExecution: 'Blokace exekuce',
			holdFauOffice: 'Blokace FAU',
			holdLivingWage: 'Blokace životní minimum',
			holdPolice: 'Blokace policie',
			holdRiskAml: 'Blokace risk/AML',
			holdSettlement: 'Vyrovnání blokace',
			instalment: 'Splátka',
			instantPayment: 'Okamžitá platba',
			negativeInterestCorrection: 'Korekce úroků z úvěru',
			negativeInterest: 'Úrok z úvěru',
			positiveInterestCorrection: 'Korekce úroků z vkladu',
			positiveInterest: 'Úrok z vkladu',
			productPackageFee: 'Poplatek za balíček',
			standingOrder: 'Trvalý příkaz',
			sipo: 'Sipo',
			sweep: 'Hlídání minimálního zůstatku',
			transfer: 'Platba',
			withholdingTax: 'Daň z úroku',
			sepaTransfer: 'SEPA platba',
			cardAccountFunding: 'Platba kartou',
			oneTimeFee: 'Jednorázový poplatek',
			zpsTransfer: 'Zahraniční platba',
			zpsFee: 'Poplatek za zahraniční platbu',
			exchange: 'Převod měn',
			transferConversion: 'Platba',
			balanceRealignment: 'Vyrovnání zůstatku',
			bankInsuranceFee: 'Poplatek za pojištění',
			cryptoAssetsPurchase: 'Nákup kryptoměny',
			cryptoAssetsSale: 'Prodej kryptoměny',
			cryptoAssetsPurchaseFee: 'Poplatek za nákup kryptoměny',
			cryptoAssetsSaleFee: 'Poplatek za prodej kryptoměny',
			tdInitPayment: 'Zřízení termínovaného vkladu',
			tdFinalTransfer: 'Ukončení termínovaného vkladu',
		},
		clientTransactionsHistoryPage: {
			noTransactions: 'Žádné transakce',
			failedToLoadTransactions: 'Transakce se nepodařilo načíst',
			tokenTransaction: 'Token',
			currencyExchangeTopLine: '{fromCurrency: string} → {toCurrency: string}',
			directions: {
				incoming: 'Příchozí',
				outgoing: 'Odchozí',
			},
			paymentGroups: {
				cardTransactions: 'Karetní transakce',
				transfers: 'Převody',
				other: 'Ostatní',
			},
			filter: {
				titles: {
					search: 'Vyhledat',
					direction: 'Směr',
					paymentGroups: 'Skupina transakcí',
					card: 'Karta',
					transactionStatus: 'Stav transakce',
					transactionDate: 'Datum transakce',
					transactionAmount: 'Částka transakce',
				},
				tooltips: {
					search:
						'Vyhledá text v parametrech transakce jako název protistrany, číslo účtu, variabilní / specifický / konstantní symbol, poznámka pro mě nebo zpráva pro příjemce.',
				},
				labels: {
					fullTextSearch: 'Vyhledat v transakci',
					card: 'Karta',
					dateFrom: 'Datum od',
					dateTo: 'Datum do',
					originalCounterpartyNameTooltip:
						'Původní název protistrany: {originalName}',
					clientCounterpartyNameTooltip:
						'Pojmenování protistrany klientem: {name:string}',
					systemCounterpartyNameTooltip:
						'Označení protistrany systémem: {name:string}',
				},
				noData: {
					cards: 'Žádné karty',
				},
				failedToLoadData: {
					cards: 'Karty se nepodařilo načíst',
				},
				noCardChosen: 'Žádná',
			},
			transactionStatus: {
				cancelledByBank: 'Zrušena bankou',
				holded: 'Pozdržená',
				partialRealized: 'Částečně realizovaná',
				readyForRealization: 'Připravena k realizaci',
				realized: 'Realizovaná',
				reverted: 'Vrácená',
				cancelledByClient: 'Zrušena klientem',
				expired: 'Expirovaná',
				rejected: 'Odmítnutá',
				manuallyReleased: 'Ručně uvolněná',
			},
			transactionStatusReason: {
				declinedAtmDisabled: 'Nepovolené ATM výběry',
				declinedCashBackInForeignCurrency:
					'Nepovolený cash back v zahraniční měně',
				declinedContactlessDisabled: 'Nepovolené bezkontaktní platby',
				declinedDailyLimitExceeded: 'Překročen denní limit',
				declinedDccBlocked: 'Nepovolené DCC',
				declinedEcommerceDisabled: 'Nepovolené internetové platby',
				declinedFraudInvestigation: 'Podezření na podvod',
				declinedFrozenCard: 'Zablokovaná karta',
				declinedInsufficientFounds: 'Nedostatek prostředků na účtu',
				declinedMagStripeDisabled: 'Nepovolené použití magnetického proužku',
				declinedMaximalLimitExceeded: 'Překročen maximální limit',
				declinedMccBlocked: 'Nepovolené MCC',
				declinedTerminatedCard: 'Zrušená karta',
				declinedUnactivatedCard: 'Neaktivovaná karta',
				declinedUnexpectedProblem: 'Neočekávaný problém',
				declinedSoftDecline:
					'Vyžadována nová transakce s extra potvrzením klienta',
				distraintTermination: 'Ukončení exekuce',
				expired: 'Expirace',
				expiredCardHold: 'Expirace karetního holdu',
				expiredInsufficientBalance: 'Nedostatečný disponibilní zůstatek',
				manuallyReleased: 'Manuálně uvolněná',
				rejectedFraudDetection: 'Podezření na podvod',
				reverted: 'Vrácená',
				unknown: 'Neznámý',
				invalidCVV2: 'Neplatný CVV kód',
				invalidExpirationDate: 'Nevalidní - expirace',
				invalidPin: 'Nevalidní PIN',
				pinNotAssigned: 'PIN nepřidělen',
			},
			walletType: {
				applePay: 'Apple pay',
				googlePay: 'Google pay',
				garminPay: 'Garmin pay',
				fidesmoPay: 'Fidesmo pay',
				swatchPay: 'Swatch pay',
				clickToPay: 'Click to pay',
				other: 'Jiné',
			},
			transactionDetail: {
				noTransactionsDetail: 'Žádný detail transakce',
				failedToLoadTransactionDetail: 'Detail transakce se nepodařilo načíst',
				accountBalance: 'zůstatek {balance: string}',
				labels: {
					originAccount: 'Z účtu',
					targetAccount: 'Na účet',
					bankCode: 'SWIFT/BIC / kód banky',
					status: 'Status transakce',
					variable: 'Variabilní symbol',
					constant: 'Konstantní symbol',
					specific: 'Specifický symbol',
					message: 'Zpráva pro příjemce',
					noteForMe: 'Poznámka pro mně',
					paymentReference: 'Reference',
					feeType: 'Typ poplatku',
					shaValue: 'SHA',
					valutaDate: 'Datum valuty',
					realizationDate: 'Datum zaúčtování',
					paymentCategory: 'Kategorie plateb',
				},
				counterpartyInfo: {
					title: 'Informace o příjemci',
					labels: {
						recipientName: 'Název příjemce / společnosti',
						street: 'Ulice',
						city: 'Město',
						postcode: 'PSČ',
						country: 'Země',
						province: 'Provincie',
					},
				},
				zpsCounterpartyInfo: {
					outgoingTitle: 'Informace o příjemci',
					incomingTitle: 'Informace o odesílateli',
					labels: {
						recipientName: 'Název příjemce / společnosti',
						senderName: 'Název odesílatele / společnosti',
						street: 'Ulice',
						city: 'Město',
						postcode: 'PSČ',
						country: 'Země',
						province: 'Provincie',
						additionalInfo: 'Další údaje',
					},
				},
				counterpartyBankInfo: {
					title: 'Informace o bance příjemce',
					labels: {
						bankName: 'Název',
						address: 'Adresa',
						country: 'Země',
						accountNumberType: 'Typ účtu',
					},
				},
				additionalData: {
					title: 'Dodatečné údaje',
					labels: {
						transactionId: 'ID transakce',
						cardPan: 'Karta',
						transactionStatusReason: 'Důvod stavu transakce',
						approvedBy: 'Schválil(a)',
						dueDate: 'Datum splatnosti',
						source: 'Zdroj',
						originalCounterpartyName: 'Původní název protistrany',
						clientCounterpartyName: 'Pojmenování protistrany klientem',
					},
					requestedOperation: {
						createPaymentOrder: 'Mobilní aplikace',
						createPaymentOrderFromFip: 'Poradce ve FIPu',
						createPsd2PaymentOrder: 'PSD2',
					},
					approverNames: {
						approved: '{date}, {approver}',
					},
				},
				conversion: {
					title: 'Konverze',
					labels: {
						originalAmount: 'Původní částka',
						exchangeRate: 'Směnný kurz',
						ecbDeviation: 'Odchylka od kurzu ECB',
					},
				},
				paymentCategory: {
					categoryGroup: 'Kategorie - skupina',
					category: 'Kategorie',
					categoryGroups: {
						consumption: 'Spotřeba',
						housingCosts: 'Bydlení',
						financialIndependence: 'Investice a finanční nezávislost',
						shortTermReserve: 'Zajištění a krátkodobá rezerva',
					},
					internalCategories: {
						atm: 'Výběr z bankomatu',
						buildingSavings: 'Stavební spoření',
						consumptionOther: 'Ostatní spotřeba',
						digitalSubscriptions: 'Předplatné a digitální služby',
						education: 'Vzdělání',
						energy: 'Energie',
						entertainment: 'Zábava',
						fashion: 'Oblečení a móda',
						groceries: 'Potraviny',
						healthBeauty: 'Zdraví a krása',
						houseGarden: 'Dům a zahrada',
						householdFees: 'Poplatky',
						householdOther: 'Ostatní bydlení',
						investment: 'Investice',
						investmentsOther: 'Ostatní Investice a finanční nezávislost',
						lifeInsurance: 'Životní pojištění',
						mortgage: 'Hypotéka',
						nonlifeInsurance: 'Neživotní pojištění',
						rent: 'Nájem',
						restaurant: 'Restaurace',
						retirementSavings: 'Penzijní spoření',
						services: 'Služby',
						shortTimeOther: 'Ostatní zajištění a krátkodobá rezerva',
						shortTimeReserve: 'Spoření',
						transportation: 'Doprava',
						vacation: 'Dovolená',
						vice: 'Neřesti',
					},
				},
				buttons: {
					unblockTransaction: 'Uvolnit blokaci',
				},
				unblockTransactionDialog: {
					title: 'Uvolnit blokaci transakce?',
					description:
						'Blokace částky {amount: string} bude uvolněna a prostředky se vrátí klientovi na účet.',
					unblockButton: 'Uvolnit',
					snackbar: {
						success: 'Blokace transakce byla uvolněna',
						error: 'Blokaci transakce se nepodařilo uvolnit',
					},
				},
			},
		},
		clientTransactionsFuturePage: {
			noTransactions: 'Žádné transakce',
			failedToLoadTransactions: 'Transakce se nepodařilo načíst',
			transactionDetail: {
				noTransactionsDetail: 'Žádný detail transakce',
				failedToLoadTransactionDetail: 'Detail transakce se nepodařilo načíst',
				labels: {
					originAccount: 'Z účtu',
					targetAccount: 'Na účet',
					message: 'Zpráva pro příjemce',
				},
				additionalData: {
					title: 'Dodatečné údaje',
					labels: {
						transactionId: 'ID transakce',
					},
				},
			},
		},
		clientStandingOrdersPage: {
			noActiveStandingOrders: 'Žádné aktivní trvalé příkazy',
			noCancelledStandingOrders: 'Žádné zrušené trvalé příkazy',
			failedToLoadStandingOrders: 'Trvalé příkazy se nepodařilo načíst',
			filter: {
				active: 'Aktivní',
				cancelled: 'Zrušené',
			},
			columns: {
				paymentOrder: 'Příkaz',
				amount: 'Částka',
				processStatus: 'Stav',
			},
			processStatus: {
				active: 'Aktivní',
				inactive: 'Pozastavený',
				cancelled: 'Zrušený',
				expired: 'Expirovaný',
			},
			standingOrderType: {
				regular: 'Trvalý příkaz',
				savingGoal: 'Spořicí cíl',
				pocketMoney: 'Kapesné',
			},
			standingOrderDetail: {
				labels: {
					nextPaymentDate: 'Datum příští platby',
					recipientMessage: 'Zpráva pro příjemce',
					messageForSender: 'Zpráva pro mě',
					paymentCodes: {
						variable: 'Variabilní symbol',
						specific: 'Specifický symbol',
						constant: 'Konstantní symbol',
					},
					recipientAccountNumber: 'Číslo účtu příjemce',
				},
				additionalInfo: {
					sectionTitle: 'Dodatečné údaje',
					labels: {
						standingOrderId: 'ID trvalého příkazu',
						firstPaymentDate: 'Datum první platby',
						recipientCategory: 'Kategorie',
					},
				},
				validity: {
					sectionTitle: 'Platnost',
					labels: {
						validFrom: 'Platný od',
						validTo: 'Platný do',
					},
				},
			},
		},
		clientSiposPage: {
			noActiveSipos: 'Žádné aktivní SIPO',
			noCancelledSipos: 'Žádné zrušené SIPO',
			failedToLoadSipos: 'SIPO se nepodařilo načíst',
			filter: {
				active: 'Aktivní',
				cancelled: 'Zrušené',
			},
			columns: {
				name: 'Název',
				amount: 'Částka',
				processStatus: 'Stav',
			},
			labels: {
				amountTo: 'až {amount: string}',
			},
			sipoDetail: {
				labels: {
					connectionNumber: 'Spojovací číslo',
					messageForSender: 'Zpráva pro mě',
				},
				additionalInfo: {
					sectionTitle: 'Dodatečné údaje',
					labels: {
						sipoId: 'ID SIPA',
					},
				},
				validity: {
					sectionTitle: 'Platnost',
					labels: {
						validFrom: 'Platný od',
						validTo: 'Platný do',
					},
				},
			},
		},
		clientDirectDebitsPage: {
			noActiveDirectDebits: 'Žádné aktivní souhlasy s inkasem',
			noCancelledDirectDebits: 'Žádné zrušené souhlasy s inkasem',
			failedToLoadDirectDebits: 'Souhlasy s inkasem se nepodařilo načíst',
			filter: {
				active: 'Aktivní',
				cancelled: 'Zrušené',
			},
			columns: {
				name: 'Název',
				amount: 'Částka',
				processStatus: 'Stav',
			},
			labels: {
				amountTo: 'až {amount: string}',
			},
			directDebitDetail: {
				labels: {
					recipientAccount: 'Účet příjemce',
					recipientMerchantName: 'Název příjemce',
					messageForSender: 'Zpráva pro mě',
					recipientMessage: 'Zpráva pro příjemce',
				},
				additionalInfo: {
					sectionTitle: 'Dodatečné údaje',
					labels: {
						directDebitId: 'ID inkasa',
					},
				},
				validity: {
					sectionTitle: 'Platnost',
					labels: {
						validFrom: 'Platný od',
						validTo: 'Platný do',
					},
				},
			},
		},
		transactionPeriodicity: {
			weekly: 'Týdně',
			monthly: 'Měsíčně',
			quarterly: 'Čtvrtletně',
			semiAnnually: 'Pololetně',
			annually: 'Ročně',
		},
	},
	clientRequirements: {
		title: 'Požadavky',
		bankOperationGroups: {
			payment: 'Platba',
			account: 'Účet',
			card: 'Karta',
			loan: 'Úvěr',
			standingOrder: 'Trvalý příkaz',
			directDebit: 'Inkaso',
			sipo: 'SIPO',
			insurance: 'Pojištění',
			crypto: 'Krypto',
		},
		pidOperationGroups: {
			application: 'Aplikace',
			consulting: 'Poradenství',
		},
		operationTextWithGroupPrefix: '{operationGroup} → {operationText}',
		operations: {
			acceptationFipDocument: 'Podpis dokumentu / smlouvy z FIPu',
			accountLimitSet: 'Změna limitu plateb na účtu',
			activateCard: 'Aktivace karty',
			activationChildApp: 'Aktivace dětské aplikace',
			addDisponentToBankChild: 'Přidání disponenta k dětskému účtu',
			backofficeClientIdentityConfirmation:
				'Potvrzení totožnosti pro vzdálený servis',
			backofficeChangeConsent: 'Změna souhlasu',
			backofficeChangeContactResidence: 'Změna kontaktní adresy',
			bundleChange: 'Změna balíčku',
			buyCrypto: 'Nákup kryptoměny',
			cardsAcsAuthenticationApprove: 'Potvrzení 3D Secure platby (historické)',
			cardsTokenInappVerification: 'Potvrzení karetního tokenu',
			contractSharingInvitation:
				'Potvrzení souhlasu ke sdílení smluv s jiným klientem',
			createDirectDebit: 'Nové inkaso',
			createChallengePaymentOrder: 'Nová výzva',
			createChildDirectDebit: 'Nové inkaso (dítě)',
			createChildPaymentOrder: 'Nová platba (dítě)',
			createChildRegularStandingOrder: 'Nový trvalý příkaz (dítě)',
			createCryptoAccount: 'Založení krypto účtu',
			createMobility: 'Žádost o převod účtu (mobilita)',
			createPaymentOrder: 'Nová platba',
			createPaymentOrderFromFip: 'Nová platba (z FIPu)',
			createPocketMoney: 'Nové kapesné',
			createPsd2SepaPayment: 'Nová PSD2 SEPA platba',
			createPsd2ZpsPayment: 'Nová PSD2 zahraniční platba',
			createProductCurrentAccountBasic: 'Nový běžný účet',
			createProductCurrentAccountChild: 'Nový dětský účet',
			createProductCurrentAccountSecondary: 'Nový vedlejší účet',
			createProductCurrentAccountShared: 'Nový společný účet',
			createProductsFipOnboarding: 'Onboarding žádost z PFS',
			createProductProtectedAccount: 'Nový chráněný účet',
			createProductTermDeposit: 'Nový termínovaný vklad',
			createProductSavingsAccountBasic: 'Nový spořicí účet',
			createProductSavingsAccountChild: 'Nový dětský spořicí účet',
			createProductSavingsAccountShared: 'Nový společný spořicí účet',
			createProductSavingsGoalBasic: 'Nový spořicí cíl',
			createProductSavingsGoalChild: 'Nový dětský spořicí cíl',
			createProductSavingsGoalShared: 'Nový společný spořicí cíl',
			createRegularStandingOrder: 'Nový trvalý příkaz',
			createSavingsGoalStandingOrder: 'Nový trvalý příkaz pro spořicí cíl',
			createSipo: 'Nové SIPO',
			createStandingOrderFromFip: 'Nový trvalý příkaz (z FIPu)',
			createTreasuryForeignPayment: 'Nová zahraniční platba (treasury)',
			createTreasuryPayment: 'Nová TREASURY platba',
			deactivateStandingOrder: 'Pozastavení trvalého příkazu',
			deleteDirectDebit: 'Zrušení inkasa',
			deletePocketMoney: 'Zrušení kapesného',
			deleteSipo: 'Zrušení SIPO',
			deleteStandingOrder: 'Zrušení trvalého příkazu',
			changeCustomAccountName: 'Změna názvu účtu',
			changeProductSavingsAccountChild: 'Změna dětského spořicího účtu',
			changeProductSavingsGoalBasic: 'Změna spořicího cíle',
			changeProductSavingsGoalChild: 'Změna dětského spořicího cíle',
			changeProductSavingsGoalShared: 'Změna společného spořicího cíle',
			changeSavingsAccountBasicParameters: 'Změna parametrů spořicího účtu',
			changeSavingsAccountSharedParameters:
				'Změna parametrů společného spořicího účtu',
			instrumentWithdraw: 'Podepsání příkazu k odkupu investice',
			onboardingDocumentsAgreement:
				'Souhlas s dokumenty při onboardingu (historické)',
			pidOnboardingDocumentsAgreement: 'Souhlas s dokumenty při onboardingu',
			prepareSddPayload: 'Zobrazení citlivých údajů na kartě',
			reactivateChildRegularStandingOrder: 'Obnova trvalého příkazu (dítě)',
			reactivateStandingOrder: 'Obnova trvalého příkazu',
			removeDisponentFromBankChild: 'Odebrání disponenta z dětského účtu',
			stampApsLoanDocument: 'APS dokument (TBD)',
			terminateAccount: 'Zrušení účtu',
			updateDirectDebit: 'Změna inkasa',
			updateChildDirectDebit: 'Změna inkasa (dítě)',
			updateChildRegularStandingOrder: 'Změna trvalého příkazu (dítě)',
			updatePocketMoney: 'Změna kapesného',
			updateSipo: 'Změna SIPO',
			updateStandingOrder: 'Změna trvalého příkazu',
			pidOnboardingChildOnboardingMandate: 'Příkazní smlouva',
			terminateProductProtectedAccount4Eyes: 'Zrušení chráněného účtu',
			terminateProductCurrentAccountBasic4Eyes: 'Zrušení běžného účtu',
			terminateProductCurrentAccountSecondary4Eyes:
				'Zrušení vedlejšího běžného účtu',
			terminateProductCurrentAccountChild4Eyes: 'Zrušení dětského účtu',
			terminateProductCurrentAccountShared4Eyes: 'Zrušení společného účtu',
			terminateProductSavingsAccountBasic4Eyes: 'Zrušení spořicího účtu',
			terminateProductSavingsAccountChild4Eyes:
				'Zrušení dětského spořicího účtu',
			terminateProductSavingsAccountShared4Eyes:
				'Zrušení společného spořicího účtu',
			cancelPaymentOrder: 'Zrušení platby',
			createSepaPayment: 'Nová SEPA platba',
			changeAccountSettings: 'Změna nastavení účtu',
			changeSavingsAccountChildParameters:
				'Změna parametrů dětského spořicího účtu',
			cards3DsRequest: 'Potvrzení 3D Secure platby',
			cardSetLimit: 'Nastavení limitu karty',
			createPsd2PaymentOrder: 'Nová PSD2 platba',
			createPsd2RegularStandingOrder: 'Nový PSD2 trvalý příkaz',
			upsertSweep: 'Aktivace / změna hlídání minimálního zůstatku',
			deactivateSweep: 'Deaktivace hlídání minimálního zůstatku',
			createOdooPayment: 'Nová ODOO platba',
			updatePsd2StandingOrder: 'Změna PSD2 trvalého příkazu',
			deletePsd2StandingOrder: 'Zrušení PSD2 trvalého příkazu',
			createZpsPayment: 'Nová zahraniční platba',
			createProductSupersavings: 'Nová chytrá rezerva',
			changeProductSupersavings: 'Změna chytré rezervy',
			terminateProductSupersavings: 'Zrušení chytré rezervy',
			createPaymentTemplate: 'Nová šablona platebního příkazu',
			updatePaymentTemplate: 'Změna šablony platebního příkazu',
			deletePaymentTemplate: 'Zrušení šablony platebního příkazu',
			createExchangeOrder: 'Nová směna',
			eaLongtermTravelInsuranceCreate: 'Nové cestovní pojištění',
			eaLongtermTravelInsuranceTermination: 'Zrušení cestovního pojištění',
			eaLongtermTravelInsuranceWithdraw: 'Odstoupení od cestovního pojištění',
			childAccountTransition: 'Převod dětského účtu na dospělý',
			sellCrypto: 'Prodej kryptoměny',
			renteaContributionChange: 'Změna příspěvku Rentea',
			emailChange: 'Změna emailu',
			phoneChange: 'Změna telefonu',
			ocpWalletWithdraw: 'Výběr z investiční peněženky (OCP)',
			ocpNonPartnersBankAccountRegistration:
				'Registrace bankovního účtu mimo Partners (OCP)',
			gdprConsent: 'Souhlas s GDPR',
			pidWorkflowDocument: 'Zpracování dokumentu',
			ocpPartnersBankAccountRegistration:
				'Registrace Partners bankovního účtu (OCP)',
			deviceQrNewDeviceApproval: 'Schválení aktivace z druhého zařízení',
			identityVerification: 'Ověření identity',
			unknown: 'Neznámý požadavek',
		},
		operationStatus: {
			waitingForSign: 'Čeká na schválení',
			processing: 'Zpracovává se',
			canceled: 'Zrušený',
			cancelling: 'Ruší se',
			done: 'Dokončený',
			expired: 'Expirovaný',
			expiring: 'Expiruje',
			refused: 'Odmítnutý',
		},
		noRequirements: 'Žádné požadavky',
		failedToLoadRequirements: 'Požadavky se nepodařilo načíst',
		horizontalMenuItems: {
			clientAndIdentity: 'Klient a aplikace',
			bankingProductsAndServices: 'Bankovní produkty a služby',
		},
		filter: {
			all: 'Všechny',
			waitingForApproval: 'Čekající na schválení',
			operationType: 'Typ požadavku',
			operationStatus: 'Stav požadavku',
			selectOperationType: 'Typ',
			noOperationTypes: 'Žádné typy požadavků',
			failedToLoadOperationTypes: 'Typy požadavků se nepodařilo načíst',
		},
		requirementDetail: {
			requirementId: 'ID požadavku',
			expiration: 'Datum expirace',
			document: 'Dokument',
			documents: 'Dokumenty',
			acceptationFipDocument: {
				requestSource: 'Zdroj',
				casId: 'Číslo případu ve FIPu',
				partnerName: 'Název partnera',
				requestName: 'Název požadavku',
			},
			backofficeClientIdentityConfirmation: {
				generatedByTheUser: 'Vygenerováno uživatelem',
				userPID: 'PID uživatele',
				userId: 'UserId uživatele',
			},
			contractSharingInvitation: {
				inviterFullName: 'Majitel smluv',
				inviterPersonalId: 'ID majitele smluv',
				invitedClientFullName: 'Sdílí s klientem',
				invitedClientPersonalId: 'ID klienta',
			},
			addDisponentToBankChild: {
				newDisponentFullName: 'Nový disponent',
				newDisponentPidUuid: 'PID disponenta',
				childFullName: 'Dotčené dítě',
				childPidUuid: 'PID dítěte',
			},
			bundleChange: {
				sourceBundleName: 'Původní balíček',
				targetBundleName: 'Nový balíček',
			},
			createNewPaymentOrder: {
				amount: 'Částka',
				dueDate: 'Datum splatnosti',
			},
			createSepaPayment: {
				amount: 'Částka',
				dueDate: 'Datum splatnosti',
			},
			sweep: {
				iban: 'Číslo běžného účtu',
				sourceAccountUuid: 'ID spořícího účtu',
				targetAmount: 'Výše minimálního zůstatku',
			},
			createPaymentOrderFromFip: {
				createdBy: 'Vytvořil',
			},
			onboardingDocumentsAgreement: {
				documentType: 'Typ dokumentu',
				documentTypes: {
					gdprConsent: 'Skupinový souhlas',
					mobileAppTermsOfUse: 'Podmínky použití mobilní aplikace',
					unknown: 'Neznámý',
				},
			},
			instrumentWithdraw: {
				amount: 'Částka',
				bankAccount: 'Číslo účtu',
				bankAccountCurrencyCode: 'Měna účtu',
				message: 'Zpráva pro příjemce',
				noFees: 'Žádné poplatky',
				note: 'Poznámka',
				isin: 'ISIN',
				sections: {
					recipient: 'Příjemce',
					fees: 'Poplatky',
				},
				withdrawalDate: 'Datum odkupu',
			},
			card3DsRequest: {
				merchantName: 'Název obchodníka',
				purchaseDate: 'Datum nákupu',
				amount: 'Částka',
				pan: 'Číslo karty',
				referenceId: 'ID žádosti',
			},
			createMobility: {
				otherBankAccountNumber: 'Číslo účtu v jiné bance',
				partnersAccountNumber: 'Číslo účtu v Partners',
				mobilityDate: 'Datum mobility',
				mobilityDirection: 'Typ mobility',
				mobilityScope: 'Rozsah',
				oldMobilityScopes: {
					balanceTransferedPayments:
						'Převést aktuální zůstatek a platby (bez zrušení účtu)',
					balanceTransferredCancelAccount:
						'Převést aktuální zůstatek a zrušit účet (bez převodu plateb)',
					balanceTransferredPaymentsCancelAccount:
						'Převést aktuání zůstatek, platby a zrušit účet',
				},
			},
			createZpsPayment: {
				amount: 'Částka',
				dueDate: 'Datum splatnosti',
			},
			eaLongtermTravelInsuranceCreate: {
				productName: 'Název',
				productCode: 'Kód produktu',
				paymentAccountIban: 'Hrazeno z účtu',
				priceAmount: 'Výše pojistného',
				pricePeriod: 'Frekvence',
				validFrom: 'Platnost od',
				sections: {
					insurance: 'Pojistné',
				},
			},
			eaLongtermTravelInsuranceWithdraw: {
				insuranceUuid: 'ID pojištění',
				productCode: 'Kód produktu',
				productName: 'Název',
				insuranceValidFrom: 'Platnost od',
				paymentAccountIban: 'Hrazeno z účtu',
				withdrawalType: 'Důvod odstoupení',
				withdrawalTypes: {
					coolingOffPeriod: 'Odstoupení ve 14 denní lhůtě',
				},
			},
			createCryptoAccount: {
				fullName: 'Jméno klienta',
				activationDate: 'Datum aktivace',
				sections: {
					bankDocuments: 'Bankovní dokumenty',
					thirdPartyDocuments: 'Dokumenty třetí strany',
				},
			},
			buyCrypto: {
				amount: 'Částka celkem',
				dueDate: 'Datum nákupu',
				cryptoCurrency: 'Kryptoměna',
				feeAmount: 'Poplatek',
				feeRate: 'Sazba poplatku',
				netAmount: 'Částka nákupu',
			},
			sellCrypto: {
				feeAmountPercentage: 'Sazba poplatku',
				sellCryptoAmount: 'Prodávané množství',
				sellCryptoCurrency: 'Kryptoměna',
			},
			accountLimitSet: {
				ownerAccountUuid: 'ID účtu',
				newLimitAmount: 'Nový limit',
				infiniteLimit: 'Neomezený limit',
			},
			createProductCurrentAccountBasic: {
				bundle: 'Balíček',
			},
			createProductCurrentAccountShared: {
				passengerPhoneNumber: 'Telefon spoluvlastníka',
			},
			createProductCurrentAccountChild: {
				childPhoneNumber: 'Telefon dítěte',
			},
			createProductsSavingsAccount: {
				sectionTitle: 'Úroková sazba',
				interestRate: 'Základní úroková sazba',
				reducredInterestRate: 'Snížená úroková sazba',
			},
			directDebit: {
				section: {
					title: 'Dotčený účet',
				},
			},
			standingOrder: {
				senderAccountNumber: 'Odesílající účet',
				standingOrderName: 'Název',
				amount: 'Částka',
				periodicity: 'Frekvence',
				recipient: 'Příjemce',
			},
			cardsSetLimit: {
				newLimitAmount: 'Nový limit',
				oldLimitAmount: 'Původní limit',
				bankCardUuid: 'ID karty',
			},
			terminateAccount: {
				accountName: 'Název účtu',
				terminationOrigin: 'Zdroj zrušení',
				targetIban: 'Číslo účtu pro vypořádání zůstatku',
				accountsAffectedByTermination: 'Ostatní rušené účty',
			},
			prepareSddPayload: {
				operation: 'Operace',
				operations: {
					cvc2View: 'Zobrazení CVC2 kódu',
					panView: 'Zobrazení čísla karty',
					pinSet: 'Nastavení PIN kódu',
					pinView: 'Zobrazení PIN kódu',
				},
			},
			productSuperSavings: {
				subsectionAccountsTitle: {
					single: 'Účet, ze kterého se spoří',
					multiple: 'Účty, ze kterých se spoří',
				},
				savingsAccountName: 'Název spořícího účtu',
				savingsAccountUuid: 'ID spořícího účtu',
				accountName: 'Název účtu',
				accountUuid: 'ID účtu',
				roundUpAmount: 'Částka zaokrouhlená nahoru na nejbližších',
				additionalAmount: 'Částka navíc ke spoření',
			},
			createProductTermDeposit: {
				reservedIban: 'Rezervovaný účet',
				deposit: 'Částka vkladu',
				interestRate: 'Úroková sazba',
				durationInMonths: 'Délka vázání (měsíce)',
				maturityDate: 'Datum splatnosti',
				settlementAccountIban: 'Účet vypořádání',
			},
		},
	},
	documents: {
		category: 'Kategorie',
		fileName: 'Jméno souboru',
		tags: 'Tagy',
		description: 'Popis',
		bankTypes: {
			addendumToFrameworkAgreement: 'Dodatek k rámcové smlouvě',
			availableAccountConfirmation: 'Potvrzení o vedení účtu',
			availableBalanceConfirmation: 'Potvrzení o zůstatku',
			commitmentsConfirmation: 'Potvrzení o závazcích',
			complaintsProcedure: 'Reklamační řád',
			directDebitConfirmation: 'Potvrzení inkasa',
			example: 'Příklad',
			foreignPoliceConfirmation: 'Potvrzení pro cizineckou policii',
			frameworkAgreement: 'Rámcová smlouva',
			priceList: 'Ceník',
			sipoConfirmation: 'SIPO potvrzení',
			standingOrderConfirmation: 'potvrzení trvalého příkazu',
			statementOfFees: 'Poplatkový výpis',
			statementOfPayments: 'Transakční výpis',
			termsAndConditions: 'Pravidla a podmínky',
			termsAndConditionsCards: 'Pravidla a podmínky pro karty',
			termsAndConditionsCardsGoogleAndApplePay:
				'Pravidla a podmínky pro Google/Apple pay',
			termsAndConditionsPayments: 'Pravidla a podmínky pro platby',
			transactionConfirmation: 'Potvrzení transakce',
			unsupported: 'Nepodporováno',
			mobilityRequest: 'Žádost o mobilitu',
			interestRates: 'Úroková sazba',
			personalDataProcessingInformation:
				'Informace o zpracování osobních údajů',
			permanentlyAccessibleInformation: 'Trvale přístupné informace',
			termsOfUseMobileApplication: 'Podmínky používání mobilní aplikace',
			groupMarketingConsent: 'Skupinový marketingový souhlas',
			informationOnTheDepositInsuranceSystem:
				'Informace o systému pojištění vkladů',
			mobilityChangeAccount: 'Mobilita - změna účtu',
			mobilityPayers: 'Mobilita - plátce',
			accountTerminationBankImmediateCab: 'Zrušení účtu - okamžité - CAB',
			accountTerminationBankImmediateOther: 'Zrušení účtu - okamžité - jiný',
			accountTerminationBankWithNoticePeriod: 'Zrušení účtu - výpovědní lhůta',
			accountTerminationLimitationOfAutonomy:
				'Zrušení účtu - omezení svéprávnosti',
			cardPaymentConfirmation: 'Potvrzení o platbě kartou',
			domesticPaymentConfirmation: 'Potvrzení o domácí platbě',
			sepaPaymentConfirmation: 'Potvrzení o SEPA platbě',
			foreignPaymentConfirmation: 'Potvrzení zahraniční platby',
			exampleTemplate: 'Ukázková šablona',
			loanInterestRateGuaranteeUnsecured:
				'Zajištění úrokové sazby - nezajištěný',
			loanInterestRateGuaranteeSecured: 'Zajištění úrokové sazby - zajištěný',
			loanIzuUnsecured: 'Úvěr IŽU - nezajištěný',
			loanScheduleUnsecured: 'Úvěrový plán - nezajištěný',
			loanScheduleSecured: 'Úvěrový plán - zajištěný',
			loanEuropeanStandardisedInformationSheetSecured:
				'Evropský standardizovaný informační přehled - zajištěný',
			loanAccessionToDebtAgreementSecured:
				'Smlouva o přistoupení k závazku - zajištěný',
			loanAccessionToDebtAgreementUnsecured:
				'Smlouva o přistoupení k závazku - nezajištěný',
			loanApplicationUnsecured: 'Žádost o úvěr - nezajištěný',
			loanApplicationSecured: 'Žádost o úvěr - zajištěný',
			loanCalculationWhenWithdrawingFromALoan: 'Výpočet při výběru z úvěru',
			loanConfirmationOfCancellationOfApplication: 'Potvrzení zrušení žádosti',
			loanConfirmationOfConsumerLoanRepayment:
				'Potvrzení splacení spotřebitelského úvěru',
			loanConfirmationOfConsumerLoanRepaymentAndTerminationOfTheAccessionObligation:
				'Potvrzení splacení a ukončení závazku',
			loanContractSecured: 'Úvěrová smlouva - zajištěný',
			loanContractUnsecured: 'Úvěrová smlouva - nezajištěný',
			loanEuropeanStandardisedInformationSheetUnsecured:
				'Evropský standardizovaný informační přehled - nezajištěný',
			loanExtraordinaryFullInstalmentCalculation: 'Výpočet mimořádné splátky',
			loanNoticeOfEarlyRepaymentOfConsumerLoanUnsecured:
				'Oznámení o předčasném splacení - nezajištěný',
			loanPreContractualExplanation: 'Předkontraktační vysvětlení',
			loanStandardEuropeanConsumerCreditInformationUnsecured:
				'Standardní evropské spotřebitelské informace - nezajištěný',
			loanConfirmationOfPaidInterestSecured:
				'Potvrzení zaplacených úroků - zajištěný',
			loanAgreement: 'Smlouva o úvěru',
			loanAccessorAgreement: 'Smlouva o přístupu k úvěru',
			loanRefinancingTermination: 'Ukončení refinancování úvěru',
			loanEarlyRepaymentNotice: 'Oznámení o předčasném splacení',
			frameworkAgreementAmendment: 'Dodatek k rámcové smlouvě',
			priceListAmendment: 'Dodatek k ceníku',
			termsAndConditionsAmendment: 'Dodatek k podmínkám',
			termsAndConditionsAdjustment: 'Úprava podmínek',
			termsAndConditionsPaymentsAmendment: 'Dodatek k podmínkám pro platby',
			termsAndConditionsPaymentsAdjustment: 'Úprava podmínek pro platby',
			termsAndConditionsCardsAmendment: 'Dodatek k podmínkám pro karty',
			termsAndConditionsCardsAdjustment: 'Úprava podmínek pro karty',
			other: 'Ostatní',
		},
		clientCategories: {
			accountCancellation: 'Zrušení účtu',
			complaints: 'Reklamace, Stížnosti',
			confirmationStatements: 'Potvrzení, Výpisy',
			contractualDocumentation: 'Smluvní dokumentace',
			drawdownDocumentation: 'Dokumentace k čerpání',
			exceptionDocumentation: 'Podklady pro výjimku',
			incomeDocumentation: 'Dokumentace k příjmům',
			inheritancePowerOfAttorney: 'Dědictví, Plná moc',
			other: 'Ostatní',
			outgoingMobility: 'Mobilita odchozí',
			incomingMobility: 'Mobilita příchozí',
			postDrawdownDocumentation: 'Dokumentace po dočerpání',
			preContractualDocumentation: 'Předsmluvní dokumentace',
			propertyDocumentation: 'Dokumentace k nemovitosti',
		},
		documentsTableComponent: {
			name: 'Název',
			invalidate: 'Zneplatnit',
			expireAt: 'Datum expirace',
			editDialogTitle: 'Změnit informace o dokumentu',
			invalidated: 'Zneplatněný',
			invalidationDialog: {
				title: 'Zneplatnění dokumentu',
				description:
					'Přejete si pokračovat v zneplatnění dokumentu? Akce je nevratná.',
			},
			snackbar: {
				saveSuccess: 'Dokument byl úspěšně upraven',
				saveError: 'Nepodařilo se upravit dokument',
			},
		},
		clientDocumentUploadComponent: {
			dialogTitle: 'Nahrát dokumenty',
			cancelDialog: {
				title: 'Zrušit nahrávání dokumentů?',
				description: 'Přijdete tak o všechny změny.',
			},
			showInMobileApp: 'Zobrazit v mobilní aplikaci',
		},
	},
	appDocumentsUploadDialogComponent: {
		upload: 'Nahrát',
		stateDescriptions: {
			uploading: 'Nahrávám...',
			uploaded: 'Nahráno',
			error: 'Chyba s dokumentem',
		},
	},
	appCopyableTextComponent: {
		textWasCopied: 'Text byl zkopírován',
		textCopyFailed: 'Text se nepodařilo zkopírovat',
	},
	appFilterButtonComponent: {
		inactive: 'Filtry',
		active: 'Filtry aktivní',
	},
	appFilterSelectButtonComponent: {
		text: 'Filtr:',
	},
	verifyIdentityPage: {
		start: {
			title: 'Ověření totožnosti klienta',
			description:
				'Vygeneruje požadavek do mobilní aplikace klienta. Pro pokračování vzdáleného servisu musí klient požadavek potvrdit.',
			startVerification: 'Spustit ověření',
		},
		waiting: {
			title: 'Čekám na potvrzení totožnosti',
			description:
				'Požadavek na ověření byl odeslána do mobilní aplikace klientovi',
		},
		success: {
			title: 'Totožnost potvrzena',
			description: 'Je možné pokračovat v servisu klienta',
		},
		fail: {
			title: 'Totožnost nebyla potvrzena',
			description:
				'Pro pokračování v servisu je potřeba ověřit klienta jiným způsobem',
		},
		alreadyInProgress: {
			title: 'Nelze pokračovat',
			description:
				'Požadavek na ověření totožnosti nelze vytvořit jelikož existuje jiný požadavek, který je potřeba dokončit',
			showRequest: 'Zobrazit požadavek',
		},
		noActiveDevice: {
			title: 'Nelze pokračovat',
			description:
				'Požadavek na ověření totožnosti nelze vytvořit jelikož klient nemá žádné aktivní zařízení, kde by ověření mohl provézt',
		},
	},
	pfsOnboardingApplications: {
		pfsOnboardingApplicationDialog: {
			title: 'Detail žádosti',
		},
		pfsOnboardingApplicationDetail: {
			selectedAccountNumber: 'Vybrané číslo účtu',
			selectedBundle: 'Balíček',
			selectedProductCode: 'Produktový kód běžného účtu',
			applicationExpiration: 'Expirace žádosti',
			applicationUuid: 'ID žádosti',
			fipProcessId: 'ID žádosti ve FIPu',
			virtualCardRequested: 'Virtuální karta požadována',
			standardCardRequested: 'Plastová karta požadována',
			sectionTitles: {
				selectedProducts: 'Vybrané produkty',
				bundle: 'Balíček',
				account: 'Účet',
			},
		},
		pfsOnboardingApplicationProducts: {
			bundleCouple: 'Balíček pro dva',
			bundleFamily: 'Balíček pro rodinu',
			bundleSingle: 'Balíček pro jednoho',
			childCurrentAccount: 'Dětský běžný účet',
			personalCurrentAccount: 'Běžný účet',
			personalSavingAccount: 'Běžný spořicí účet',
			sharedCurrentAccount: 'Společný běžný účet',
			sharedSavingAccount: 'Společný spořicí účet',
		},
		pfsOnboardingApplicationStatuses: {
			accountCreated: 'Účet vytvořen',
			bankProcessing: 'Vyhodnocována bankou',
			bankProcessingPaused: 'Vyhodnocení bankou pozastaveno',
			cancelledByAdvisor: 'Zrušena poradcem',
			cancelledByBank: 'Zrušena bankou',
			cancelledByClient: 'Zrušena klientem',
			completed: 'Dokončena',
			expired: 'Expirovaná',
			expiredNotSigned: 'Expirovaná - nepodepsaná',
			inProgress: 'Rozpracovaná',
			productActivationFailed: 'Aktivace produktu selhala',
			signatureWaitingForClient: 'Čeká na podpis klientem',
			signed: 'Podepsaná',
		},
		pfsOnboardingApplicationBundleProductCodes: {
			bundleCouple: 'Pro pár',
			bundleFamily: 'Pro rodinu',
			bundleIndividual: 'Pro jednoho',
		},
	},
	advisorRightsPage: {
		title: 'Poradce: Nastavení práv',
		infoText: 'Počet nalezených práv: {rightsAmount: number}',
		noData: 'Žádná práva nebyla nalezena',
		failedToLoad: 'Nepodařilo se načíst nastavení práv',
		columns: {
			right: 'Právo',
		},
		roles: {
			administrator: 'Správce',
			guardian: 'Opatrovník',
			shared: 'Nasdíleno',
			service: 'Servis',
			structure: 'Struktura',
			bubble: 'Bublina',
		},
		actions: {
			edit: 'Změnit',
		},
		editDialog: {
			title: 'Změna nastavení práva',
			subtitle: 'Nastavení pro jednotlivé role poradců',
			rightLabel: 'Právo',
			setRight: 'Nastavit',
		},
		snackbars: {
			saveSuccess: 'Změna nastavení práv dokončena',
			saveError: 'Nastavení práv se nepodařilo dokončit',
		},
	},
	advisorClientAccessPage: {
		title: 'Poradce: Přístup na klienty',
		unknownAdvisor: 'Neznámý poradce',
		columns: {
			client: 'Klient',
			address: 'Adresa',
			phone: 'Telefon',
			email: 'E-mail',
		},
		advisorIdLabel: 'ID poradce',
		rolesLabel: 'Role',
		rolesPlaceholder: 'Vyberte role...',
		rolesSelectedPlaceholder: {
			single: '{count: number} role vybrána',
			few: '{count: number} role vybrány',
			plural: '{count: number} rolí vybráno',
		},
		advisorSectionTitle: 'Poradce',
		clientsCount: 'Počet klientů: {count: number}',
		searchResultSection: {
			title: 'Výsledky vyhledávání',
			noClientsText: 'Žádní klienti',
		},
		advisorClientAccessDetail: {
			labels: {
				roles: 'Role',
				definitionUpdated: 'Definice aktualizována',
				birthNumber: 'Rodné číslo',
				birthDate: 'Datum narození',
				idCardNumber: 'Číslo občanského průkazu',
				pidClient: 'PID Klienta',
			},
			advisorRolesSectionTitle: 'Nastavené role poradce',
			buttons: {
				updateClientRights: 'Aktualizovat práva na klienta',
			},
			snackbars: {
				updateSuccess: 'Aktualizace dokončena. Zkuste klienta znovu vyhledat.',
				updateError:
					'Aktualizace neproběhla. Zkontrolujte zadané údaje a případně akci opakujte.',
			},
		},
	},
	onboardingApplicationsPage: {
		title: 'Onboarding z PFS',
		noData: 'Žádné žádosti',
		numberOfApplicationsFound:
			'Počet nalezených žádostí: {applicationsCount: number}',
		labels: {
			product: 'Typ žádosti',
			status: 'Stav žádosti',
			mainClientName: 'Hlavní žadatel',
			createdAt: 'Datum vytvoření',
			expiration: 'Datum expirace',
		},
		values: {
			products: {
				personalCurrentAccount: 'Běžný účet',
			},
			statuses: {
				all: 'Všechny',
			},
		},
		detailPage: {
			title: 'Detail žádosti',
			sections: {
				package: 'Balíček',
				account: 'Účet',
				mainApplicant: 'Hlavní žadatel',
				mobility: 'Mobilita',
				advisorData: 'Údaje o poradcích',
				additionalData: 'Dodatečné údaje',
				processingErrors: 'Chyby zpracování',
			},
			labels: {
				advisorDiscount: 'Sleva poradce',
				reservedAccounts: 'Rezervovaná čísla účtů',
				noMobilityRequested: 'Mobilita nebyla požadována',
				noProcessingErrors: 'Žádné chyby ve zpracování',
				mobilitySelectedAccount: 'Vybraný účet',
				clientPidUuid: 'PID hlavního žadatele',
				accountNumberInAnotherBank: 'Číslo účtu v jiné bance',
				mobilityDate: 'Datum mobility',
				mobilityStatus: 'Stav mobility',
				mobilityScopes: 'Rozsah mobility',
				applicationCreatedBy: 'Žádost založil',
				applicationSignedBy: 'Žádost podepisuje',
				statedOnPaper: 'Na smlouvě bude uveden',
				applicationUuid: 'UUID žádosti',
				processId: 'ID procesu',
				signatureExpirationDate: 'Datum expirace podpisu',
				selectedSignatureMethod: 'Způsob podpisu',
				signOperationUuid: 'ID podpisové operace',
				processingErrors: 'Chyby zpracování',
				errorDate: 'Datum chyby',
				errorDescription: 'Popis chyby',
			},
			format: {
				fipUserWithName: '{name:string} (ID {fipId:number})',
				fipUserIdOnly: 'ID {fipId:number}',
			},
			actions: {
				restartProcessing: 'Restartovat zpracování',
			},
			snackbar: {
				restartProcessingSuccess: 'Zpracování bylo úspěšně restartováno',
				restartProcessingError: 'Při restartování zpracování došlo k chybě',
			},
		},
	},
	activateApplicationsPage: {
		title: 'Aktivace aplikace',
		noActivations: 'Žádné aktivace',
		failedToLoadActivations: 'Aktivace se nepodařilo načíst',
		infoText: 'Počet nalezených aktivací: {activationsAmount:number}',
	},
	identityVerificationPage: {
		title: 'Ověření identity',
		noVerifications: 'Žádné ověření',
		failedToLoadVerifications: 'Ověření se nepodařilo načíst',
		infoText: 'Počet nalezených ověření: {verificationsAmount:number}',
		columns: {
			verification: 'Ověření',
			state: 'Stav',
			creationDate: 'Datum vytvoření',
			client: 'Klient',
		},
		filter: {
			state: 'Stav',
			completionDate: 'Datum poslední aktualizace',
			from: 'Od',
			to: 'Do',
			clientPidUuid: 'PID klienta',
			allStates: 'Vše',
		},
		detail: {
			documentSection: 'Doklad',
			idCardType: 'Typ dokladu',
			idCardNumber: 'Číslo dokladu',
			idCardCountry: 'Země vydání',
			samplesSection: 'Ověřované vzorky',
			sampleType: 'Typ vzorku',
			sampleId: 'ID vzorku',
			deviceSection: 'Zařízení',
			deviceName: 'Název zařízení',
			deviceBrand: 'Značka zařízení',
			deviceId: 'Unikátní ID zařízení',
			deviceIndustrialDesign: 'Označení od výrobce',
			progressSection: 'Průběh',
			additionalInfoSection: 'Dodatečné údaje',
			verificationId: 'ID ověření',
			lastUpdate: 'Poslední aktualizace',
			ocrInvestigationId: 'OCR Investigation ID',
			ocrProfile: 'OCR profil',
			blockageRequired: 'Požadována blokace',
		},
		verificationStates: {
			verificationCreated: 'Vytvořeno',
			signOperationPrepared: 'Čeká na podpis',
			idScanning: 'Probíhá scanování',
			idScanned: 'Naskenováno',
			verificationSuccessful: 'Dokončeno',
			identityVerificationFailed: 'Ověření identity selhalo',
			manualIdentityVerificationRequired: 'K manuálnímu ověření',
			verificationFailed: 'Zamítnuto',
		},
		createVerificationDialog: {
			title: 'Nové ověření identity',
			description:
				'Vytvoří požadavek do mobilní aplikace klienta na doložení fotografie dokladu nebo tváře.',
			blockCheckboxLabel: 'Zablokovat klienta po dobu ověřování',
			createButton: 'Vytvořit',
			snackbar: {
				success: 'Požadavek vytvořen',
				successActionButton: 'Zobrazit požadavek',
				error: 'Požadavek se nepodařilo vytvořit',
			},
		},
		approveDialog: {
			title: 'Schválit ověření?',
			description:
				'Ověření na zařízení {deviceName: string} bude úspěšně dokončeno.',
			descriptionWithoutDevice: 'Ověření bude úspěšně dokončeno.',
			approveButton: 'Schválit',
			snackbar: {
				success: 'Ověření schváleno',
				error: 'Ověření se nepodařilo schválit',
			},
		},
		rejectDialog: {
			title: 'Zamítnout ověření?',
			description: 'Ověření na zařízení {deviceName: string} bude zamítnuto.',
			descriptionWithoutDevice: 'Ověření bude zamítnuto.',
			rejectButton: 'Zamítnout',
			snackbar: {
				success: 'Ověření zamítnuto',
				error: 'Ověření se nepodařilo zamítnout',
			},
		},
		actions: {
			sectionTitle: 'Ověření identity',
			newIdentityVerification: 'Nové ověření identity',
		},
	},
	applicationsActivations: {
		columns: {
			request: 'Aktivace',
			processType: 'Způsob aktivace',
		},
		additionalData: 'Dodatečné údaje',
		activationProgress: 'Průběh aktivace',
		bankIdData: 'Bank iD',
		processId: 'ID procesu',
		fingerprint: 'Fingerprint',
		activationId: 'ID aktivace',
		deviceBrand: 'Značka zařízení',
		deviceId: 'Unikátní ID zařízení',
		deviceIndustrialDesign: 'Označení od výrobce',
		noActivationRequestDetail: 'Žádný detail aktivace',
		phoneNumber: 'Telefonní číslo',
		bankIdElements: {
			bankIdAuthorizationErrorType: 'Chyba při autorizaci',
			bankIdAuthorizationErrorDescription: 'Popis chyby při autorizaci',
			userImportTraceId: 'Trace ID verifikace',
			userVerificationProcess: 'IČO verifikující banky',
			userSub: 'Identifikátor klienta',
			bankTitle: 'Banka použita pro přihlášení',
			consultantId: 'Doporučovací kód / ID poradce',
		},
		identityVerificationElements: {
			identityDocumentProcessingErrorType: 'Chyba při zpracování dokladů',
			deviceBrand: 'Značka zařízení',
			deviceId: 'ID zařízení',
		},
		filters: {
			titles: {
				lastUpdateDate: 'Datum poslední aktualizace',
				activationType: 'Typ aktivace',
				requestStatus: 'Stav aktivace',
				phoneNumber: 'Telefonní číslo',
				deviceName: 'Název zařízení',
				activationName: 'Název aktivace',
			},
			labels: {
				clientPidUuid: 'PID klienta',
				onlyUncompletedActivations: 'Nedokončené',
				manualIdentityVerificationAllowed: 'K manuálnímu ověření',
				allActivationRequestStates: 'Všechny',
				userSub: 'Identifikátor klienta v Bank iD procesu',
			},
			hints: {
				userSub: 'Lze použít pouze pro "Bank iD" typy aktivací',
			},
		},
		processStates: {
			processCreated: 'Proces vytvořen',
			activationInitialized: 'Aktivace spuštěna',
			activationCreated: 'Aktivace vytvořena',
			activationCommitted: 'Aktivace potvrzena',
			documentsToSignPrepared: 'Dokumenty k podpisu připraveny',
			signedDocumentsProcessingFailed: 'Zpracování podpisu selhalo',
			signedDocumentsProcessingCompleted: 'Zpracování podpisu dokončeno',
			processCompleted: 'Proces dokončen',
			processCancelled: 'Proces zrušen',
			userImported: 'Klient nahrán do procesu',
			bankIdAuthorizationFailed: 'Autorizace Bank iD selhala',
			userUpsertInitiated: 'Aktualizace klienta spuštěna',
			userUpsertCompleted: 'Aktualizace klienta dokončena',
			userUpsertFailed: 'Aktualizace klienta selhala',
			identityVerificationInitiated: 'Ověření identity spuštěno',
			identityVerificationCompleted: 'Ověření identity dokončeno',
			identityVerificationFailed: 'Ověření identity selhalo',
			identityVerified: 'Identita ověřena',
			manualIdentityVerificationRequired: 'Manuální ověření identity',
			deviceApproved: 'Zařízení schváleno',
			userPartiallyImported: 'Klient částečně nahrán',
			userVerified: 'Klient ověřen',
			unknown: 'Neznámý',
		},
		aggregatedProcessStates: {
			cancelled: 'Zrušena',
			completed: 'Dokončena',
			expired: 'Expirovaná',
			initiated: 'Spuštěna',
			processingFailed: 'Zpracování selhalo',
			unknown: 'Neznámý krok',
			identityVerified: 'Identita ověřena',
			identityVerificationFailed: 'Ověření identity selhalo',
			manualIdentityVerificationRequired: 'K manuálnímu zpracování',
			userUpsertInitiated: 'Aktualizace klienta spuštěna',
			userUpsertCompleted: 'Aktualizace klienta dokončena',
			userUpsertFailed: 'Aktualizace klienta selhala',
			deviceApproved: 'Zařízení schváleno',
		},
		processTypes: {
			bankIdOnboarding: 'Bank iD onboarding',
			bankIdActivation: 'Bank iD aktivace',
			idScanVerification: 'Verifikace dokladem',
			consultantQrActivation: 'QR kód u poradce',
			deviceQrActivation: 'QR kód z jiného zařízení',
			childOnboarding: 'Onboarding dítěte',

			// Old process types for backward compatibility
			bankId: 'Bank iD',
			identityVerification: 'Ověření dokladu',
			qr: 'QR kód',
		},
		approveActivationDialog: {
			title: 'Schválit aktivaci',
			description: 'Opravdu chcete schválit aktivaci?',
			descriptionWithDeviceName:
				'Opravdu chcete schválit aktivaci na zařízení "{deviceName: string}"?',
			snackbar: {
				success: 'Aktivace byla schválena',
				error: 'Aktivaci se nepodařilo schválit',
			},
			approveButton: 'Schválit',
		},
		rejectActivationDialog: {
			title: 'Zamítnout aktivaci',
			description: 'Opravdu chcete zamítnout aktivaci?',
			descriptionWithDeviceName:
				'Opravdu chcete zamítnout aktivaci na zařízení "{deviceName: string}"?',
			snackbar: {
				success: 'Aktivace byla zamítnuta',
				error: 'Aktivaci se nepodařilo zamítnout',
			},
			rejectButton: 'Zamítnout',
		},
	},
	mobilityRequests: {
		noMobilityRequests: 'Žádné žádosti o mobilitu',
		failedToLoadMobilityRequests: 'Žádosti o mobilitu se nepodařilo načíst',
		mobility: 'Mobilita',
		mobilityContent: '{direction:string} z {accountNumber:string}',
		mobilityDate: 'Datum mobility',
		accountCurrency: 'Měna účtu',
		accountInOtherBank: 'Účet u jiné banky',
		accountInPartners: 'Účet u Partners',
		additionalInformation: 'Dodatečné informace',
		applicationId: 'ID žádosti',
		accountUuid: 'ID účtu',
		idDaktelaTicket: 'ID Daktela ticketu',
		mobilitySource: 'Zdroj mobility',
		mobilitySources: {
			clientMa: 'Klient v mobilní aplikaci',
			onboardingFip: 'Onboarding u poradce',
			userBo: 'Dashboard / BOA',
		},
		mobilityRequestsDialog: {
			title: 'Žádosti o mobilitu',
			newMobilityRequestButton: 'Nová žádost',
			cancellationDate: 'Datum zrušení',
			closingDate: 'Datum dokončení',
			createdByUser: 'Vytvořil(a)',
			cancelledByUser: 'Zrušil(a)',
			closedByUser: 'Dokončil(a)',
			buttons: {
				cancel: 'Zrušit',
				close: 'Dokončit',
			},
			statusChangeDialog: {
				title: 'Změnit stav',
				statusLabel: 'Stav',
				statusHelper: 'Nový stav',
				internalStatusLabel: 'Interní stav zpracování',
				internalStatusNoteLabel: 'Poznámka k internímu stavu',
				amosIdLabel: 'Číslo v AMOS',
				notificationCheckboxLabel: 'Odeslat notifikaci o změně stavu klientovi',
				saveButton: 'Uložit',
				closeButton: 'Zavřít',
				statusOptions: {
					keepInProgress: 'Ponechat "Ve zpracování"',
					close: 'Dokončit',
					cancel: 'Zrušit',
				},
				errorMessage:
					'Nečekaná chyba. Mobilita se nachází ve stavu, který neumožňuje změnu provést. Obraťte se na helpdesk.',
				snackBar: {
					success: 'Mobilita aktualizována',
					error: 'Mobilitu se nepodařilo aktualizovat',
				},
				bulkSnackBar: {
					success: 'Mobility aktualizovány',
					error: 'Mobility se nepodařilo aktualizovat',
					showList: 'Zobrazit seznam',
				},
				bulkWarning:
					'Provádíte hromadnou akci. Změny se uloží do všech žádostí a přepíšou aktuální hodnoty.',
				bulkErrorDialog: {
					title: 'Chyby při aktualizaci mobilit',
					errorCodes: {
						errorMobilityInWrongStatus: 'Špatný stav mobility',
						errorUpdateNotSaved: 'Aktualizaci se nepodařilo uložit',
						errorGetMobility: 'Nepodařilo se získat mobilitu',
						errorUnexpected: 'Neočekávaná chyba',
						errorUnknown: 'Neznámá chyba',
					},
				},
			},
			changeStatusButton: 'Změnit stav',
			bulkActions: {
				button: 'Hromadná akce',
				downloadRequests: 'Stáhnout žádosti',
				changeStatus: 'Změnit stav',
				downloadConfirmation: {
					title: 'Stáhnout žádosti?',
					description:
						'U vybraných mobility budou hromadně staženy dokumenty "Žádost o změnu platebního účtu".',
					downloadButton: 'Stáhnout',
					snackBar: {
						success: 'Žádosti byly staženy',
						error: 'Stažení žádostí se nezdařilo',
					},
				},
			},
			internalStatuses: {
				pendingSendToOriginalBank: 'Čeká na odeslání do původní banky',
				sentToOriginalBank: 'Odesláno do původní banky',
				fourEyesCheck: 'Kontrola nastavení příkazů',
				processed: 'Zpracováno',
				rejectedByOriginalBank: 'Zamítnuto původní bankou',
				rejectedByPartnersBank: 'Zamítnuto Partners bankou',
				cancelledByClient: 'Odvoláno klientem',
			},
			internalStatusBanner: {
				statusLine: 'Upřesnění stavu zpracování: {status:string}',
				noteLine: 'Poznámka: {note:string}',
			},
		},
		uploadPaymentOrders: {
			button: 'Nahrát příkazy',
		},
		documentActions: {
			processPayment: {
				button: 'Spustit vytěžení dokumentu',
				successDialog: {
					title: 'Dokument byl zpracován',
					description:
						'Příkazy byly založeny v DCS aplikaci a čekají na schválení.',
					buttons: {
						openAccountInDCS: 'Otevřít účet v DCS',
					},
				},
				snackBar: {
					error: 'Vytěžení dokumentu se nepodařilo spustit',
				},
			},
			changeStatus: {
				button: 'Dokument zpracován ručně',
				dialogTitle: 'Způsob zpracování',
				description: 'Vyberte způsob zpracování:',
				confirmButton: 'Uložit',
				options: {
					processedManually: 'Příkazy zadány ručně v DCS',
					canceled: 'Zpracování zrušeno',
				},
				snackBar: {
					success: 'Stav dokumentu byl změněn',
					error: 'Změna stavu dokumentu se nezdařila',
				},
			},
		},
		documentStatus: {
			notProcessed: 'Čeká na zpracování',
			processingFailed: 'Nelze zpracovat',
			processed: 'Zpracován {date:string}',
			processingNotPossible: 'Zpracování selhalo. Zkuste znova',
			alreadyProcessed: 'Duplicita k jinému dokumentu',
			invalidClientAccount: 'Nelze zpracovat, chybný účet',
			processedManually: 'Zpracován ručně {date:string}',
			canceled: 'Zpracování zrušeno {date:string}',
			unknown: 'Neznámý stav',
		},
		filter: {
			hasDocumentsPendingProcessing: 'Čekající na zpracování',
		},
	},
	mobilityApplicationsPage: {
		title: 'Žádosti o mobilitu',
		infoText: 'Počet nalezených žádostí: {mobilityRequestAmount:number}',
		applicationStatus: 'Stav žádosti',
		mobilityDirection: 'Typ mobility',
		direction: 'Typ',
		scope: 'Rozsah',
		documents: 'Dokumenty',
		pidUuid: 'PID klienta',
		directions: {
			incoming: 'Příchozí',
			outgoing: 'Odchozí',
		},
		statuses: {
			cancelled: 'Zrušena',
			closed: 'Dokončena',
			draft: 'Návrh',
			expired: 'Expirovaná',
			inProgress: 'Ve zpracování',
			signatureBankProcessing: 'Dokončování žádosti',
			signaturePreparation: 'Příprava žádosti',
			signaturePreparationFailed: 'Příprava žádosti selhala',
			waitingForOnboardingApplication: 'Čeká na dokončení onboardingu',
			waitingForSign: 'Čeká na podpis',
			signatureBankProcessingFailed: 'Dokončování žádosti selhalo',
		},
		mobilityId: 'ID mobility',
		filters: {
			source: 'Zdroj',
			sources: {
				userBo: 'BOA',
				clientMa: 'Klientem v MA',
				onboardingFip: 'FIP onboarding',
			},
			internalStatus: 'Interní stav zpracování',
			documents: 'Dokumenty',
		},
	},
	internalControlsPage: {
		title: 'Interní kontroly',
		noDocuments: 'Žádné dokumenty',
		noInternalControls: 'Žádné interní kontroly',
		noInternalControlsWaitingForSign: 'Žádné interní kontroly ke schválení',
		failedToLoadInternalControls: 'Interní kontroly se nepodařilo načíst',
		infoText: 'Počet nalezených kontrol: {internalControlsAmount:number}',
		request: 'Požadavek',
		settlementAccount: 'Účet pro vypořádání zůstatku',
		account: 'Účet',
		amount: 'Částka',
		approvalHistory: 'Historie schvalování',
		additionalInfo: 'Dodatečné údaje',
		terminationOrigin: 'Zdroj',
		clientPidUuid: 'PID klienta',
		expiration: 'Datum expirace',
		terminatedAccountID: 'ID rušeného účtu',
		operationId: 'ID operace',
		firstSign: 'První podpis',
		secondSign: 'Druhý podpis',
		all: 'Vše',
		approve: 'Schválit',
		decline: 'Zamítnout',
		documents: 'Dokumenty',
		operationStatuses: {
			cancelled: 'Zrušena',
			cancelling: 'V procesu rušení',
			done: 'Dokončena',
			expired: 'Expirovaná',
			expiring: 'V procesu expirace',
			processing: 'V procesu',
			refused: 'Odmítnuta',
			waitingForSign: 'Čeká na schválení',
		},
		operations: {
			terminateProductProtectedAccount4Eyes: 'Zrušení chráněného účtu',
			terminateProductCurrentAccountBasic4Eyes: 'Zrušení běžného účtu',
			terminateProductCurrentAccountSecondary4Eyes:
				'Zrušení vedlejšího běžného účtu',
			terminateProductCurrentAccountChild4Eyes: 'Zrušení dětského účtu',
			terminateProductCurrentAccountShared4Eyes: 'Zrušení společného účtu',
			terminateProductSavingsAccountBasic4Eyes: 'Zrušení spořicího účtu',
			terminateProductSavingsAccountChild4Eyes:
				'Zrušení dětského spořicího účtu',
			terminateProductSavingsAccountShared4Eyes:
				'Zrušení společného spořicího účtu',
			terminateProductTermDeposit4Eyes: 'Zrušení termínovaného vkladu',
		},
		approveSnackBar: {
			success: 'Účet byl zrušen',
			error: 'Při schvalování rušení účtu nastala chyba',
		},
		declineSnackBar: {
			success: 'Zrušení účtu bylo zamítnuto',
			error: 'Při zamítnutí rušení účtu nastala chyba',
		},
	},
	nebankaProductsPage: {
		title: 'Nebanka v aplikaci',
		subTitle: 'Finanční produkty',
		navbar: {
			insurance: 'Pojištění',
			bank: 'Spoření',
			loan: 'Úvěry',
			investment: 'Investice',
		},
		header: {
			advisor: 'Opatrovník jak je uvedeno v aplikaci',
			email: 'Email',
			phone: 'Telefon',
			address: 'Sídlo poradce',
			contractSharing: 'Sdílení dat na analýze',
			details: 'Rozšířené detaily klienta',
		},
		relationships: {
			child: 'Dítě',
			other: 'Ostatní',
			owner: 'Vlastník',
			partner: 'Partner',
		},
		notifications: {
			notificationLog: 'Log notifikací',
			kindColumn: 'Typ',
			dateColumn: 'Datum zpracování',
			statusColumn: 'Stav',
			status: {
				ok: 'Aktualizováno',
				nok: 'Spadlo',
			},
		},
		contractSharingDialog: {
			title: 'Opravdu chcete zrušit sdílení pro {name: string}?',
			description:
				'Pokud zrušíte sdílení dat na analýze, klienti neuvidí vzájemně své smlouvy.',
			ticketPlaceholder: 'Číslo Daktela ticketu',
			confirmButton: 'Ano, zrušit sdílení',
			snackbarSuccess: 'Sdílení dat úspěšně zrušeno.',
		},
		update: 'Aktualizovat data',
		investments: {
			overview: 'Přehled',
			contracts: 'Smlouvy',
			value: 'Hodnota',
			contractNumber: 'Číslo smlouvy',
			absolute: 'Absolutní',
			relative: 'Relativní',
			owner: 'Majitel',
			withoutPartners: 'Investice mimo Partners',
			withoutPartnersInfo:
				'Investice sjednané mimo Partners nejsou zahrnuty v součtech a ani v zhodnocení.',
			summary: {
				currentValueSum: 'Celková hodnota investic',
				asOfDate: 'Stav ze dne',
				appreciation: 'Zhodnocení',
				purchases: 'Nákupy',
				sales: 'Prodeje',
				uninvestedAmount: 'Nezainvestovaná částka',
				uninvestedAmountInfo:
					'Tato částka není zahrnuta v celkové hodnotě investic',
				pendingSales: 'Čekající odkup',
				pendingSalesInfo:
					'Tato částka je zatím zahrnuta v celkové hodnotě investic a není zahrnuta v prodejích.',
				expectedRealizationDate: 'Předpokládaná realizace',
				contractNumber: 'Smlouva číslo',
				pendingSalesModalInfo:
					'Realizace odkupu z fondu Partners Rezerva může trvat 2 až 9 dní. Partners IS realizuje obchody každý čtvrtek, pokyn je třeba podat do úterý.',
			},
			ocpWallets: {
				title: 'Investiční účty',
				titleDip: 'DIP - Investiční účty',
				currentBalance: 'Aktuální zůstatek',
				toggleDetail: 'Detaily investičních účtů',
				tabs: {
					transactionHistory: 'Transakční historie',
					orders: 'Pokyny',
					pendingOrders: 'Neprovedené pokyny ({count: number})',
					canceledOrders: 'Klientem zrušené pokyny ({count: number})',
				},
				interest: 'Úrok',
				transactionHistory: {
					blockedBalanceAmount: 'Blokovaná částka',
					pendingPaymentHintTitle: 'Dlužný poplatek',
					pendingPaymentHintDescription:
						'K uhrazení dojde automaticky po nabití peněženky',
					otherTransactionType: 'Peněžní transakce',
					incomingPayment: 'Příchozí úhrada',
					outgoingPayment: 'Odchozí platba',
					transactionType: {
						bCash: 'Vklad na investiční účet',
						bCashInterest: 'Úrok',
						bCashSettl: 'Vypořádání investice',
						bCashTax: 'Daň z úroku',
						bDepositCash: 'Vklad na investiční účet',
						caBidsCashInc: 'Nabídka k odkupu',
						caCouponCashInc: 'Výnos z kupónu',
						caDecrCashDec: 'Dividenda snížení jmenovité hodnoty',
						caDivCashInc: 'Dividenda',
						caGainCashInc: 'Dividenda kapitálový výnos',
						caInducementsCashInc: 'Výplata pobídky',
						caLiquidationCashInc: 'Likvidace',
						caOtherCashDec: 'Odepsání prostředků',
						caOtherCashInc: 'Připsání prostředků',
						caReinvCashInc: 'Reinvestiční dividenda',
						caShprtCashInc: 'Dividenda emisní ážio',
						caTendDtchCashInc: 'Nabídka k převzetí',
						feeAdmin: 'Administrativní poplatek',
						sfkf: 'Průběžný poplatek',
						sCash: 'Výběr z investičního účtu',
						sCashInterest: 'Úrok',
						sCashSettl: 'Úhrada z pokynu - {isin: string}',
						sCashTax: 'Daň z úroku',
						sDepositCash: 'Výběr z investičního účtu',
					},
				},
				orders: {
					paymentsInNextDays: 'Platby příštích {daysAmount} {{dní}}',
					includingUnrealizedPayments:
						'Včetně nerealizovaných plateb ve výši {amountFormatted}',
					ordersSectionTitle: 'Pokyny',
					oneTimeOrder: 'Jednorázový pokyn',
					regularOrderWithoutFrequency: 'Pravidelný pokyn',
					regularOrder: 'Pravidelný pokyn ({frequency: string})',
					instrumentsValueTitle: 'Hodnota instrumentů v pokynu',
					orderParameters: 'Parametry pokynu',
					paymentDate: 'Datum platby',
					value: 'Hodnota',
					valueSectionTitle: 'Hodnota instrumentu v pokynu',
					parametersSectionTitle: 'Parametry pokynu',
					nextPaymentDate: 'Datum požadované platby',
					investmentHorizon: 'Investiční horizont',
					paymentFrequency: 'Frekvence plateb',
					fundsList: 'Seznam fondů',
					buttons: {
						pause: 'Pozastavit pokyn',
						changePayment: 'Změnit výši plateb',
					},
					insufficientBalanceCaption: 'Chybí prostředky na investičním účtu',
					insufficientBalanceHint:
						'Na provedení dalšího pokynu není na investičním účtu dostatek volných prostředků. Účet je potřeba dobít před datem realizace.',
					pendingOrdersCaption: 'Evidujeme nerealizované transakce',
					pendingOrdersHint:
						'Některou z plateb nebylo možné provést, protože na investičním účtu chyběly peníze. Po dobití investičního účtu bude zpracována nejprve čekající platba.',
				},
				pendingOrders: {
					hint: 'Pro uspokojení neprovedených pokynů je potřeba dobít {amount: string}.',
				},
				canceledOrders: {
					hint: 'Klientem zrušené pokyny již nelze uhradit.',
				},
			},
		},
	},
	accountSearchResultPage: {
		pageTitle: 'Výsledky vyhledávání',
		numberOfAccounts: 'Počet nalezených účtů: {numberOfAccounts:number}',
		labels: {
			accountUuid: 'ID účtu: ',
			iban: 'IBAN: ',
			swiftIban: 'SWIFT IBAN: ',
		},
		dispositionsCount: 'Počet klientů s dispozicemi: {count:number}',
		hiddenClientsWarning:
			'Na zobrazení ostatních klientů nemáte dostatečné oprávnění.',
		account: 'Účet',
	},
	searchResultPage: {
		pageTitle: 'Výsledky vyhledávání',
		numberOfClients: 'Počet nalezených klientů: {numberOfClients:number}',
		noClientFound: 'Žádný klient nenalezen',
		checkYourEntryOrChangeIt: 'Zkontrolujte si zadání nebo ho změňte',
		tableColumns: {
			lastName: 'Příjmení',
			firstName: 'Jméno',
			birthday: 'Datum narození',
			address: 'Adresa',
			contact: 'Kontakt',
		},
		showAllResults: 'Zobrazit všechny klienty',
	},
	eventsPage: {
		title: 'Události',
		infoText: 'Počet nalezených událostí: {eventsAmount:number}',
		noEvents: 'Žádné události',
		failedToLoadEvents: 'Události se nepodařilo načíst',
		horizontalMenuItems: {
			all: 'Všechny',
			clientAndIdentity: 'Klient a identita',
			mobileApplication: 'Mobilní aplikace',
			boaInternal: 'BOA Interní',
			communication: 'Komunikace',
		},
		filter: {
			eventType: 'Typ události',
			client: 'Klient',
			clientPid: 'PID klienta',
			user: 'Uživatel',
			userPid: 'PID uživatele',
			userId: 'UserId uživatele',
			eventDate: 'Datum události',
		},
		eventType: {
			addressChange: 'Změna adresy',
			appActivationCancelled: 'Aktivace aplikace zrušena',
			appActivationCompleted: 'Aktivace aplikace dokončena',
			appActivationFailed: 'Aktivace aplikace selhala',
			appActivationInitiated: 'Aktivace aplikace spuštěna',
			appActivationManuallyVerified: 'Aktivace aplikace manuálně zpracována',
			appActivationStepCompleted: 'Aktivace aplikace - dokončení kroku',
			clientDataHistoryShown: 'Zobrazení historických dat klienta',
			clientDataShown: 'Zobrazení klienta',
			clientLoggedIn: 'Přihlášení do mobilní aplikace',
			clientLoggedOut: 'Odhlášení z mobilní aplikace',
			consentChanged: 'Změna souhlasu',
			deviceActivated: 'Aktivace mobilní aplikace',
			deviceBlocked: 'Zablokování mobilní aplikace',
			deviceRemoved: 'Odstranění mobilní aplikace',
			deviceTemporarilyBlocked: 'Zablokování mobilní aplikace',
			deviceUnblocked: 'Odblokování mobilní aplikace',
			emailChanged: 'Změna emailu',
			phoneChanged: 'Změna telefonu',
			pfsAdvisorRoleSetChanged: 'Změna nastavení práv pro poradce',
			userLoggedIn: 'Přihlášení do BOA',
			userLoggedOut: 'Odhlášení z BOA',
			notificationSent: 'Odeslání notifikace',
			smsSent: 'Odeslání SMS',
			emailSent: 'Odeslání emailu',
			call: 'Hovor',
			maChat: 'Chat v mobilní aplikaci',
			clientAnalysisCreationInPfs: 'Vytvoření analýzy klienta v PFS',
			clientDocumentationSendToPfs: 'Odeslání dokumentace klienta do PFS',
			unknown: 'Neznámá událost',
			noEventTypeChosen: 'Nebyl vybrán typ události',
		},
		eventId: {
			newPaymentToConfirm: 'Platba ke schválení',
			posPurchase: 'Nákup u obchodníka',
			posPurchaseChild: 'Nákup u obchodníka (dítě)',
			cardFrozen: 'Platba nerealizována z důvodu blokované karty',
			cardTerminated: 'Platba nerealizována z důvodu zrušené karty',
			cardTerminated2: 'Platba nerealizována z důvodu zrušené karty',
			atmWithdrawalDisabled: 'Výběry z bankomatu nepovoleny',
			eCommerceDisabled: 'Platby na internetu nepovoleny',
			contactlessDisabled: 'Bezkontaktní platby nepovoleny',
			magneticStripeDisabled: 'Platby magnetickým proužkem nepovoleny',
			mccBlocked: 'Platby s využitím MCC nepovoleny',
			dailyLimitExceeded: 'Nedostatečný denní limit pro platby',
			nonSufficientFunds: 'Nedostatečný zůstatek na účtu',
			pinCounterExceeded: 'Zablokovaný PIN ke kartě',
			cardFrozenFraud: 'Karta zablokována pro podezření na podvod',
			disposableCardTerminated: 'Jednorázová karta zrušena',
			cardCreatedVirtual: 'Virtuální karta vytvořena',
			cardCreatedPlastic: 'Plastová karta ve výrobě',
			cardWithdrawal: 'Výběr kartou',
			cardWithdrawalChild: 'Výběr kartou (dítě)',
			moneyTransfer: 'Převod peněz na kartu',
			moneyTransferChild: 'Převod peněz na kartu (dítě)',
			dccBlocked: 'Platba zamítnuta z důvodu nevýhodného kurzu',
			dccBlocked2: 'Platba zamítnuta z důvodu nevýhodného kurzu',
			acsAuthenticate: 'Potvrzení platby u obchodníka',
			incomingPayment: 'Příchozí platba',
			outgoingPayment: 'Odchozí platba',
			incomingPaymentGeneral: 'Příchozí platba',
			outgoingPaymentGeneral: 'Odchozí platba',
			paymentOrderCancellation: 'Platební příkaz zrušen',
			paymentToSign: 'Platba od dítěte ke schválení',
			childPaymentApproved: 'Platba schválena (dítě)',
			cardRefund: 'Vrácení prostředků na kartu',
			cardRefund2: 'Vrácení prostředků na kartu',
			maximalLimitExceeded: 'Platba nerealizována z důvodu překročení limitu',
			cardNotRenewed: 'Blížící se konec platnosti karty',
			cardUnactivated: 'Karta musí být aktivována',
			cashbackForeignCurrency: 'Cashback v zahraničí nepovolen',
			childPaymentCanceled: 'Platba zamítnuta (dítě)',
			childCardFrozen: 'Karta zablokována (dítě)',
			childAtmWithdrawalDisabled: 'Výběry z bankomatu nepovoleny (dítě)',
			childECommerceDisabled: 'Platby na internetu nepovoleny (dítě)',
			childContactlessDisabled: 'Bezkontaktní platby nepovoleny (dítě)',
			childMagneticStripeDisabled:
				'Platby magnetickým proužkem nepovoleny (dítě)',
			childMccBlocked: 'Použití s využitím MCC nepovoleny (dítě)',
			childDailyLimitExceeded: 'Nedostatečný denní limit pro platby (dítě)',
			childNonSufficientFunds: 'Nedostatečný zůstatek na účtu (dítě)',
			childPinCounterExceeded: 'Zablokovaný PIN ke kartě (dítě)',
			childCardFrozenFraud: 'Karta zablokována pro podezření na podvod (dítě)',
			childCardUnactivated: 'Karta musí být aktivována (dítě)',
			childCashbackForeignCurrency: 'Cashback nepovolen (dítě)',
			childPaymentExpiredParent: 'Platba expirovala u rodiče (dítě)',
			childPaymentExpired: 'Platba zamítnuta (dítě)',
			newIndividualPaymentToConfirm: 'Platba ke schválení',
			newStandingOrderToConfirm: 'Trvalý příkaz ke schválení',
			cardRefundAccepted: 'Vrácení prostředků na kartu realizováno',
			appChatMessage: 'Zpráva v aplikaci',
			unexpectedProblem: 'Něco se pokazilo',
			unexpectedProblem2: 'Něco se pokazilo',
			cardHoldExpired: 'Vracíme peníze',
			cardHoldExpired2: 'Vracíme peníze',
			cardTokenActivated: 'Karetní token přidán do aplikace',
			cardTokenActivated2: 'Karetní token přidán do aplikace',
			cardUnactivatedTransactionOverLimit: 'Platba nerealizována',
			cardUnactivatedTransactionOverLimitChild: 'Platba nerealizována (dítě)',
			smsCheckCard: 'Jednorázový kód pro přidání karty do peněženky',
			smsCheckCard2: 'Jednorázový kód pro přidání karty do peněženky',
			treasuryTransactionCreated: 'Treasury transakce ke schválení',
			tokenNotActivated: 'Platba nerealizována z důvodu neaktivního tokenu',
			cardTerminatedUndelivered: 'Karta zrušena z důvodu nedoručení',
			childStandingOrderToConfirm: 'Trvalý příkaz ke schválení',
			childStandingOrderConfirmed: 'Trvalý příkaz schválen (dítě)',
			childStandingOrderExpiredParent:
				'Trvalý příkaz expiroval u rodiče (dítě)',
			childStandingOrderExpiredChild: 'Trvalý příkaz zamítnut (dítě)',
			childStandingOrderRequestRejectedChild: 'Trvalý příkaz zamítnut (dítě)',
			childDirectDebitToConfirm: 'Inkaso ke schválení',
			childDirectDebitConfirmed: 'Inkaso schváleno (dítě)',
			childDirectDebitExpiredParent: 'Inkaso expirovalo u rodiče (dítě)',
			childDirectDebitExpiredChild: 'Inkaso expirovalo (dítě)',
			childDirectDebitRequestRejectedChild: 'Inkaso zamítnuto (dítě)',
			cardCreatedDisposable: 'Jednorázová karta vytvořena',
			childPaymentRequestRefused: 'Platba zamítnuta (dítě)',
			outgoingPaymentSEPA: 'Odchozí SEPA platba',
			incomingPaymentSEPA: 'Příchozí SEPA platba',
			cardPinNotAssigned: 'Chybně zadaný PIN',
			childCardPinNotAssigned: 'Chybně zadaný PIN (dítě)',
			cardWrongPin: 'Chybně zadaný PIN',
			childCardWrongPin: 'Chybně zadaný PIN (dítě)',
			cardWrongCVV2: 'Chybně zadaný CVV kód karty',
			cardWrongExpiryDate: 'Chybně zadané datum platnosti karty',
			cardFraudInvestigation: 'Platba nerealizována z důvodu nečekané chyby',
			outgoingPaymentForeign: 'Odchozí zahraniční platba',
			incomingPaymentForeign: 'Příchozí zahraniční platba',
			rejectedPayment: 'Platba zamítnuta pro podezření na podvod',
			paymentApprove3rdpartyToConfirm: 'Platba ke schválení',
			newStandingOrder3rdpartyToConfirm: 'Trvalý příkaz ke schválení',
			nonrealizedFirstGeneral:
				'Platba nerealizována z důvodu nedostatečného zůstatku na účtu',
			nonrealizedFirstTmpStandingOrder:
				'Trvalý příkaz nerealizován z důvodu nedostatečného zůstatku na účtu',
			odooTransactionCreated: 'Cizoměnová (odoo) transakce ke schválení',
			click2PayOn: 'Click2Pay na kartě zapnuto',
			click2PayOff: 'Click2Pay na kartě vypnuto',
			superSavingsToConfirm: 'Zapnutí chytré rezervy ke schválení',
			superSavingsCreated: 'Chytrá rezerva vytvořena',
			superSavingsRejected: 'Chytrá rezerva zamítnuta',
			superSavingsChangeToConfirm: 'Změna chytré rezervy ke schválení',
			superSavingsChanged: 'Chytrá rezerva změněna',
			superSavingsNotChanged: 'Změna chytré rezervy zamítnuta',
			superSavingsToCancel: 'Zrušení chytré rezervy ke schválení',
			superSavingsCanceled: 'Chytrá rezerva zrušena',
			superSavingsNotCanceled: 'Zrušení chytré rezervy zamítnuto',
			teenSuperSavingsToConfirm: 'Chytrá rezerva ke schválení (dítě)',
			teenSuperSavingsCreated: 'Chytrá rezerva vytvořena (dítě)',
			teenSuperSavingsRejected: 'Chytrá rezerva zamítnuta (dítě)',
			teenSuperSavingsChangeToConfirm:
				'Změna chytré rezervy ke schválení (dítě)',
			teenSuperSavingsApproved: 'Změna chytré rezervy schválena (dítě)',
			teenSuperSavingsNotApproved: 'Změna chytré rezervy zamítnuta (dítě)',
			teenSuperSavingsToCancel: 'Zrušení chytré rezervy ke schválení (dítě)',
			teenSuperSavingsCanceled: 'Chytrá rezerva zrušena (dítě)',
			teenSuperSavingsNotCanceled: 'Zrušení chytré rezervy zamítnuto (dítě)',
			childSuperSavingsCreated: 'Chytrá rezerva vytvořena (dítě)',
			childSuperSavingsChanged: 'Chytrá rezerva změněna (dítě)',
			childSuperSavingsCanceled: 'Chytrá rezerva zrušena (dítě)',
			standingOrder3rdpartyToChanged: 'Změna trvalého příkazu ke schválení',
			standingOrder3rdpartyToCancelled: 'Zrušení trvalého příkazu ke schválení',
			childIncomingPaymentSEPAConversion: 'Příchozí SEPA platba (dítě)',
			pidActivationOtp: 'Jednorázový kód pro aktivaci mobilní aplikace',
			incomingPaymentConversion: 'Příchozí platba s konverzí',
			incomingPaymentSEPAConversion: 'Příchozí SEPA platba s konverzí',
			incomingPaymentForeignAgg: 'Příchozí zahraniční platba',
			incomingPaymentForeignConversionAgg:
				'Příchozí zahraniční platba s konverzí',
			incomingPaymentInterestBasicAgg:
				'Připsány úroky (individuální spořicí účty)',
			incomingPaymentInterestSharedAgg: 'Připsány úroky (sdílené spořicí účty)',
			incomingPaymentInterestChildAgg: 'Připsány úroky (dětské spořicí účty)',
			outgoingPaymentSEPAConversion: 'Odchozí SEPA platba s konverzí',
			outgoingPaymentForeignAgg: 'Odchozí zahraniční platba',
			outgoingPaymentForeignConversionAgg:
				'Odchozí zahraniční platba s konverzí',
			outgoingPaymentStandingOrder: 'Trvalý příkaz realizován',
			outgoingPaymentStandingOrderAgg: 'Trvalé příkazy realizovány',
			outgoingPaymentAgg: 'Plánované platby realizovány',
			outgoingPaymentDirectDebit: 'Inkaso realizováno',
			outgoingPaymentSIPO: 'SIPO platba realizována',
			outgoingIncomingPayment: 'Převod mezi vlastními účty realizován',
			outgoingIncomingPaymentConversion:
				'Převod mezi vlastními účty s konverzí realizován',
			outgoingPaymentSweep: 'Dorovnání minimálního zůstatku',
			outgoingPaymentConversion: 'Odchozí platba s konverzí',
			nonrealizedFirstStandingOrder: 'Trvalý příkaz nerealizován',
			nonrealizedFirstStandingOrderAgg: 'Trvalé příkazy nerealizovány',
			nonrealizedFirstDirectDebit: 'Inkaso nerealizováno',
			nonrealizedFirstSIPO: 'SIPO nerealizováno',
			nonrealizedFirstFuture: 'Platba nerealizována',
			nonrealizedFirstFutureAgg: 'Platby nerealizovány',
			nonrealizedExpiredStandingOrder:
				'Trvalý příkaz nerealizován z důvodu nedostatečného zůstatku',
			nonrealizedExpiredStandingOrderAgg:
				'Trvalé příkazy nerealizovány z důvodu nedostatečného zůstatku',
			nonrealizedExpiredDirectDebit:
				'Inkaso nerealizováno z důvodu nedostatečného zůstatku',
			nonrealizedExpiredSIPO:
				'SIPO nerealizováno z důvodu nedostatečného zůstatku',
			nonrealizedExpiredFuture:
				'Platba nerealizována z důvodu nedostatečného zůstatku',
			nonrealizedExpiredFutureAgg:
				'Platby nerealizovány z důvodu nedostatečného zůstatku',
			nonrealizedFraud: 'Platba nerealizována pro podezření na podvod',
			nonrealizedLowLimitDirectDebit:
				'Inkaso zamítnuto z důvodu nedostatečného limitu',
			nonrealizedLowLimitSIPO: 'SIPO zamítnuto z důvodu nedostatečného limitu',
			nonrealizedSweep:
				'Doplnění účtu neproběhlo z důvodu nedostatečného zůstatku',
			nonrealizedFirstInstalment:
				'Splátka nerealizována z důvodu nedostatečného zůstatku',
			productPackageFee: 'Poplatek za balíček',
			childIncomingPaymentGeneral: 'Příchozí platba (dítě)',
			childOutgoingPaymentGeneral: 'Odchozí platba (dítě)',
			childIncomingPaymentInterestChildAgg: 'Úroky ze spoření připsány (dítě)',
			childOutgoingPaymentStandingOrder: 'Trvalý příkaz realizován (dítě)',
			childOutgoingPaymentStandingOrderAgg: 'Trvalé příkazy realizovány (dítě)',
			childOutgoingPaymentAgg: 'Plánované platby realizovány (dítě)',
			childOutgoingPaymentDirectDebit: 'Inkaso realizováno (dítě)',
			childOutgoingIncomingPayment:
				'Převod mezi vlastními účty realizován (dítě)',
			childOutgoingIncomingPaymentConversion:
				'Převod mezi vlastními účty s konverzí realizován (dítě)',
			childOutgoingPaymentConversion:
				'Odchozí platba s konverzí realizována (dítě)',
			childNonrealizedFirstStandingOrder: 'Trvalý příkaz nerealizován (dítě)',
			childNonrealizedFirstStandingOrderAgg:
				'Trvalé příkazy nerealizovány (dítě)',
			childNonrealizedFirstDirectDebit: 'Inkaso nerealizováno (dítě)',
			childNonrealizedFirstFuture: 'Platba nerealizována (dítě)',
			childNonrealizedFirstFutureAgg: 'Platby nerealizovány (dítě)',
			childNonrealizedExpiredStandingOrder:
				'Trvalý příkaz nerealizován z důvodu nedostatečného zůstatku (dítě)',
			childNonrealizedExpiredStandingOrderAgg:
				'Trvalé příkazy nerealizovány z důvodu nedostatečného zůstatku (dítě)',
			childNonrealizedExpiredDirectDebit:
				'Inkaso nerealizováno z důvodu nedostatečného zůstatku (dítě)',
			childNonrealizedExpiredFuture:
				'Platba nerealizována z důvodu nedostatečného zůstatku (dítě)',
			childNonrealizedExpiredFutureAgg:
				'Platby nerealizovány z důvodu nedostatečného zůstatku (dítě)',
			childNonrealizedFraud:
				'Platba nerealizována pro podezření na podvod (dítě)',
			childNonrealizedLowLimitDirectDebit:
				'Inkaso nerealizováno z důvodu nedostatečného limitu (dítě)',
			disposableCardRenewed: 'Jednorázová karta vytvořena',
			childDisposableCardRenewed: 'Jednorázová karta vytvořena (dítě)',
			outgoingIncomingBalanceRealignment:
				'Automatický převod pro vyrovnání zůstatku',
		},
		table: {
			header: {
				event: 'Událost',
				client: 'Klient',
				user: 'Uživatel',
				date: 'Datum',
			},
			detail: {
				clientDataShown: {
					viewReason: 'Důvod náhledu',
					specifyingReason: 'Upřesnění důvodu',
				},
				clientDataShowFailed: {
					error: 'Chyba',
				},
				additionalData: {
					title: 'Dodatečné údaje',
					applicationTitle: 'Aplikace',
					application: {
						backoffice: 'BOA',
						mobileApplication: 'Mobilní aplikace',
						unknown: 'Neznámá',
					},
					eventCategoryTitle: 'Kategorie',
					eventCategory: {
						bankCards: 'Karty',
						bankDocuments: 'Dokumenty',
						bankTransactions: 'Transakce',
						client: 'Klient a identita',
						communication: 'Komunikace',
						internalApplication: 'BOA interní',
						mobileApplication: 'Mobilní aplikace',
						unknown: 'Neznámé',
					},
					processIdTitle: 'ID procesu',
					clientPidTitle: 'PID klienta',
					userPidTitle: 'PID uživatele',
					userIdTitle: 'UserId uživatele',
				},
			},
		},
	},
	clickToPayPage: {
		title: 'Click To Pay',
		noCards: 'Žádné karty s Click To Pay',
		infoText: 'Počet nalezených karet: {cardsAmount:number}',
		visaStatus: {
			activating: 'Probíhá aktivace',
			active: 'Aktivní',
			disabling: 'Probíhá vypínání',
			disabled: 'Vypnutá',
		},
		table: {
			header: {
				visaStatus: 'Stav Click To Pay',
			},
			detail: {
				bankCardUuid: 'ID karty',
				status: 'Stav karty',
				showCardDetail: 'Zobrazit detail karty',
			},
		},
		filter: {
			bankCardUuid: 'ID karty',
			visaStatus: 'Stav Click To Pay',
			status: 'Stav karty',
		},
	},
	infoPage: {
		clientVersion: 'Verze aplikace: {version: string}',
		infoGroup: 'Aplikační skupina: {group: string}',
		infoName: 'Jméno aplikace: {name: string}',
	},

	accessDeniedPage: {
		companyName: 'Partners',
		productName: 'Back Office',
		title: 'Přístup nepovolen',
		message:
			'Účet pod kterým jste přihlášení ve FIPu nemá povolen přístup do Dashboardu.',
		possibleReasonsLink: 'Možné důvody?',
		reasonsDialog: {
			title: 'Možné důvody zamítnutí přístupu',
			legalPersonReason: 'Jste přihlašeni pod účtem právnické osoby',
			legalPersonDescription:
				'Přihlášení pod účtem poboček, VIPCO nebo jiné právnické osoby není povoleno. Přihlašte se pod svým osobním účtem.',
			blockedAccessReason: 'Máte zablokovaný přístup',
			blockedAccessDescription:
				'Váš osobní účet má z nějakého důvodu zablokovaný přístup do Dashboardu. Pro ověření kontaktujte podporu.',
			historicalAccessNote:
				'Pokud jste historicky již v Dashboardu pracovali a nyní vám přístup z neznámého důvodu nefunguje, obraťte se na podporu.',
			close: 'Zavřít',
		},
	},
	profilePage: {
		noProfileData: 'Žádná data o uživateli',
		noRoles: 'Žádná role nepřidělena',
		roles: 'Role',
		sections: {
			basicInfo: 'Základní údaje',
			roles: 'Přidělené role',
		},
		title: 'Profil',
		userEmail: 'Email',
		userName: 'Jméno',
		userPidUuid: 'PID',
	},
} satisfies BaseTranslation;

export default cs;
